import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import DateCell from '../components/common/cells/DateCell';
import ReportStatusCell from '../components/common/cells/ReportStatusCell';
import IsActive from '../components/common/cells/IsActive';
import BankReconciliationDiffCell from '../components/common/cells/bank-reconciliation/BankReconciliationDiffCell';
import BankReconciliationCountAmountCell from '../components/common/cells/bank-reconciliation/BankReconciliationCountAmountCell';
import BankReconciliationSurplusCell from '../components/common/cells/bank-reconciliation/BankReconciliationSurplusCell';
import BankReconciliationCashDifferenceCell from '../components/common/cells/bank-reconciliation/BankReconciliationCashDifferenceCell';
import SapMigrationRetryButton from '../components/common/cells/bank-reconciliation/SapMigrationRetryButton';
import ManualVoucherPaymentSapRetryButton from '../components/common/cells/bank-reconciliation/ManualVoucherPaymentSapRetryButton';

import {
  POSTPAID_BOOKING_REJECTED,
  EXTRAORDINARY_MOVEMENT_CONTROL_STATUS,
  FUEL_VOUCHER_STATUS,
  FUEL_VOUCHER_EXTRAORDINARY_OPTIONS,
  USER_ENABLED_OPTIONS,
  ITINERARY_SCHEDULE_MACIVA_OPTIONS,
  COMPANY_TYPE,
  IN_SYSTEM_NOTIFICATION_SEVERITY,
  EXPENSE_STATUS,
  ITINERARY_GROUP_STATUS,
  KILOGRAM_SYMBOL,
  GENDERS,
  KILOMETER_SYMBOL,
  MINUTE_SYMBOL,
  ITINERARY_TYPE,
  CONTRACT_STATUS,
  CREDIT_NOTE_STATUS_OPTIONS,
  PURCHASE_ORDER_STATUS,
  MANUAL_VOUCHER_SERVICE_TYPE,
  MANUAL_VOUCHER_PAYMENT_TYPE,
  MAINTENANCE_FACTOR_TYPE,
  ACTIVITY_STATUS,
  MATERIAL_MEASUREMENT_UNIT,
  TICKET_STATUS,
  EXPENSE_TYPE_LABEL,
  CONTRACT_TYPE,
  MAINTENANCE_WARNING_TYPE,
  MAINTENANCE_WARNING_PRIORITY,
  MAINTENANCE_WARNING_STATUS,
  MAINTENANCE_SERVICE_ORDER_PRIORITY,
  MAINTENANCE_SERVICE_ORDER_STATUS,
  MAINTENANCE_ACTIVITY_TYPE,
  ACTIVITY_ACTION,
  PEN_SYMBOL,
  TICKET_BOARDED_STATUS,
  CARGO_ITEM_PERISHABLE_OPTIONS,
  PARCEL_PAYMENT_STATUS,
  PAYMENT_STATUS,
  COMPANY_STAFF_TYPE,
  TRIP_REQUEST_STATUS,
  COMPANY_BUS_SEAT_COUNT,
  PARCEL_PRICE_STATUS,
  MAINTENANCE_WARNING_STATUS_ACTIVITY,
  DRIVER_STATUS_OPTION,
  PARCEL_FINANCIAL_STATUS,
  MAINTENANCE_PLANNING_STATUS,
  GENERAL_STATUS,
  ACTIVE_OPTIONS,
  DELIVERY_STATUS,
  CARGO_ITEM_STATUS,
  CARGO_CUSTOMER_TYPE,
  COMMON_PRODUCT_PRICE_SCHEDULE_STATUS,
  SUITABLE_STATUS,
  BUS_MAINTENANCE_STATUS_TYPE,
  GEOFENCE_ALERT_TYPE,
  TICKET_BOARDED_STATUS_CODE,
  LEGAL_SOURCE_SYSTEM,
  DISCOUNT_CODE_FLOOR_RULE,
  STATUS_TRANSLATIONS,
  CURRENCY_TYPE,
  ITINERARY_ACTIVE_OPTIONS,
  AGENCY_ACTIVE_OPTIONS,
  SENDER_REMISSION_GUIDE_EXIT_REASON,
  SENDER_REMISSION_GUIDE_ITEM_PICKUP_STATUS,
  MONTH_OPTIONS,
  ITINERARY_DIRECTION,
  SENDER_REMISSION_GUIDE_CLOSURE_STATUS,
  COMMERCIAL_STATUS_OPTIONS,
  MAINTENANCE_STAY_STATUS_OPTIONS,
  COMMERCIAL_STATUS,
  TICKET_REASSINGMENT_ACCEPT_MERGE,
  TICKET_REASSINGMENT_NEGOTIATION,
  TICKET_REASSINGMENT_RETURN_TYPE,
  RELATIONSHIP_TO_MINOR,
  INCIDENT_RECORD_TYPE,
  BILLING_PROCESS_STATUS,
  BILLING_VOUCHER_TYPE,
  PAYMENT_TYPE,
  BILL_PROCESS_ORIGIN,
  BILLING_REPORT_DETAIL_STATUS,
  BILLING_PROCESS_TYPE,
  BILLING_DOCUMENT_TYPE,
  TICKET_BOARDING_STATUS,
  NEW_BAGGAGE_ITEM_STATUS,
  BAGGAGE_STATUS,
  SUPPLIER_TYPE,
  FOOD_PUBLIC_TYPE,
  REJECTED_EXPENSE_OPTIONS,
  EXCESS_BAGGAGE_ACCOUNTING_STATUS,
  ITINERARY_CHANGE_ROUTE_STATUS,
  ITINERARY_COUNTER_REPORT_STATUS,
  PREVENTIVE_TASK_REPEAT_TYPE,
  PREVENTIVE_TASK_ASSIGNEE_SCOPE,
  PREVENTIVE_TASK_EXECUTION_STATUS,
  RESOURCE_EXECUTION_MODE,
  EXPENSE_AUTHORIZER_USER_TYPE,
  ROUTE_ACTIVE_OPTIONS,
  CIRCUIT_ACTIVE_OPTIONS,
  ENDPOINT_PERMISSION_TYPE,
  GENERAL_INCOME_TYPE_LABEL,
  TRANSACTION_TYPE,
  END_DATE_SOURCE,
  STATUS_EVENT_TYPE,
  MECHANIC_EMPLOYEE_TYPE,
  SUPPLIER_ASSIGNED_SERVICE_STATUS,
  MIGRATION_STATUS,
  BANK_RECONCILIATION_STATUS,
  BANK_RECONCILIATION_DEPOSIT_RESULT,
  BANK_RECONCILIATION_HOLDER_TYPE,
  DEPOSIT_MIGRATION_STATUS,
  DEPOSIT_BANK_TRANSFER_STATUS,
  SAP_MIGRATION_DOCUMENT_TYPE,
  DEPOSIT_MIGRATION_FILE_STATUS,
  DEPOSIT_MIGRATION_MOVEMENT_CLASSIFICATION,
  BILLING_PROCESS_REPORT_STATUS,
  BOARDED_AT_OTHER_LOCATION_OPTIONS,
  CREDIT_NOTE_MOTIVES,
} from './constants';
import * as ColumnFilterDataTypes from './columnFilterDataTypes';
import AgencyFilter from '../components/common/filters/AgencyFilter';
import PostpaidBookingStatusCell from '../components/common/cells/postpaid-booking/PostpaidBookingStatusCell';
import PostpaidBookingStatusFilter from '../components/common/filters/PostpaidBookingStatusFilter';
import PostpaidBookingActionsCell from '../components/common/cells/postpaid-booking/PostpaidBookingActionsCell';
import RowExpander from '../components/common/cells/postpaid-booking/RowExpander';
import TicketPaymentMethodCell from '../components/common/cells/sales-session/TicketPaymentMethodCell';
import TicketStatusFilter from '../components/common/filters/TicketStatusFilter';
import TicketReportAgenciesCell from '../components/common/cells/ticket-report/TicketReportAgenciesCell';
import ExpenseTypeFilter from '../components/common/filters/ExpenseTypeFilter';
import CircuitFilter from '../components/common/filters/CircuitFilter';
import EnumStatus from '../components/common/EnumStatus';
import EnumSelectFilter from '../components/common/filters/EnumSelectFilter';
import SelectFilter from '../components/common/filters/SelectFilter';
import VoucherTypeFilter from '../components/common/filters/VoucherTypeFilter';
import PaymentMethodFilter from '../components/common/filters/PaymentMethodFilter';
import CityFilter from '../components/common/filters/CityFilter';
import Checkbox from '../components/common/forms/Checkbox';
import TicketActiveFilter from '../components/common/filters/TicketActiveFilter';
import { DATE_FORMAT, DATE_TIME_FORMAT, TIME_FORMAT } from './locale';
import SeatMapSelect from '../components/common/forms/select/SeatMapSelect';
import RouteSelect from '../components/common/forms/select/RouteSelect';
import { enumToSelectOptions } from '../utils/enum';
import {
  elapsedTimeFormat,
  getDayFromTimestamp,
  timeFormat,
  tzDiff,
  tzNormalizeDate,
} from '../utils/date';
import {
  BUS_MAINTENANCE_STAY_PATH,
  DEPOSIT_PATH,
  EXPENSE_PATH,
  ITEM_PATH,
  ITINERARY_FOR_COUNTER_PATH,
  ITINERARY_PATH,
  LIQUIDATION_SESSION_PATH,
  MAINTENANCE_SERVICE_ORDER_PATH,
  MANUAL_VOUCHER_PATH,
  MANUAL_VOUCHER_PAYMENT_PATH,
  PREVENTIVE_TASK_EXECUTION_PATH,
  SALES_SESSION_PATH,
  TICKET_PATH,
} from './paths';
import CustomerFilter from '../components/common/filters/CustomerFilter';
import RegisteredBusFilter from '../components/common/filters/RegisteredBusFilter';
import { numberFormatter } from '../utils/number';
import { padStart } from '../utils/string';
import HierarchyFilter from '../components/common/filters/HierarchyFilter';
import ActionsCell from '../components/common/cells/ActionsCell';
import Badge from '../components/common/Badge';
import BadgeList from '../components/common/BadgeList';
import OrganizationChartSelect from '../components/common/forms/select/OrganizationChartSelect';
import LinkToModuleResource from '../components/common/resource/LinkToModuleResource';
import ExpenseTypeLabelSelect from '../components/common/forms/select/ExpenseTypeLabelSelect';
import AgencyContractTypeSelect from '../components/common/forms/select/AgencyContractTypeSelect';
import CargoItemMovementStatusCell from '../components/common/cells/cargo/cargo-item/CargoItemMovementStatusCell';
import CargoItemStatusCell from '../components/common/cells/cargo/cargo-item/CargoItemStatusCell';
import ParcelPaymentStatusCell from '../components/common/cells/cargo/cargo/ParcelPaymentStatusCell';
import CargoItemStatusFilter from '../components/common/filters/CargoItemStatusFilter';
import CommonProductFilter from '../components/common/filters/CommonProductFilter';
import CargoCategoryFilter from '../components/common/filters/CargoCategoryFilter';
import BusinessFilter from '../components/common/filters/BusinessFilter';
import DriverStatusCell from '../components/units/traffic/driver/DriverStatusCell';
import LocationFilter from '../components/common/filters/LocationFilter';
import ManualVoucherActionsCell from '../components/common/cells/manual-voucher/ManualVoucherActionsCell';
import DriverFilter from '../components/common/filters/DriverFilter';
import DriverMovementFilter from '../components/common/filters/DriverMovementFilter';
import UserFilter from '../components/common/filters/UserFilter';
import CargoCorporateCreditFilter from '../components/common/filters/CargoCorporateCreditFilter';
import VoidTicketButton from '../components/units/reservation/ticket/ticket-toolbar/VoidTicketButton';
import EditBusMaintenanceStayButton from '../components/units/mechanical-maintenance/bus-maintenance-stay/EditBusMaintenanceStayButton';
import BusMaintenanceStayDeleteButton from '../components/units/mechanical-maintenance/bus-maintenance-stay/BusMaintenanceStayDeleteButton';
import ServiceTypeFilter from '../components/common/filters/ServiceTypeFilter';
import MaintenanceBusFleetHistoryButton from '../components/units/mechanical-maintenance/maintenance-bus-fleet/MaintenanceBusFleetHistoryButton';
import BusMaintenanceStayClearButton from '../components/units/mechanical-maintenance/bus-maintenance-stay/BusMaintenanceStayClearButton';
import EditMaintenanceBusFleetButton from '../components/units/mechanical-maintenance/maintenance-bus-fleet/EditMaintenanceBusFleetButton';
import MaintenanceBusFleetClearButton from '../components/units/mechanical-maintenance/maintenance-bus-fleet/MaintenanceBusFleetClearButton';
import BusRetentionScheduleActionsCell from '../components/units/bus/registered-bus-fleet/BusRetentionScheduleActionsCell';
import BillingPdfButton from '../components/units/accounting/billing/BillingPdfButton';
import BillingCdrButton from '../components/units/accounting/billing/BillingCdrButton';
import BillingXmlButton from '../components/units/accounting/billing/BillingXmlButton';
import BillingViewButton from '../components/units/accounting/billing/BillingViewButton';
import TollLiquidationDifferenceReasonFilter from '../components/common/filters/TollLiquidationDifferenceReasonFilter';
import TicketFilter from '../components/common/filters/TicketFilter';
import ExcessBaggageFilter from '../components/common/filters/ExcessBaggageFilter';
import ItemCategoryFilter from '../components/common/filters/ItemCategoryFilter';
import SupplierFilter from '../components/common/filters/SupplierFilter';
import CabinCrewFilter from '../components/common/filters/CabinCrewFilter';
import ItinerarySupplierFoodReportDetailButton from '../components/units/food/itinerary-supplier-food-report/ItinerarySupplierFoodReportDetailButton';
import ShelfFilter from '../components/common/filters/ShelfFilter';
import EditExpenseSapMigrationButton from '../components/units/accounting/expense-sap-migration/EditExpenseSapMigrationButton';
import ViewExpenseSapMigrationButton from '../components/units/accounting/expense-sap-migration/ViewExpenseSapMigrationButton';
import ManualVoucherPaymentActionsCell from '../components/units/corporate/manual-voucher-payment/ManualVoucherPaymentActionsCell';
import { filterMethodCaseInsensitive, filterMethodExactValue } from '../utils/filter-methods';

export const REPORT_COLUMNS = [
  {
    Header: 'Fecha de Inicio',
    accessor: 'fromDate',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'toDate',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'created',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Última Actualización',
    accessor: 'lastUpdate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Estado',
    accessor: 'reportStatus',
    Cell: (row) => <ReportStatusCell value={row.value} />,
  },
];

export const TICKET_REPORT_COLUMNS = [
  {
    Header: 'Fecha de Inicio',
    accessor: 'fromDate',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'toDate',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Agencias',
    accessor: 'agencySet',
    Cell: (row) => <TicketReportAgenciesCell agencies={row.value} />,
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'created',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Última Actualización',
    accessor: 'lastUpdate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Estado',
    accessor: 'reportStatus',
    Cell: (row) => <ReportStatusCell value={row.value} />,
  },
];

export const LOCATION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Dirección',
    accessor: 'address.address',
    className: 'text-center',
  },
  {
    Header: 'Distrito',
    accessor: 'address.district',
    className: 'text-center',
  },
  {
    Header: 'Ciudad',
    accessor: 'address.city.name',
    className: 'text-center',
  },
  {
    Header: 'ID de Correlación Civa',
    accessor: 'locationCorrelationId',
    className: 'text-center',
  },
];

export const ITINERARIES_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    Cell: (row) => {
      let badgeForItineraryWithoutExpectedConsumption = '';
      if (+row.original.expectedFuelConsumption === 0)
        badgeForItineraryWithoutExpectedConsumption = (
          <Badge color="danger" text="1" />
        );

      let badgeForItineraryWithoutExtraordinaryRealValue = '';
      if (+row.original.hasNotExtraordinaryRealValue)
        badgeForItineraryWithoutExtraordinaryRealValue = (
          <Badge color="warning" text="2" />
        );

      return (
        <div>
          {row.value} {badgeForItineraryWithoutExpectedConsumption}{' '}
          {badgeForItineraryWithoutExtraordinaryRealValue}
        </div>
      );
    },
    width: 100,
  },
  {
    Header: 'Ruta',
    accessor: 'route.name',
    className: 'text-center',
    minWidth: 300,
    maxWidth: 450,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType.name',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Activo',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <TicketActiveFilter
        onChangeFilter={row.onChange}
        options={ITINERARY_ACTIVE_OPTIONS}
      />
    ),
  },
  {
    Header: 'Programado',
    accessor: 'trip',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Fecha',
    accessor: 'departureTime',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Hora',
    accessor: 'departureTime',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Tipo',
    accessor: 'type',
    Cell: (row) => ITINERARY_TYPE[row.value.toLowerCase()].label,
    className: 'text-center',
  },
];

export const TICKETS_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    Cell: (row) => padStart(row.value, '7'),
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Fecha de Emisión',
    accessor: 'documentAssignmentDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 160,
  },
  {
    Header: 'Nro. documento',
    accessor: 'customer.idDocumentNumber',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Nombres',
    accessor: 'customer.firstName',
    className: 'text-center',
    width: 200,
    filterMethod: (filter, row) => {
      const value = row[filter.id];
      if (!value) return false;

      return value
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: 'Apellidos',
    accessor: 'customer.lastName',
    className: 'text-center',
    width: 200,
    filterMethod: (filter, row) => {
      const value = row[filter.id];
      if (!value) return false;

      return value
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocation.name',
    className: 'text-center',
    width: 200,
    filterMethod: (filter, row) => {
      const value = row[filter.id];
      if (!value) return false;

      return value
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocation.name',
    className: 'text-center',
    width: 200,
    filterMethod: (filter, row) => {
      const value = row[filter.id];
      if (!value) return false;

      return value
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: 'Fecha de Viaje',
    accessor: 'departureDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 160,
  },
  {
    Header: 'Precio',
    accessor: 'salePrice',
    Cell: (row) =>
      numberFormatter({
        style: 'currency',
        value: row.value,
      }),
    className: 'text-right',
    width: 150,
  },
  {
    Header: 'Estado',
    accessor: 'ticketStatus',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={TICKET_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => <TicketStatusFilter onChangeFilter={row.onChange} />,
    width: 200,
    filterable: false,
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const COUNTRIES_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'País',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Código',
    accessor: 'countryCode',
    className: 'text-center',
  },
];

export const ADDRESS_COLUMNS = [
  {
    Header: 'Dirección 1',
    accessor: 'address',
    className: 'text-center',
  },
  {
    Header: 'Dirección 2',
    accessor: 'address2',
    className: 'text-center',
  },
  {
    Header: 'Distrito',
    accessor: 'district',
    className: 'text-center',
  },
  {
    Header: 'Ciudad',
    accessor: 'city.name',
    className: 'text-center',
  },
  {
    Header: 'Código Postal',
    accessor: 'postalCode',
    className: 'text-center',
  },
  {
    Header: 'Teléfono',
    accessor: 'phone',
    className: 'text-center',
  },
];

export const SALES_SESSIONS_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Nombre Usuario',
    accessor: 'user.customer.firstName',
    className: 'text-center',
    width: 300,
  },
  {
    Header: 'Apellido Usuario',
    accessor: 'user.customer.lastName',
    className: 'text-center',
    width: 300,
  },
  {
    Header: 'Agencia',
    accessor: 'agency.name',
    className: 'text-center',
    filterable: true,
    Filter: (row) => (
      <AgencyFilter onChangeFilter={row.onChange} visibilityRestricted />
    ),
    id: 'agencyId',
    dataType: ColumnFilterDataTypes.ARRAY,
    width: 400,
  },
  {
    Header: 'Caja',
    accessor: 'workstation.name',
    className: 'text-center',
  },
  {
    Header: 'Inicio',
    accessor: 'sessionStart',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Fin',
    accessor: 'sessionEnd',
    dataType: ColumnFilterDataTypes.DATE,
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    className: 'text-center',
  },
];

export const DEPOSITS_COLUMNS = [
  {
    Header: 'Operador',
    accessor: 'operatorUser.customerId',
    className: 'text-center',
    Filter: (row) => (
      <CustomerFilter onChangeFilter={row.onChange} isClearable />
    ),
    Cell: (row) =>
      `${row.original.operatorUser.customer.fullName} - DNI: ${row.original.operatorUser.customer.idDocumentNumber}`,
  },
  {
    Header: 'Agencia',
    accessor: 'dailyLiquidationSessionSet',
    Cell: (row) => {
      if (!row.value) return null;
      const agencyList = row.value.map(({ agency }) => ({ text: agency.name }));
      return <BadgeList cell textArray={agencyList} />;
    },
    filterable: true,
    Filter: (row) => (
      <AgencyFilter onChangeFilter={row.onChange} visibilityRestricted />
    ),
    id: 'dailyLiquidationSession.agency.id',
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
  },
  {
    Header: 'Fecha de Liquidación',
    accessor: 'dailyLiquidationSessionSet',
    Cell: (row) => {
      if (!row.value) return null;
      const dailyLiquidationDateList = row.value.map(
        ({ dailyLiquidationDate }) => ({
          text: tzNormalizeDate({
            date: dailyLiquidationDate,
            format: DATE_FORMAT,
          }),
        }),
      );
      return <BadgeList cell textArray={dailyLiquidationDateList} />;
    },
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Fecha de Depósito',
    accessor: 'depositDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Número de Operación',
    accessor: 'operationNumber',
    className: 'text-center',
  },
  {
    Header: 'Monto de Liquidación',
    accessor: 'expectedAmountToDeposit',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Monto Depositado',
    accessor: 'actualAmountDeposited',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Diferencia',
    accessor: 'depositDifferenceAmount',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Aprobado',
    accessor: 'settled',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Notas',
    accessor: 'depositNoteList',
    Cell: (row) => row.value.length,
    className: 'text-center',
    filterable: false,
  },
];

export const EXPENSE_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 130,
  },
  {
    Header: 'Agencia',
    accessor: 'transactionList',
    id: 'transaction.salesSession.agencyId',
    Cell: (row) =>
      row.value[0].salesSession ? row.value[0].salesSession.agency.name : null,
    Filter: (row) => (
      <AgencyFilter onChangeFilter={row.onChange} visibilityRestricted />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Estado',
    accessor: 'expenseStatus',
    Cell: (row) => (row.value ? EXPENSE_STATUS[row.value].label : '-'),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={EXPENSE_STATUS}
      />
    ),
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Centro de Costo',
    accessor: 'costCenter.name',
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Nombre Counter',
    accessor: 'transactionList',
    id: 'transaction.user.customer.firstName',
    Cell: (row) =>
      row.value[0].user.customer ? row.value[0].user.customer.firstName : null,
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Apellido Counter',
    accessor: 'transactionList',
    id: 'transaction.user.customer.lastName',
    Cell: (row) =>
      row.value[0].user.customer ? row.value[0].user.customer.lastName : null,
    className: 'text-center',
    width: 300,
  },
  {
    Header: 'Tipo de comprobante',
    accessor: 'transactionList',
    id: 'transaction.voucherType.name',
    Cell: (row) => {
      if (!row.value) return null;
      const voucherTypeList = [];
      row.value.forEach(({ voucherType }) => {
        if (voucherType) voucherTypeList.push({ text: voucherType.name });
      });
      return <BadgeList cell textArray={voucherTypeList} />;
    },
    className: 'text-center',
    width: 300,
  },
  {
    Header: 'RUC',
    accessor: 'transactionList',
    id: 'transaction.business.businessTaxId',
    Cell: (row) =>
      row.value[0].business ? row.value[0].business.businessTaxId : null,
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Razón Social',
    accessor: 'transactionList',
    id: 'transaction.business.name',
    Cell: (row) => (row.value[0].business ? row.value[0].business.name : null),
    className: 'text-center',
    width: 350,
  },
  {
    Header: 'Tipo de egreso',
    accessor: 'transactionList',
    id: 'transaction.expenseTypeId',
    Cell: (row) => {
      if (!row.value) return null;
      const expenseTypeList = row.value.map(({ expenseType }) => ({
        text: expenseType.name,
      }));
      return <BadgeList cell textArray={expenseTypeList} />;
    },
    Filter: (row) => <ExpenseTypeFilter onChangeFilter={row.onChange} />,
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    width: 350,
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
    width: 350,
  },
  {
    Header: 'Total',
    accessor: 'transaction.amount',
    Cell: (row) => row.value && numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const EXPENSE_ITEMS = [
  {
    Header: 'Tipo de egreso',
    accessor: 'expenseType.name',
    className: 'text-center',
  },
  {
    Header: 'Total',
    accessor: 'amount',
    Cell: (row) => row.value && numberFormatter({ value: row.value }),
    className: 'text-center',
  },
];

export const EXPENSE_UPDATE_HISTORY_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Usuario',
    accessor: 'createUser.customer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Motivo de Rechazo',
    accessor: 'rejectedMotive',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={REJECTED_EXPENSE_OPTIONS} enumValue={row.value} />
    ),
  },
  {
    Header: 'Descripción',
    accessor: 'comment',
    className: 'text-center',
    Cell: (row) => (
      <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
        {row.original.comment}
      </div>
    ),
  },
];

export const POSTPAID_BOOKINGS_COLUMNS = [
  {
    className: 'text-center',
    Expander: (expander) => (
      <RowExpander
        isExpanded={Boolean(expander.isExpanded)}
        status={expander.original.status}
      />
    ),
    getProps: (state, rowInfo) => {
      if (rowInfo) {
        // same test as above
        if (rowInfo.original.status === POSTPAID_BOOKING_REJECTED) {
          // hijack the onClick so it doesn't open
          return {
            onClick: () => {},
          };
        }
      }
      return {
        className: 'show-pointer',
      };
    },
    expander: true,
  },
  {
    Header: 'Reserva',
    accessor: 'customerOrder.reservation.id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Usuario',
    accessor: 'userSummary.fullName',
    className: 'text-center',
  },
  {
    Header: 'Método de pago',
    accessor: 'postpaidPreTransaction.paymentMethod.name',
    className: 'text-center',
    Cell: ({ value, original: { postpaidPreTransactionList } }) => {
      if (value) return value;
      return postpaidPreTransactionList && postpaidPreTransactionList.length
        ? postpaidPreTransactionList
            .map((transaction) => transaction.paymentMethod.name)
            .join(', ')
        : '';
    },
  },
  {
    Header: 'Código voucher',
    accessor: 'postpaidPreTransaction.voucherCode',
    Cell: ({ value, original: { postpaidPreTransactionList } }) => {
      if (value) return value;
      if (postpaidPreTransactionList && postpaidPreTransactionList.length) {
        const transaction = postpaidPreTransactionList.find(
          (t) => t.voucherCode,
        );
        return transaction ? transaction.voucherCode : '-';
      }
      return '-';
    },
    className: 'text-center',
  },
  {
    Header: 'Destinatario',
    accessor: 'customerFullName',
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    accessor: 'routeName',
    className: 'text-center',
  },
  {
    Header: 'Fecha de reserva',
    accessor: 'createDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Fecha de Expiración CIP/Link',
    accessor: 'pagoEfectivoExpirationDate',
    Cell: (row) => {
      if (row.value)
        return <DateCell format={DATE_TIME_FORMAT} value={row.value} />;
      else if (row.original.linkExpirationDate) {
        return (
          <DateCell
            format={DATE_TIME_FORMAT}
            value={row.original.linkExpirationDate}
          />
        );
      }
      return '-';
    },
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Fecha de viaje',
    accessor: 'departureDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Monto',
    accessor: 'customerOrder.reservation.ticketList',
    Cell: (row) => {
      let salePrice = 0;
      row.value.forEach((ticket) => {
        salePrice += ticket.salePrice;
      });
      return numberFormatter({ value: salePrice });
    },
    filterable: false,
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => <PostpaidBookingStatusCell value={row.value} />,
    Filter: (row) => (
      <PostpaidBookingStatusFilter onChangeFilter={row.onChange} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <PostpaidBookingActionsCell
        customerOrderId={row.original.customerOrder.id}
        transactionCode={
          row.original.postpaidPreTransaction
            ? row.original.postpaidPreTransaction.paymentMethod.transactionCode
            : row.original.postpaidPreTransactionList[
                row.original.postpaidPreTransactionList.length - 1
              ].paymentMethod.transactionCode
        }
        status={row.original.status}
      />
    ),
    width: 150,
    filterable: false,
  },
];

export const DISCOUNT_CODE_REPORT_COLUMNS = [
  {
    Header: 'Agencia',
    accessor: 'agency',
  },
  {
    Header: 'Counter',
    accessor: 'counter',
  },
  {
    Header: 'Código de Descuento',
    accessor: 'discountCode',
  },
  {
    Header: `Descuento`,
    accessor: 'discountedAmount',
    Cell: (row) => numberFormatter({ value: row.value }),
  },
  {
    Header: 'Descuento (%)',
    accessor: 'discountPercentage',
  },
  {
    Header: 'Boleto',
    accessor: 'ticketCode',
  },
  {
    Header: 'Fecha de Uso',
    accessor: 'useDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
];

export const CALL_CENTER_REPORT_COLUMNS = [
  {
    Header: 'Código de Referencia',
    accessor: 'referenceCode',
  },
  {
    Header: 'Vendedor',
    accessor: 'sellerName',
  },
  {
    Header: 'Agencia',
    accessor: 'agencyName',
  },
];

export const SALES_SESSION_TICKETS_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },

  {
    Header: 'Tipo de Comprobante',
    accessor: 'voucherType',
    className: 'text-center',
  },
  {
    Header: 'Precio de Venta',
    accessor: 'salePrice',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Método de Pago',
    accessor: 'paymentMethodList',
    Cell: (row) => <TicketPaymentMethodCell paymentMethodList={row.value} />,
    filterMethod: (filter, row) => {
      const result = row.paymentMethodList.some((paymentMethod) =>
        paymentMethod.moneyFlowConcept
          .toLowerCase()
          .includes(filter.value.toLowerCase()),
      );
      return result;
    },
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'ticketStatus',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={TICKET_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => <TicketStatusFilter onChangeFilter={row.onChange} />,
  },
];

export const SALES_SESSION_INCOME_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Beneficiario',
    accessor: 'payee',
    className: 'text-center',
  },
  {
    Header: 'Autorizado por',
    accessor: 'authorizer',
    className: 'text-center',
  },
];

export const SALES_SESSION_EXPENSE_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Egreso',
    accessor: 'expenseType',
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Beneficiario',
    accessor: 'payee',
    className: 'text-center',
  },
  {
    Header: 'Autorizado por',
    accessor: 'authorizer',
    className: 'text-center',
  },
];

export const SALES_SESSION_BAGGAGE_EXCESSES_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
    Cell: (row) => (row.value ? `${row.value.toFixed(2)} kg` : 0),
    className: 'text-center',
  },
  {
    Header: 'Precio Sin Descuento',
    accessor: 'priceBeforeDiscount',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Descuento',
    accessor: 'discountAmount',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Precio Final',
    accessor: 'price',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Método de Pago',
    accessor: 'paymentMethodSummaryList',
    Cell: (row) =>
      row.value.map(({ paymentMethodName, amount, transactionCode }) => (
        <div key={transactionCode}>
          {paymentMethodName}: {numberFormatter({ value: amount })}
        </div>
      )),
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'accountingStatus',
    Cell: (row) => (
      <EnumStatus
        enumObject={EXCESS_BAGGAGE_ACCOUNTING_STATUS}
        enumValue={row.value}
      />
    ),
    className: 'text-center',
    filterable: true,
    filterMethod: (filter, row) => {
      if (!filter.value || filter.value.length === 0) return true;
      const isVoided = !!row[filter.id];
      const values = Array.isArray(filter.value)
        ? filter.value
        : [filter.value];
      return values.some((v) => {
        if (v === BAGGAGE_STATUS.ACTIVE.value) return isVoided;
        if (v === BAGGAGE_STATUS.VOIDED.value) return !isVoided;
        return true;
      });
    },
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={BAGGAGE_STATUS}
      />
    ),
  },
];

export const SALES_SESSION_PARCELS_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Emisión',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'financialStatus',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PARCEL_FINANCIAL_STATUS}
      />
    ),
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_FINANCIAL_STATUS} enumValue={row.value} />
    ),
  },
  {
    Header: 'Precio de Venta',
    accessor: 'salePrice',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Método de Pago',
    accessor: 'paymentMethodList',
    Cell: (row) => <TicketPaymentMethodCell paymentMethodList={row.value} />,
    Filter: (row) => <PaymentMethodFilter onChangeFilter={row.onChange} />,
    dataType: ColumnFilterDataTypes.ARRAY,
    id: 'paymentMethodId',
    className: 'text-center',
  },
  {
    Header: 'Estado de Pago',
    accessor: 'paymentStatus',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PARCEL_PAYMENT_STATUS}
      />
    ),
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_PAYMENT_STATUS} enumValue={row.value} />
    ),
  },
];

export const SALES_SESSION_OTHER_INCOMES_PARCELS_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Comprobante',
    accessor: 'voucherTypeName',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Emisión',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Cliente',
    accessor: 'customerId',
    Filter: (row) => (
      <CustomerFilter isClearable onChangeFilter={row.onChange} />
    ),
    Cell: (row) =>
      row.value
        ? `${row.original.customerIdentificationTypeName} ${row.original.customerIdDocumentNumber} - ${row.original.customerFullName} (${row.original.customerIdOriginOfCountry})`
        : '-',
    className: 'text-center',
  },
  {
    Header: 'Empresa',
    accessor: 'businessId',
    Filter: (row) => (
      <BusinessFilter isClearable onChangeFilter={row.onChange} />
    ),
    Cell: (row) =>
      row.value
        ? `RUC ${row.original.businessTaxIdentificationNumber} - ${row.original.businessName}`
        : '-',
    className: 'text-center',
  },
  {
    Header: 'Precio de Venta',
    accessor: 'salePrice',
    Cell: (row) => numberFormatter({ value: row.value }),
    filterable: false,
    className: 'text-center',
  },
  {
    Header: 'Método de Pago',
    accessor: 'paymentMethodId',
    Cell: (row) => {
      const { paymentMethodSummaryList, paymentMethodName } = row.original;
      if (!paymentMethodSummaryList || paymentMethodSummaryList.length < 2) {
        return paymentMethodName;
      }
      return paymentMethodSummaryList.map(
        ({ paymentMethodName: name, amount, transactionCode }) => (
          <div key={`${transactionCode}-${name}`}>
            {name}: {numberFormatter({ value: amount })}
          </div>
        ),
      );
    },
    className: 'text-center',
    Filter: (row) => <PaymentMethodFilter onChangeFilter={row.onChange} />,
  },
];

export const SALES_SESSION_DEBIT_NOTES_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Comprobante',
    accessor: 'voucherType',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Emisión',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Cliente',
    accessor: 'customerId',
    Filter: (row) => (
      <CustomerFilter isClearable onChangeFilter={row.onChange} />
    ),
    Cell: (row) =>
      row.value
        ? `${row.original.customerIdDocumentNumber} - ${row.original.customerFullName}`
        : '-',
    className: 'text-center',
  },
  {
    Header: 'Empresa',
    accessor: 'businessId',
    Filter: (row) => (
      <BusinessFilter isClearable onChangeFilter={row.onChange} />
    ),
    Cell: (row) =>
      row.value
        ? `RUC ${row.original.businessTaxIdentificationNumber} - ${row.original.businessName}`
        : '-',
    className: 'text-center',
  },
  {
    Header: 'Documento Modificado',
    accessor: 'previousDocumentSeries',
    Cell: (row) => {
      const { previousDocumentType, previousDocumentCode } = row.original;
      if (!row.value) {
        return '-';
      }
      const documentType = BILL_PROCESS_ORIGIN[previousDocumentType];
      const documentNumber = `${row.value}-${previousDocumentCode}`;
      return documentType
        ? `${documentType.label} ${documentNumber}`
        : documentNumber;
    },
    className: 'text-center',
  },
  {
    Header: 'Motivo',
    accessor: 'motive',
    Cell: (row) =>
      row.value ? (
        <EnumStatus enumObject={CREDIT_NOTE_MOTIVES} enumValue={row.value} />
      ) : (
        '-'
      ),
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Total',
    accessor: 'totalAmount',
    Cell: (row) => numberFormatter({ value: row.value }),
    filterable: false,
    className: 'text-center',
  },
  {
    Header: 'Método de Pago',
    accessor: 'paymentMethodName',
    Cell: (row) => {
      const { paymentMethodSummaryList } = row.original;
      if (!paymentMethodSummaryList || paymentMethodSummaryList.length < 2) {
        return row.value || '-';
      }
      return paymentMethodSummaryList.map(
        ({ paymentMethodName, amount, transactionCode }) => (
          <div key={`${transactionCode}-${paymentMethodName}`}>
            {paymentMethodName}: {numberFormatter({ value: amount })}
          </div>
        ),
      );
    },
    className: 'text-center',
  },
];

export const SALES_SESSION_UNRETURNED_AMOUNT_COLUMNS = [
  {
    Header: 'Transacción Externa',
    accessor: 'externalTransactionId',
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: (row) => row.value && numberFormatter({ value: row.value }),
    className: 'text-center',
  },
];

export const EXPECTED_FUEL_CONSUMTION_COLUMNS = [
  {
    Header: 'Ruta',
    accessor: 'routeName',
    id: 'routeId',
    Filter: (row) => <RouteSelect onChangeFilter={row.onChange} useForFilter />,
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    filterable: true,
  },
  {
    Header: 'Comentario',
    accessor: 'comment',
    className: 'text-center',
    filterable: false,
  },
];

export const DRIVER_BUS_ASSIGNMENT_COLUMNS = [
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    id: 'companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Conductor',
    accessor: 'driverAssignmentDateList[0].driver.driverName',
    id: 'fullName',
    className: 'text-center',
  },
  {
    Header: 'DNI',
    accessor: 'driverAssignmentDateList[0].driver.driverIdDocumentNumber',
    id: 'idDocumentNumber',
    className: 'text-center',
  },
];

export const BUS_FUEL_GROUP_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Rendimiento Km/Galón',
    accessor: 'performance',
    className: 'text-center',
    filterable: false,
    Cell: (row) => (row.value ? row.value.toFixed(2) : null),
  },
];

export const FUEL_PROFILE_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Circuito',
    accessor: 'circuitName',
    id: 'circuitId',
    className: 'text-center',
    Filter: (row) => <CircuitFilter onChangeFilter={row.onChange} />,
    dataType: ColumnFilterDataTypes.ARRAY,
  },
];

export const PURCHASE_ORDER_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    id: 'agency.id',
    Header: 'Agencia',
    accessor: 'agency.name',
    className: 'text-center',
    Filter: (row) => <AgencyFilter onChangeFilter={row.onChange} />,
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Total',
    accessor: 'totalAmount',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={PURCHASE_ORDER_STATUS} enumValue={row.value} />
    ),
    filterable: false,
    className: 'text-center',
  },
];

export const EXTRAORDINARY_MOVEMENT_CONTROL_COLUMNS = [
  {
    Header: 'Fecha Creación',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Fecha Salida Inicial',
    accessor: 'initialDepartureTime',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    id: 'registeredBusId',
    Filter: (row) => <RegisteredBusFilter onChangeFilter={row.onChange} />,
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Filter: (row) => (
      // Apparently the backend does not support filter with enum, pending review
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={EXTRAORDINARY_MOVEMENT_CONTROL_STATUS}
      />
    ),
    Cell: (row) => (
      <EnumStatus
        enumObject={EXTRAORDINARY_MOVEMENT_CONTROL_STATUS}
        enumValue={row.value}
      />
    ),
    filterable: false,
  },
  {
    Header: 'KM Inicial',
    accessor: 'initialKilometers',
    className: 'text-center',
  },
  {
    Header: 'KM Real',
    accessor: 'realKilometers',
    className: 'text-center',
  },
  {
    Header: 'Combustible Inicial',
    accessor: 'expectedFuelConsumption',
    className: 'text-center',
  },
  {
    Header: 'Combustible Real',
    accessor: 'authorizedFuelConsumption',
    className: 'text-center',
  },
  {
    Header: 'Origen Real',
    accessor: 'realSourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Destino Real',
    accessor: 'realDestinationLocationName',
    className: 'text-center',
  },
];

export const FUEL_VOUCHER_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    className: 'text-center',
  },
  {
    Header: 'ID de Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Galones',
    accessor: 'numberOfGallons',
    Cell: (row) => {
      const gallons = row.original.realNumberOfGallons || row.value;
      return numberFormatter({
        style: 'decimal',
        value: gallons,
        minimumFractionDigits: 2,
      });
    },
    className: 'text-center',
  },
  {
    Header: 'Galones Reales',
    accessor: 'realNumberOfGallons',
    Cell: (row) => {
      const gallons = row.original.realNumberOfGallons || row.value;
      return numberFormatter({
        style: 'decimal',
        value: gallons,
        minimumFractionDigits: 2,
      });
    },
    className: 'text-center',
  },
  {
    Header: 'Tipo',
    accessor: 'extraordinary',
    className: 'text-center',
    Cell: (row) => (row.value ? 'Extraordinario' : 'Regular'),
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={FUEL_VOUCHER_EXTRAORDINARY_OPTIONS}
      />
    ),
  },
  {
    Header: 'Estado',
    accessor: 'fuelVoucherStatus',
    className: 'text-center',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={FUEL_VOUCHER_STATUS}
      />
    ),
    Cell: (row) => (
      <EnumStatus enumObject={FUEL_VOUCHER_STATUS} enumValue={row.value} />
    ),
  },
];

export const PURCHASE_ORDER_DETAILS_COLUMNS_TABLE = [
  {
    Header: 'Serie',
    accessor: 'fuelVoucher.documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'fuelVoucher.documentCode',
    className: 'text-center',
  },
  {
    Header: 'Galones Autorizados',
    accessor: 'fuelVoucher.numberOfGallons',
    className: 'text-center',
  },
  {
    Header: 'Galones Utilizados',
    accessor: 'fuelVoucher.realNumberOfGallons',
    className: 'text-center',
  },
  {
    Header: 'Bus',
    accessor: 'fuelVoucher.companyBusId',
    className: 'text-center',
  },
];

export const EXPENSE_TYPES_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Código de Egreso',
    accessor: 'expenseCode',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Etiqueta de Tipo De Egreso',
    accessor: 'expenseTypeLabel',
    Cell: (row) => (row.value ? EXPENSE_TYPE_LABEL[row.value].label : '-'),
    Filter: (row) => (
      <ExpenseTypeLabelSelect onChangeFilter={row.onChange} useForFilter />
    ),
    className: 'text-center',
  },
  {
    Header: 'Interno',
    accessor: 'internal',
    className: 'text-center',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    filterable: false,
  },
  {
    Header: 'Centro de Costo',
    accessor: 'costCenter.description',
    className: 'text-center',
    filterable: false,
  },
];

export const USERS_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'customer.firstName',
    className: 'text-center',
  },
  {
    Header: 'Apellido',
    accessor: 'customer.lastName',
    className: 'text-center',
  },
  {
    Header: 'Usuario',
    accessor: 'username',
    className: 'text-center',
  },
  {
    Header: 'Perfil de Seguridad',
    accessor: 'securityProfileSet',
    id: 'securityProfileSet.name',
    Cell: (row) => {
      if (!row.value) return null;
      const securityProfile = row.value.map(({ name }) => ({ text: name }));
      return <BadgeList cell textArray={securityProfile} />;
    },
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Estado',
    accessor: 'enabled',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={USER_ENABLED_OPTIONS}
      />
    ),
  },
  {
    Header: 'Ultimo Ingreso',
    accessor: 'lastLogin',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    filterable: false,
    className: 'text-center',
  },
];

export const CUSTOMER_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Nombre',
    accessor: 'firstName',
    className: 'text-center',
  },
  {
    Header: 'Apellido',
    accessor: 'lastName',
    className: 'text-center',
  },
  {
    Header: 'Género',
    accessor: 'gender',
    className: 'text-center',
    Cell: (row) => {
      const customerGender = GENDERS.find(
        (gender) => gender.value === row.value,
      );
      return customerGender ? customerGender.label : null;
    },
    filterable: false,
  },
  {
    Header: 'País de Origen',
    accessor: 'idCountryOfOrigin',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Tipo de Documento',
    accessor: 'identificationType.name',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Número de Documento',
    accessor: 'idDocumentNumber',
    className: 'text-center',
  },
];

export const ITINERARIES_FOR_COUNTER_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
    width: 80,
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
    width: 180,
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
    width: 180,
  },
  {
    Header: 'Ruta',
    accessor: 'routeName',
    className: 'text-center',
    width: 580,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Programado',
    accessor: 'tripId',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    className: 'text-center',
    filterable: false,
    width: 70,
  },
  {
    Header: 'Número de Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    width: 70,
  },
  {
    Header: 'Activo',
    accessor: 'active',
    Cell: (row) => <IsActive value={row.value} />,
    className: 'text-center',
    width: 90,
  },
  {
    Header: 'Fecha de Salida',
    accessor: 'departuretime',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
    width: 100,
  },
  {
    Header: 'Hora de Salida',
    accessor: 'departuretime',
    className: 'text-center',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
    width: 100,
  },
  {
    Header: 'Tipo de Itinerario',
    accessor: 'type',
    className: 'text-center',
    Cell: (row) => ITINERARY_TYPE[row.value.toLowerCase()].label,
    width: 100,
  },
];

export const BAGGAGES_COLUMNS = [
  {
    Header: 'Equipaje',
    columns: [
      {
        Header: 'ID',
        accessor: 'id',
        className: 'text-center',
        width: 120,
      },
      {
        id: 'ticketId',
        Header: 'Boleto de Viaje',
        accessor: 'ticketList',
        Cell: (row) => {
          if (!row.value) return null;
          const ticketList = row.value.map(
            ({ documentSeries, documentCode }) => ({
              text: `${documentSeries}-${padStart(documentCode.toString(), 7)}`,
            }),
          );
          return <BadgeList cell textArray={ticketList} />;
        },
        className: 'text-center',
        Filter: (row) => (
          <TicketFilter onChangeFilter={row.onChange} isClearable />
        ),
      },
      {
        accessor: 'tagNumber',
        Header: 'Número del Equipaje',
        className: 'text-center',
        width: 120,
      },
      {
        id: 'sourceLocationId',
        Header: 'Embarque',
        accessor: 'ticketList',
        Cell: (row) => {
          if (!row.value) return null;
          const sourceList = row.value.map(({ sourceLocation }) => ({
            text: sourceLocation.name,
          }));
          return <BadgeList cell textArray={sourceList} />;
        },
        className: 'text-center',
        Filter: (row) => (
          <LocationFilter
            onChangeFilter={row.onChange}
            isClearable
            placeholder="Filtrar por Embarque"
          />
        ),
      },
      {
        id: 'destinationLocationId',
        Header: 'Desembarque',
        accessor: 'ticketList',
        Cell: (row) => {
          if (!row.value) return null;
          const destinationList = row.value.map(({ destinationLocation }) => ({
            text: destinationLocation.name,
          }));
          return <BadgeList cell textArray={destinationList} />;
        },
        className: 'text-center',
        Filter: (row) => (
          <LocationFilter
            onChangeFilter={row.onChange}
            isClearable
            placeholder="Filtrar por Desembarque"
          />
        ),
      },
      {
        Header: 'Items',
        accessor: 'itemList',
        Cell: (row) => {
          if (!row.value) return null;
          const itemList = row.value.map(({ description }) => ({
            text: description,
          }));
          return <BadgeList cell textArray={itemList} />;
        },
        className: 'text-center',
        filterable: false,
      },
      {
        Header: 'Tickets',
        accessor: 'itemList',
        Cell: (row) => {
          if (!row.value) return null;
          const itemList = row.value.map(({ itemSeries, itemCode }) => ({
            text: `${itemSeries}-${itemCode}`,
          }));
          return <BadgeList cell textArray={itemList} />;
        },
        className: 'text-center',
        filterable: false,
      },
      {
        Header: 'Correlativo Automático',
        accessor: 'itemList',
        Cell: (row) => {
          if (!row.value) return null;
          const itemList = row.value.map(({ itemCorrelation }) => ({
            text: itemCorrelation,
          }));
          return <BadgeList cell textArray={itemList} />;
        },
        className: 'text-center',
        filterable: false,
      },
      {
        Header: 'Peso',
        accessor: 'totalWeight',
        className: 'text-center',
        Cell: (row) => `${row.value} ${KILOGRAM_SYMBOL}`,
        width: 120,
      },
      {
        id: 'status',
        Header: 'Estado',
        accessor: 'baggageStatus',
        className: 'text-center',
        Cell: (row) => (
          <EnumStatus enumObject={BAGGAGE_STATUS} enumValue={row.value} />
        ),
        Filter: (row) => (
          <EnumSelectFilter
            onChangeFilter={row.onChange}
            enumOptions={BAGGAGE_STATUS}
          />
        ),
      },
    ],
  },
  {
    Header: 'Exceso',
    columns: [
      {
        id: 'excessBaggageId',
        Header: 'Boleta',
        accessor: 'excessBaggage',
        Cell: (row) => {
          const { value } = row;
          if (!value) return null;
          return (
            <Badge
              text={`${value.documentSeries}-${padStart(
                value.documentCode.toString(),
                7,
              )}`}
            />
          );
        },
        Filter: (row) => (
          <ExcessBaggageFilter onChangeFilter={row.onChange} isClearable />
        ),
        className: 'text-center',
      },
      {
        Header: 'Peso',
        accessor: 'excessBaggage',
        Cell: (row) => row.value && `${row.value.weight} ${KILOGRAM_SYMBOL}`,
        className: 'text-center',
        width: 120,
      },
      {
        Header: `Precio`,
        accessor: 'excessBaggage.price',
        Cell: (row) => row.value && numberFormatter({ value: row.value }),
        className: 'text-center',
        width: 120,
      },
    ],
  },
];

export const DISTRICTS_COLUMNS = [
  {
    Header: 'Distrito',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Ciudad',
    accessor: 'city.name',
    className: 'text-center',
  },
  {
    Header: 'Departamento',
    accessor: 'city.region.name',
    className: 'text-center',
  },
  {
    Header: 'Pais',
    accessor: 'city.region.country.name',
    className: 'text-center',
  },
];

export const DEPRECIATION_RULES_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Depreciación',
    accessor: 'depreciationType',
    className: 'text-center',
  },
  {
    Header: 'Perdiodo',
    accessor: 'depreciationPeriodicity',
    className: 'text-center',
  },
  {
    Header: 'Porcentaje de Dep.',
    accessor: 'depreciationPercentage',
    className: 'text-center',
  },
];

export const DELIVERY_GROUPS_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const BASE_PRICE_PER_KILOMETER_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Kilómetro Inicial',
    accessor: 'fromKilometer',
    className: 'text-center',
  },
  {
    Header: 'Kilómetro Final',
    accessor: 'toKilometer',
    className: 'text-center',
  },
  {
    Header: 'Precio Base',
    accessor: 'price',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Factor Kilometraje',
    accessor: 'kilometerFactor',
    className: 'text-center',
  },
];

export const GEOGRAPHIC_ZONES_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Ciudades',
    accessor: 'cityList',
    className: 'text-center',
    filterable: false,
    Cell: (row) => {
      if (!row.value) return null;
      const cityList = row.value.map(({ name }) => ({ text: name }));
      return <BadgeList cell textArray={cityList} />;
    },
  },
];

export const GEOGRAPHIC_ZONES_COMBINATION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Zona Origen',
    accessor: 'sourceGeographicZone.name',
    className: 'text-center',
  },
  {
    Header: 'Zona Destino',
    accessor: 'destinationGeographicZone.name',
    className: 'text-center',
  },
  {
    Header: 'Factor',
    accessor: 'factor',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const COMMON_PRODUCT_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre Producto',
    accessor: 'productName',
    className: 'text-center',
  },
  {
    Header: 'Categoria',
    accessor: 'cargoCategory.name',
    className: 'text-center',
    Filter: (row) => <CargoCategoryFilter onChangeFilter={row.onChange} />,
    id: 'cargoCategoryId',
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Descripción Producto',
    accessor: 'productDescription',
    className: 'text-center',
  },
  {
    Header: 'Producto Interno',
    accessor: 'internalProduct',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Activo',
    accessor: 'active',
    Cell: (row) => <IsActive value={row.value} />,
    className: 'text-center',
    filterable: false,
  },
];

export const CARGO_DISTANCE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Ciudad Origen',
    accessor: 'sourceCity.name',
    className: 'text-center',
  },
  {
    Header: 'Ciudad Destino',
    accessor: 'destinationCity.name',
    className: 'text-center',
  },
  {
    Header: 'Kilómetros',
    accessor: 'kilometers',
    className: 'text-center',
  },
];

export const CARGO_CATEGORY_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Categoría',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const PARCELS_COLUMNS = [
  {
    Header: 'Tipo de Comprobante',
    accessor: 'voucherTypeName',
    className: 'text-center',
    Filter: (row) => <VoucherTypeFilter onChangeFilter={row.onChange} />,
    id: 'voucherTypeId',
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
    bsSize: 'lg',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'financialStatus',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PARCEL_FINANCIAL_STATUS}
      />
    ),
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_FINANCIAL_STATUS} enumValue={row.value} />
    ),
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    id: 'sourceLocationId',
    className: 'text-center',
    Filter: (row) => (
      <LocationFilter onChangeFilter={row.onChange} isClearable />
    ),
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    id: 'destinationLocationId',
    className: 'text-center',
    Filter: (row) => (
      <LocationFilter onChangeFilter={row.onChange} isClearable />
    ),
  },
  {
    Header: 'Cliente',
    accessor: 'customerFullName',
    id: 'customerId',
    Filter: (row) => (
      <CustomerFilter isClearable onChangeFilter={row.onChange} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Empresa',
    accessor: 'businessName',
    id: 'businessId',
    Filter: (row) => (
      <BusinessFilter isClearable onChangeFilter={row.onChange} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Remitente',
    accessor: 'senderCustomerFullName',
    id: 'senderCustomerId',
    Filter: (row) => (
      <CustomerFilter isClearable onChangeFilter={row.onChange} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Consignado',
    accessor: 'consigneeCustomerFullName',
    id: 'consigneeCustomerId',
    Filter: (row) => (
      <CustomerFilter isClearable onChangeFilter={row.onChange} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Consignado Secundario',
    accessor: 'secondaryConsigneeCustomerFullName',
    id: 'secondaryConsigneeCustomerId',
    Filter: (row) => (
      <CustomerFilter isClearable onChangeFilter={row.onChange} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Método de Pago',
    accessor: 'paymentMethodName',
    className: 'text-center',
    Filter: (row) => <PaymentMethodFilter onChangeFilter={row.onChange} />,
    id: 'paymentMethodId',
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Cantidad de Encomiendas',
    accessor: 'cargoItemSize',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Monto Total',
    accessor: 'salePrice',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
  },
  {
    Header: 'Codigo de Descuento',
    accessor: 'discountCodeString',
    className: 'text-center',
  },
  {
    Header: 'Estado de Pago',
    accessor: 'paymentStatus',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PARCEL_PAYMENT_STATUS}
      />
    ),
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_PAYMENT_STATUS} enumValue={row.value} />
    ),
  },
];

export const INTERNAL_PARCELS_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
    bsSize: 'lg',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceCityName',
    className: 'text-center',
    Filter: (row) => <CityFilter onChangeFilter={row.onChange} />,
    id: 'sourceCityId',
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Destino',
    accessor: 'destinationCityName',
    className: 'text-center',
    Filter: (row) => <CityFilter onChangeFilter={row.onChange} />,
    id: 'destinationCityId',
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Remitente',
    accessor: 'senderCustomerFullName',
    id: 'senderCustomer.idDocumentNumber',
    className: 'text-center',
  },
  {
    Header: 'Consignado',
    accessor: 'consigneeCustomerFullName',
    id: 'consigneeCustomer.idDocumentNumber',
    className: 'text-center',
  },
];

export const CARGO_ITEMS_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Producto Frecuente',
    accessor: 'commonProductName',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Categoría',
    accessor: 'cargoCategoryName',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Anaquel',
    accessor: 'shelfSpace',
    className: 'text-center',
    Cell: (row) => {
      const { value } = row;
      if (!value) return '-';
      const { locationName } = row.original;
      return `${locationName || '-'} | ${value.shelfName} - ${value.spaceName}`;
    },
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => <CargoItemStatusCell value={row.value} />,
    Filter: (row) => <CargoItemStatusFilter onChangeFilter={row.onChange} />,
  },
  {
    Header: 'Monto total',
    accessor: 'salePrice',
    className: 'text-center',
    Cell: (row) => `${PEN_SYMBOL} ${row.value.toFixed(2)}`,
  },
];

export const generateCargoItemsColumnsTable = (setSelectedLocationIds) => [
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    id: 'commonProductId',
    Header: 'Producto Frecuente',
    accessor: 'commonProductName',
    className: 'text-center',
    Filter: (row) => <CommonProductFilter onChangeFilter={row.onChange} />,
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    id: 'cargoCategoryId',
    Header: 'Categoría',
    accessor: 'cargoCategoryName',
    className: 'text-center',
    Filter: (row) => <CargoCategoryFilter onChangeFilter={row.onChange} />,
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => <CargoItemStatusCell value={row.value} />,
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        isMulti
        enumOptions={CARGO_ITEM_STATUS}
      />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Perecible',
    accessor: 'perishable',
    className: 'text-center',
    id: 'isPerishable',
    Cell: (row) => <Checkbox checked={row.value} />,
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={CARGO_ITEM_PERISHABLE_OPTIONS}
      />
    ),
  },
  {
    Header: 'Ubicación',
    accessor: 'locationName',
    className: 'text-center',
    id: 'locationId',
    Filter: (row) => (
      <LocationFilter
        onChangeFilter={(value) => {
          setSelectedLocationIds(value || []);
          row.onChange(value);
        }}
        isClearable
        isMulti
      />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    id: 'shelfSpace.shelf.id',
    Header: 'Anaquel',
    accessor: 'shelfSpace',
    className: 'text-center',
    Cell: (row) => {
      const { value } = row;
      if (!value) return '-';
      const { shelf } = row.value;
      return `${shelf.name} - ${value.spaceName}`;
    },
    Filter: (row) => (
      <ShelfFilter onChangeFilter={row.onChange} isClearable isMulti />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Destino',
    accessor: 'finalLocationName',
    className: 'text-center',
    id: 'finalDestinationLocationId',
    Filter: (row) => (
      <LocationFilter onChangeFilter={row.onChange} isClearable isMulti />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Estado de Pago',
    accessor: 'parcelPaymentStatusType',
    className: 'text-center',
    id: 'parcel.paymentStatus',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_PAYMENT_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PARCEL_PAYMENT_STATUS}
      />
    ),
  },
  {
    Header: 'Método de Pago',
    accessor: 'paymentMethod.name',
    className: 'text-center',
    id: 'parcel.paymentMethodId',
    Filter: (row) => (
      <PaymentMethodFilter onChangeFilter={row.onChange} isClearable />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Precio de Venta',
    accessor: 'salePrice',
    className: 'text-center',
    Cell: (row) => `${PEN_SYMBOL} ${row.value.toFixed(2)}`,
  },
];

export const CARGO_MINIMAL_PRICE_COLUMNS = [
  {
    Header: 'Precio Mínimo',
    accessor: 'minimalPrice',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
];

export const ITINERARY_SEARCH_OMISSION_COLUMNS = [
  {
    Header: 'Ubicación Origen Id',
    accessor: 'sourceLocationId',
    className: 'text-center',
  },
  {
    Header: 'Ubicación Origen',
    accessor: 'sourceLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Ubicación Destino Id',
    accessor: 'destinationLocationId',
    className: 'text-center',
  },
  {
    Header: 'Ubicación Destino',
    accessor: 'destinationLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Itinerario Id',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Ruta del Itinerario',
    accessor: 'itineraryRouteName',
    id: 'itinerary.route.name',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Fecha de Salida del Itinerario',
    accessor: 'itineraryDepartureTime',
    id: 'itinerary.departureTime',
    className: 'text-center',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    filterable: false,
  },
];

export const ITINERARY_SCHEDULE_COLUMNS = [
  {
    Header: 'Código',
    accessor: 'itineraryCode',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Maciva',
    accessor: 'isMaciva',
    className: 'text-center',
    Cell: (row) => <Checkbox checked={row.value} />,
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={ITINERARY_SCHEDULE_MACIVA_OPTIONS}
      />
    ),
  },
];

export const COMPANY_ITINERARY_SCHEDULE_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Régimen',
    accessor: 'shift',
    className: 'text-center',
  },
  {
    Header: 'Tipo',
    accessor: 'staffType',
    Cell: (row) => COMPANY_STAFF_TYPE[row.value].label,
    className: 'text-center',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(COMPANY_STAFF_TYPE)}
      />
    ),
  },
  {
    Header: 'Fecha de Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
];

export const AGENCY_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Contrato',
    accessor: 'contractType',
    Cell: (row) => (row.value ? CONTRACT_TYPE[row.value].label : '-'),
    Filter: (row) => (
      <AgencyContractTypeSelect onChangeFilter={row.onChange} useForFilter />
    ),
    className: 'text-center',
  },
  {
    Header: 'Ubicación',
    accessor: 'location.name',
    className: 'text-center',
  },
  {
    Header: 'Número de Usuarios',
    accessor: 'numberOfUser',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <TicketActiveFilter
        onChangeFilter={row.onChange}
        options={AGENCY_ACTIVE_OPTIONS}
      />
    ),
  },
];

export const PRINT_STATION_COLUMNS = [
  {
    Header: 'Número de Serie',
    accessor: 'serialNumber',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const WORKSTATION_COLUMNS = [
  {
    Header: 'Número de Serie',
    accessor: 'serialNumber',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const PRICING_PROFILE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Perfil de Precio',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Precio Base',
    accessor: 'basePrice',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Mapa de Asiento',
    accessor: 'seatMap',
    id: 'seatMapId',
    Cell: (row) => (row.value ? row.value.name : null),
    className: 'text-center',
    Filter: (row) => (
      <SeatMapSelect onChangeFilter={row.onChange} useForFilter />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
  },
];

export const LIQUIDATION_SESSIONS_COLUMNS = [
  {
    Header: 'Agencia',
    accessor: 'agency.name',
    className: 'text-center',
    filterable: true,
    Filter: (row) => <AgencyFilter onChangeFilter={row.onChange} />,
    id: 'agencyId',
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Aprobado',
    accessor: 'isSettled',
    className: 'text-center',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    filterable: false,
  },
  {
    Header: 'Depositado',
    accessor: 'depositId',
    className: 'text-center',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    filterable: false,
  },
  {
    Header: 'Notas',
    accessor: 'dailyLiquidationSessionNoteList',
    Cell: (row) => row.value.length,
    className: 'text-center',
    filterable: false,
  },
];

export const COMPANY_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Empresa Relacionada',
    accessor: 'business.name',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Empresa Tercera',
    accessor: 'companyType',
    Cell: (row) => COMPANY_TYPE[row.value].label,
    filterable: false,
    className: 'text-center',
  },
];

export const COMPANY_CREDIT_NOTE_COLUMNS = [
  {
    Header: 'Nombre Cliente',
    accessor: 'customer.firstName',
    className: 'text-center',
  },
  {
    Header: 'Apellido Cliente',
    accessor: 'customer.lastName',
    className: 'text-center',
  },
  {
    Header: 'Documento de Identidad',
    accessor: 'customer.idDocumentNumber',
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: (row) => row.value && numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Fecha de expiración',
    accessor: 'expirationDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
];

export const AGENCY_GROUP_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Porcentaje de Descuento',
    accessor: 'discountPercentage',
    className: 'text-center',
  },
];

export const PRICING_PROFILE_REPORT_COLUMNS = [
  {
    Header: 'Fecha de Inicio',
    accessor: 'fromDate',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'toDate',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Última Actualización',
    accessor: 'lastUpdate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Estado',
    accessor: 'reportStatus',
    Cell: (row) => <ReportStatusCell value={row.value} />,
  },
];

export const SECURITY_PROFILES_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const VIEWS_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    accessor: 'route',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const AUTHORIZED_PROFILES_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Perfil',
    accessor: 'profile.name',
    className: 'text-center',
  },
  {
    Header: 'Perfil Autorizado',
    accessor: 'authorizedSecurityProfile.name',
    className: 'text-center',
  },
];

export const COMPANY_USER_CONFIGURATION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Usuario',
    accessor: 'user.customer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Usuario Padre',
    accessor: 'parentUser.customer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Empresa Tercera',
    accessor: 'company.name',
    className: 'text-center',
  },
];

export const GENERAL_INCOME_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Pagador',
    accessor: 'payerCustomer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Beneficiario',
    accessor: 'payeeUser.customer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Ingreso',
    accessor: 'transaction.generalIncomeType.name',
    className: 'text-center',
  },
  {
    Header: 'Total',
    accessor: 'total',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
  },
];

const bankReconciliationSumFooter = (accessor) => (props) =>
  (
    <strong>
      {numberFormatter({
        // eslint-disable-next-line
        value: props.data.reduce((acc, row) => acc + (row[accessor] || 0), 0),
      })}
    </strong>
  );

const bankReconciliationCountBadges = (breakdown) => {
  const visible = breakdown.filter(({ count }) => count > 0);

  if (visible.length === 0) return null;

  return (
    <BadgeList
      cell
      textArray={visible.map(({ count, label, color }) => ({
        text: `${count} ${label}`,
        color,
      }))}
    />
  );
};

const bankReconciliationEnumBreakdown = (enumObject, counts) =>
  Object.keys(counts).map((key) => ({
    key,
    count: counts[key],
    label: enumObject[key].label.toLowerCase(),
    color: enumObject[key].color,
  }));

export const BANK_RECONCILIATION_DATE_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'liquidationDate',
    className: 'text-center',
    Cell: (row) => {
      if (!row.value) return null;
      const [year, month, day] = row.value.split('-');
      return `${day}/${month}/${year}`;
    },
  },
  {
    Header: 'Liquidaciones',
    accessor: 'totalLiquidations',
    className: 'text-center',
    Cell: (row) =>
      bankReconciliationCountBadges([
        {
          key: 'GENERATED',
          count: row.original.totalLiquidations,
          label: 'generadas',
          color: 'success',
        },
        {
          key: 'NOT_GENERATED',
          count: row.original.notGeneratedLiquidations,
          label: 'sin generar',
          color: 'warning',
        },
      ]),
  },
  {
    Header: 'Estado',
    id: 'coverageStatusBreakdown',
    accessor: 'totalLiquidations',
    className: 'text-center',
    Cell: (row) =>
      bankReconciliationCountBadges(
        bankReconciliationEnumBreakdown(BANK_RECONCILIATION_STATUS, {
          RECONCILED: row.original.reconciledLiquidations,
          PARTIAL: row.original.partialLiquidations,
          UNRECONCILED: row.original.unreconciledLiquidations,
        }),
      ),
  },
  {
    Header: 'Monto a depositar',
    accessor: 'amountToDeposit',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
  },
  {
    Header: 'Depositado',
    accessor: 'amountDeposited',
    className: 'text-center',
    Cell: (row) => (
      <BankReconciliationSurplusCell
        value={row.value}
        surplus={row.original.surplus}
        sharedDepositCount={row.original.sharedDepositCount}
        showSurplus={false}
      />
    ),
  },
  {
    Header: 'Pendiente de depósito',
    accessor: 'liquidationDifference',
    className: 'text-center',
    Cell: (row) => <BankReconciliationDiffCell value={row.value} />,
  },
  {
    Header: 'Dif. banco',
    accessor: 'bankDifference',
    className: 'text-center',
    Cell: (row) => <BankReconciliationDiffCell value={row.value} />,
  },
  {
    Header: 'Migración a SAP',
    id: 'migrationStatusBreakdown',
    accessor: 'migratedCount',
    className: 'text-center',
    Cell: (row) =>
      bankReconciliationCountBadges([
        ...bankReconciliationEnumBreakdown(DEPOSIT_MIGRATION_STATUS, {
          MIGRATED: row.original.migratedCount,
          PENDING_MIGRATION: row.original.pendingMigrationCount,
          PENDING_BANK_FILE: row.original.pendingBankFileCount,
          FAILED: row.original.failedCount,
          NOT_APPLICABLE: row.original.notApplicableCount,
        }),
        {
          key: 'PENDING_BANK_VERIFICATION',
          count: row.original.pendingBankVerificationCount,
          label:
            DEPOSIT_BANK_TRANSFER_STATUS.PENDING_BANK_VERIFICATION.label.toLowerCase(),
          color: DEPOSIT_BANK_TRANSFER_STATUS.PENDING_BANK_VERIFICATION.color,
        },
        {
          key: 'BANK_TRANSFER_PENDING',
          count: row.original.bankTransferPendingCount,
          label: 'transferencia pendiente de envío',
          color: DEPOSIT_BANK_TRANSFER_STATUS.PENDING_MIGRATION.color,
        },
        {
          key: 'BANK_TRANSFER_MIGRATED',
          count: row.original.bankTransferMigratedCount,
          label: 'transferencia migrada',
          color: DEPOSIT_BANK_TRANSFER_STATUS.MIGRATED.color,
        },
        {
          key: 'BANK_TRANSFER_FAILED',
          count: row.original.bankTransferFailedCount,
          label: 'transferencia falló',
          color: DEPOSIT_BANK_TRANSFER_STATUS.FAILED.color,
        },
        {
          key: 'PENDING_SAP_DEPOSIT',
          count: row.original.pendingSapDepositCount,
          label: 'por migrar a SAP',
          color: 'warning',
        },
      ]),
  },
];

const bankReconciliationDateTotalFooter = (dateTotals, field) => () =>
  (
    <strong>
      {numberFormatter({ value: dateTotals ? dateTotals[field] : 0 })}
    </strong>
  );

const bankReconciliationGeneratedCell = (cell) => (row) =>
  row.original.generated ? cell(row) : '-';

export const bankReconciliationLiquidationColumns = (dateTotals) => [
  {
    expander: true,
    width: 35,
    // eslint-disable-next-line
    Expander: ({ isExpanded, original }) =>
      // eslint-disable-next-line
      original.generated ? (
        <div className={`rt-expander${isExpanded ? ' -open' : ''}`}>&bull;</div>
      ) : null,
    getProps: (state, rowInfo) => ({
      onClick: (e, handleOriginal) => {
        if (rowInfo && rowInfo.original.generated) handleOriginal();
      },
      style: {
        cursor: rowInfo && rowInfo.original.generated ? 'pointer' : 'default',
      },
    }),
  },
  {
    Header: 'Liquidación',
    groupStyle: {
      background: 'rgba(91,42,134,.10)',
      borderBottom: '2px solid rgba(91,42,134,.35)',
    },
    columns: [
      {
        Header: 'ID liquidación',
        accessor: 'liquidationId',
        className: 'text-center',
        Cell: (row) =>
          row.value ? (
            <LinkToModuleResource
              href={`${LIQUIDATION_SESSION_PATH}/${row.value}`}
              text={row.value}
              colorIcon="text-primary"
            />
          ) : (
            '-'
          ),
        Footer: () => <strong>Total</strong>,
      },
      {
        Header: 'Generada',
        accessor: 'generated',
        className: 'text-center',
        Cell: (row) => {
          if (row.value) return <Badge color="success" text="Generada" />;

          const { salesSessionCount, openSalesSessionCount } = row.original;

          return (
            <>
              <Badge color="warning" text="No generada" />
              {salesSessionCount ? (
                <div className="small text-muted">
                  {`${
                    openSalesSessionCount || 0
                  } de ${salesSessionCount} sesiones abiertas`}
                </div>
              ) : null}
            </>
          );
        },
      },
      {
        Header: 'Agencia',
        accessor: 'agencyName',
      },
      {
        Header: 'Responsable',
        accessor: 'operatorUserName',
        Cell: bankReconciliationGeneratedCell((row) => row.value),
      },
      {
        Header: 'Dif. caja',
        accessor: 'cashDifference',
        className: 'text-center',
        Cell: bankReconciliationGeneratedCell((row) => (
          <BankReconciliationCashDifferenceCell value={row.value} />
        )),
      },
    ],
  },
  {
    Header: 'Depósito',
    groupStyle: {
      background: 'rgba(0,0,0,.04)',
      borderBottom: '2px solid rgba(0,0,0,.15)',
    },
    columns: [
      {
        Header: 'Cant.',
        accessor: 'depositCount',
        className: 'text-center',
        width: 70,
        Cell: bankReconciliationGeneratedCell((row) => row.value),
        // eslint-disable-next-line
        Footer: ({ data }) => (
          <strong>
            {dateTotals &&
            dateTotals.totalDeposits !== null &&
            dateTotals.totalDeposits !== undefined
              ? dateTotals.totalDeposits
              : // eslint-disable-next-line
                data.reduce((acc, row) => acc + (row.depositCount || 0), 0)}
          </strong>
        ),
      },
      {
        Header: 'Días',
        accessor: 'daysToDeposit',
        className: 'text-center',
        width: 70,
        Cell: ({ value }) => value || '-',
      },
      {
        Header: 'Monto a depositar',
        accessor: 'amountToDeposit',
        className: 'text-center',
        Cell: bankReconciliationGeneratedCell((row) =>
          numberFormatter({ value: row.value }),
        ),
        Footer: bankReconciliationDateTotalFooter(
          dateTotals,
          'amountToDeposit',
        ),
      },
      {
        Header: 'Depositado',
        accessor: 'amountDeposited',
        className: 'text-center',
        Cell: bankReconciliationGeneratedCell((row) => (
          <BankReconciliationSurplusCell
            value={row.value}
            surplus={row.original.surplus}
            sharedDepositCount={row.original.sharedDepositCount}
            showSurplus
          />
        )),
        Footer: bankReconciliationDateTotalFooter(
          dateTotals,
          'amountDeposited',
        ),
      },
      {
        Header: 'Pendiente de depósito',
        accessor: 'liquidationDifference',
        className: 'text-center',
        Cell: bankReconciliationGeneratedCell((row) => (
          <BankReconciliationDiffCell value={row.value} />
        )),
        Footer: bankReconciliationDateTotalFooter(
          dateTotals,
          'liquidationDifference',
        ),
      },
      {
        Header: 'Dif. banco',
        accessor: 'bankDifference',
        className: 'text-center',
        Cell: bankReconciliationGeneratedCell((row) => (
          <BankReconciliationDiffCell value={row.value} />
        )),
        Footer: bankReconciliationDateTotalFooter(dateTotals, 'bankDifference'),
      },
      {
        Header: 'Estado',
        accessor: 'status',
        className: 'text-center',
        Cell: bankReconciliationGeneratedCell((row) => (
          <EnumStatus
            enumObject={BANK_RECONCILIATION_STATUS}
            enumValue={row.value}
          />
        )),
      },
    ],
  },
  {
    Header: 'SAP',
    groupStyle: {
      background: 'rgba(0,100,200,.10)',
      borderBottom: '2px solid rgba(0,100,200,.35)',
    },
    columns: [
      {
        Header: 'Estado',
        accessor: 'pendingSapMigration',
        className: 'text-center',
        Cell: (row) => {
          if (row.value === null) return '-';
          const status = row.value
            ? MIGRATION_STATUS.PENDING
            : MIGRATION_STATUS.SUCCESS;
          return <Badge color={status.color} text={status.label} />;
        },
      },
    ],
  },
];

const bankReconciliationCountSumFooter =
  (field) =>
    // eslint-disable-next-line
    ({ data }) =>
    // eslint-disable-next-line
    <strong>{data.reduce((acc, row) => acc + (row[field] || 0), 0)}</strong>;

// Amounts come in each row's currency, so they are never summed across currencies
const bankReconciliationCurrencyAmount = (value, currency) =>
  currency
    ? numberFormatter({ value, currency })
    : numberFormatter({ value, style: 'decimal' });

const bankReconciliationPendingAmountClassName = (value) => {
  if (value > 0) return 'text-danger font-weight-bold';
  if (value < 0) return 'text-warning font-weight-bold';
  return 'text-success';
};

const bankReconciliationCurrencySumFooter =
  (field) =>
  // eslint-disable-next-line
  ({ data }) => {
    const totals = data.reduce((acc, row) => {
      // eslint-disable-next-line no-underscore-dangle
      const { currency: rowCurrency } = row._original || row;
      const currency = rowCurrency || null;
      const existing = acc.find((total) => total.currency === currency);

      if (existing) {
        existing.value += row[field] || 0;
        return acc;
      }

      return [...acc, { currency, value: row[field] || 0 }];
    }, []);

    return totals.map(({ currency, value }) => (
      <div key={currency || 'NO_CURRENCY'}>
        <strong>{bankReconciliationCurrencyAmount(value, currency)}</strong>
      </div>
    ));
  };

const bankReconciliationSapMigrationCell = (row) => {
  const status = row.value
    ? MIGRATION_STATUS.PENDING
    : MIGRATION_STATUS.SUCCESS;
  return <Badge color={status.color} text={status.label} />;
};

const BANK_RECONCILIATION_CORPORATE_AMOUNT_GROUP = {
  Header: 'Montos',
  groupStyle: {
    background: 'rgba(200,120,0,.10)',
    borderBottom: '2px solid rgba(200,120,0,.35)',
  },
  columns: [
    {
      Header: 'Monto a depositar',
      accessor: 'amountToDeposit',
      className: 'text-center',
      Cell: (row) =>
        bankReconciliationCurrencyAmount(row.value, row.original.currency),
      Footer: bankReconciliationCurrencySumFooter('amountToDeposit'),
    },
    {
      Header: 'Depositado',
      accessor: 'amountDeposited',
      className: 'text-center',
      Cell: (row) =>
        bankReconciliationCurrencyAmount(row.value, row.original.currency),
      Footer: bankReconciliationCurrencySumFooter('amountDeposited'),
    },
    {
      Header: 'Pendiente de depósito',
      accessor: 'pendingAmount',
      className: 'text-center',
      Cell: (row) => (
        <span className={bankReconciliationPendingAmountClassName(row.value)}>
          {bankReconciliationCurrencyAmount(row.value, row.original.currency)}
        </span>
      ),
      Footer: bankReconciliationCurrencySumFooter('pendingAmount'),
    },
  ],
};

const BANK_RECONCILIATION_CORPORATE_SAP_GROUP = {
  Header: 'SAP',
  groupStyle: {
    background: 'rgba(0,100,200,.10)',
    borderBottom: '2px solid rgba(0,100,200,.35)',
  },
  columns: [
    {
      Header: 'Estado',
      accessor: 'pendingSapMigration',
      className: 'text-center',
      Cell: bankReconciliationSapMigrationCell,
    },
  ],
};

const bankReconciliationCountExpander = (countField) => ({
  expander: true,
  width: 35,
  // eslint-disable-next-line
  Expander: ({ isExpanded, original }) =>
    // eslint-disable-next-line
    original[countField] ? (
      <div className={`rt-expander${isExpanded ? ' -open' : ''}`}>&bull;</div>
    ) : null,
  getProps: (state, rowInfo) => ({
    onClick: (e, handleOriginal) => {
      if (rowInfo && rowInfo.original[countField]) handleOriginal();
    },
    style: {
      cursor: rowInfo && rowInfo.original[countField] ? 'pointer' : 'default',
    },
  }),
});

export const BANK_RECONCILIATION_CORPORATE_COVERAGE_COLUMNS = [
  bankReconciliationCountExpander('voucherCount'),
  {
    Header: 'Corporativo',
    groupStyle: {
      background: 'rgba(0,140,120,.10)',
      borderBottom: '2px solid rgba(0,140,120,.35)',
    },
    columns: [
      {
        Header: 'Tipo',
        accessor: 'holderType',
        className: 'text-center',
        width: 100,
        Cell: (row) => (
          <EnumStatus
            enumObject={BANK_RECONCILIATION_HOLDER_TYPE}
            enumValue={row.value}
          />
        ),
      },
      {
        Header: 'RUC / Documento',
        accessor: 'ruc',
        className: 'text-center',
        Cell: (row) => row.value || '-',
        Footer: () => <strong>Total</strong>,
      },
      {
        Header: 'Razón social',
        accessor: 'businessName',
        minWidth: 200,
        Cell: (row) => row.value || '-',
      },
      {
        Header: 'Moneda',
        accessor: 'currency',
        className: 'text-center',
        width: 80,
        Cell: (row) => row.value || '-',
      },
    ],
  },
  {
    Header: 'Comprobantes manuales',
    groupStyle: {
      background: 'rgba(0,0,0,.04)',
      borderBottom: '2px solid rgba(0,0,0,.15)',
    },
    columns: [
      {
        Header: 'Cant.',
        accessor: 'voucherCount',
        className: 'text-center',
        Footer: bankReconciliationCountSumFooter('voucherCount'),
      },
      {
        Header: 'Depósitos',
        accessor: 'depositCount',
        className: 'text-center',
        Footer: bankReconciliationCountSumFooter('depositCount'),
      },
      {
        Header: 'Depósitos sin comprobante',
        accessor: 'unlinkedDepositCount',
        className: 'text-center',
        Cell: (row) => (
          <span className={row.value ? 'text-warning font-weight-bold' : ''}>
            {row.value}
          </span>
        ),
        Footer: bankReconciliationCountSumFooter('unlinkedDepositCount'),
      },
    ],
  },
  BANK_RECONCILIATION_CORPORATE_AMOUNT_GROUP,
  BANK_RECONCILIATION_CORPORATE_SAP_GROUP,
];

export const BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHER_COLUMNS = [
  bankReconciliationCountExpander('depositCount'),
  {
    Header: 'Comprobante manual',
    groupStyle: {
      background: 'rgba(0,140,120,.10)',
      borderBottom: '2px solid rgba(0,140,120,.35)',
    },
    columns: [
      {
        Header: 'Documento',
        id: 'document',
        accessor: 'manualVoucherId',
        className: 'text-center',
        // eslint-disable-next-line
        Cell: ({ value, original: { documentSeries, documentCode } }) => (
          <LinkToModuleResource
            href={`${MANUAL_VOUCHER_PATH}/${value}`}
            text={
              documentSeries || documentCode
                ? `${documentSeries || '-'}-${documentCode || '-'}`
                : value
            }
            colorIcon="text-primary"
          />
        ),
        Footer: () => <strong>Total</strong>,
      },
      {
        Header: 'Tipo',
        accessor: 'voucherTypeName',
        Cell: (row) => row.value || '-',
      },
      {
        Header: 'Emisión',
        accessor: 'issueDate',
        className: 'text-center',
        Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
      },
      {
        Header: 'Pago',
        accessor: 'paymentType',
        className: 'text-center',
        Cell: (row) =>
          row.value ? (
            <EnumStatus enumObject={PAYMENT_TYPE} enumValue={row.value} />
          ) : (
            '-'
          ),
      },
      {
        Header: 'Depósitos',
        accessor: 'depositCount',
        className: 'text-center',
        width: 90,
        Footer: bankReconciliationCountSumFooter('depositCount'),
      },
    ],
  },
  BANK_RECONCILIATION_CORPORATE_AMOUNT_GROUP,
  BANK_RECONCILIATION_CORPORATE_SAP_GROUP,
];

const BANK_SUMMARY_HEADER_STYLE = { whiteSpace: 'normal' };

const bankSummaryAmount = (value) => numberFormatter({ value: value || 0 });

const bankSummaryTotalValue = (bankTotal, field) =>
  bankTotal ? bankTotal[field] : 0;

export const bankReconciliationBankSummaryColumns = (bankTotal) => [
  {
    Header: 'Banco',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'bankName',
    Cell: (row) => <span className="h6 mb-0">{row.value}</span>,
    Footer: () => <strong>TOTAL</strong>,
    width: 240,
  },
  {
    Header: 'Operaciones en Cuenta Bancaria',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'depositCount',
    className: 'text-center',
    Footer: () => (
      <strong>{bankSummaryTotalValue(bankTotal, 'depositCount')}</strong>
    ),
  },
  {
    Header: 'Registrado FLIT',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'registeredAmount',
    className: 'text-right',
    Cell: (row) => bankSummaryAmount(row.value),
    Footer: () => (
      <strong>
        {bankSummaryAmount(
          bankSummaryTotalValue(bankTotal, 'registeredAmount'),
        )}
      </strong>
    ),
  },
  {
    Header: 'Confirmado banco',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'confirmedAmount',
    className: 'text-right',
    Cell: (row) => bankSummaryAmount(row.value),
    Footer: () => (
      <strong>
        {bankSummaryAmount(bankSummaryTotalValue(bankTotal, 'confirmedAmount'))}
      </strong>
    ),
  },
  {
    Header: 'Pendiente de cruce',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    id: 'unmatched',
    accessor: 'unmatchedAmount',
    className: 'text-right',
    Cell: (row) => (
      <BankReconciliationCountAmountCell
        count={row.original.unmatchedCount}
        amount={row.original.unmatchedAmount}
        highlightClassName="text-danger font-weight-bold"
      />
    ),
    Footer: () => (
      <strong>
        <BankReconciliationCountAmountCell
          count={bankSummaryTotalValue(bankTotal, 'unmatchedCount')}
          amount={bankSummaryTotalValue(bankTotal, 'unmatchedAmount')}
          highlightClassName="text-danger"
        />
      </strong>
    ),
  },
  {
    Header: 'Diferencia de monto',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    id: 'amountDifference',
    accessor: 'amountDifference',
    className: 'text-right',
    Cell: (row) => (
      <BankReconciliationCountAmountCell
        count={row.original.partialMatchCount}
        amount={row.original.amountDifference}
        highlightClassName="text-warning font-weight-bold"
      />
    ),
    Footer: () => (
      <strong>
        <BankReconciliationCountAmountCell
          count={bankSummaryTotalValue(bankTotal, 'partialMatchCount')}
          amount={bankSummaryTotalValue(bankTotal, 'amountDifference')}
          highlightClassName="text-warning"
        />
      </strong>
    ),
  },
];

const bankSummaryHighlightedCount = (highlightClassName) => (row) =>
  <span className={row.value ? highlightClassName : ''}>{row.value || 0}</span>;

export const BANK_RECONCILIATION_LIQUIDATION_SUMMARY_COLUMNS = [
  {
    Header: 'Liquidaciones',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'totalLiquidations',
    className: 'text-center',
  },
  {
    Header: 'Cubiertas',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'coveredLiquidations',
    className: 'text-center',
  },
  {
    Header: 'Depósito incompleto',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'incompleteLiquidations',
    className: 'text-center',
    Cell: bankSummaryHighlightedCount('text-warning font-weight-bold'),
  },
  {
    Header: 'Sin depósito',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'withoutDepositLiquidations',
    className: 'text-center',
    Cell: bankSummaryHighlightedCount('text-danger font-weight-bold'),
  },
  {
    Header: 'A depositar',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'amountToDeposit',
    className: 'text-right',
    Cell: (row) => bankSummaryAmount(row.value),
  },
  {
    Header: 'Depositado',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'amountDeposited',
    className: 'text-right',
    Cell: (row) => bankSummaryAmount(row.value),
  },
  {
    Header: 'Faltante',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'liquidationDifference',
    className: 'text-right',
    Cell: (row) => bankSummaryAmount(row.value),
  },
  {
    Header: 'Excedente',
    headerStyle: BANK_SUMMARY_HEADER_STYLE,
    accessor: 'surplus',
    className: 'text-right',
    Cell: (row) => bankSummaryAmount(row.value),
  },
];

const bankReconciliationSapDocumentStatus = ({
  label,
  enumObject,
  status,
  errorMessage,
  retryButton,
}) => (
  <div className={label ? 'mb-1' : ''}>
    {label ? <span className="d-block small text-muted">{label}</span> : null}
    <div>
      <EnumStatus enumObject={enumObject} enumValue={status} />
      {retryButton}
    </div>
    {errorMessage ? (
      <span
        className="d-block text-muted"
        style={{ fontSize: '.7rem' }}
        title={errorMessage}
      >
        {/* eslint-disable-next-line */}
        <i
          className="fa fa-copy"
          style={{ cursor: 'pointer', marginRight: '4px' }}
          onClick={() => {
            navigator.clipboard.writeText(errorMessage);
          }}
        />
        {errorMessage}
      </span>
    ) : null}
  </div>
);

export const BANK_RECONCILIATION_DEPOSIT_COLUMNS = (liquidationId) => [
  {
    Header: 'ID depósito',
    accessor: 'depositId',
    className: 'text-center',
    Cell: (row) => (
      <LinkToModuleResource
        href={`${DEPOSIT_PATH}/${row.value}`}
        text={row.value}
        colorIcon="text-primary"
      />
    ),
  },
  {
    Header: 'Entidad',
    accessor: 'bankName',
    className: 'text-center',
    Cell: (row) => (
      <span>
        <Badge color="secondary" text={row.value} />
        {row.original.shared ? (
          <Badge
            color="light"
            className="ml-1"
            text="compartido"
            title="Este depósito está asociado a más de una liquidación. Se muestra completo en cada una, pero en el total del día se cuenta una sola vez."
          />
        ) : null}
      </span>
    ),
    Footer: () => <strong>Total</strong>,
  },
  {
    Header: 'Registrado en FLIT',
    groupStyle: {
      background: 'rgba(91,42,134,.10)',
      borderBottom: '2px solid rgba(91,42,134,.35)',
    },
    columns: [
      {
        Header: 'Fecha depósito',
        accessor: 'depositDate',
        className: 'text-center',
        Cell: (row) => <DateCell value={row.value} />,
      },
      {
        Header: 'N° operación',
        accessor: 'operationNumber',
        className: 'text-center',
      },
      {
        Header: 'Cuenta',
        accessor: 'accountNumber',
        className: 'text-center',
      },
      {
        Header: 'Monto',
        accessor: 'amount',
        className: 'text-center',
        Cell: (row) => numberFormatter({ value: row.value }),
        Footer: bankReconciliationSumFooter('amount'),
      },
    ],
  },
  {
    Header: 'Reportado por el banco',
    groupStyle: {
      background: 'rgba(13,110,253,.08)',
      borderBottom: '2px solid rgba(13,110,253,.30)',
    },
    columns: [
      {
        Header: 'Fecha depósito',
        accessor: 'bankDepositDate',
        className: 'text-center',
        Cell: (row) => (row.value ? <DateCell value={row.value} /> : '-'),
      },
      {
        Header: 'N° operación',
        accessor: 'bankOperationNumber',
        className: 'text-center',
        Cell: (row) => row.value || '-',
      },
      {
        Header: 'Cuenta',
        accessor: 'bankAccountNumber',
        className: 'text-center',
        Cell: (row) => row.value || '-',
      },
      {
        Header: 'Monto',
        accessor: 'bankAmount',
        className: 'text-center',
        Cell: (row) =>
          row.value === null || row.value === undefined
            ? '-'
            : numberFormatter({ value: row.value }),
        Footer: bankReconciliationSumFooter('bankAmount'),
      },
      {
        Header: 'Diferencia',
        accessor: 'bankAmountDifference',
        className: 'text-center',
        Cell: (row) =>
          row.value === null || row.value === undefined ? (
            '-'
          ) : (
            <BankReconciliationDiffCell value={row.value} />
          ),
        Footer: bankReconciliationSumFooter('bankAmountDifference'),
      },
    ],
  },
  {
    Header: 'Migración a SAP',
    groupStyle: {
      background: 'rgba(0,0,0,.04)',
      borderBottom: '2px solid rgba(0,0,0,.15)',
    },
    columns: [
      {
        Header: 'Estado',
        accessor: 'migrationStatus',
        className: 'text-center',
        Cell: (row) => {
          const {
            depositId,
            sapRetryAvailable,
            lastErrorMessage,
            bankTransferStatus,
            bankTransferErrorMessage,
            bankTransferRetryAvailable,
          } = row.original;

          const incomingPaymentStatus = bankReconciliationSapDocumentStatus({
            label: bankTransferStatus ? 'Ingreso' : null,
            enumObject: DEPOSIT_MIGRATION_STATUS,
            status: row.value,
            errorMessage: lastErrorMessage,
            retryButton: sapRetryAvailable ? (
              <SapMigrationRetryButton
                depositId={depositId}
                liquidationId={liquidationId}
              />
            ) : null,
          });

          if (!bankTransferStatus) return incomingPaymentStatus;

          return (
            <>
              {incomingPaymentStatus}
              {bankReconciliationSapDocumentStatus({
                label: SAP_MIGRATION_DOCUMENT_TYPE.BANK_TRANSFER.label,
                enumObject: DEPOSIT_BANK_TRANSFER_STATUS,
                status: bankTransferStatus,
                errorMessage: bankTransferErrorMessage,
                retryButton: bankTransferRetryAvailable ? (
                  <SapMigrationRetryButton
                    depositId={depositId}
                    liquidationId={liquidationId}
                    documentType={
                      SAP_MIGRATION_DOCUMENT_TYPE.BANK_TRANSFER.value
                    }
                    title="Reintentar transferencia SAP"
                  />
                ) : null,
              })}
            </>
          );
        },
      },
      {
        Header: 'Fecha migración',
        accessor: 'migratedDate',
        className: 'text-center',
        Cell: (row) => {
          const { bankTransferStatus, bankTransferDate, sapTransferDocNum } =
            row.original;

          const incomingPaymentDate = row.value ? (
            <DateCell value={row.value} />
          ) : (
            '-'
          );

          if (!bankTransferStatus) return incomingPaymentDate;

          return (
            <>
              <div>{incomingPaymentDate}</div>
              <div className="mt-1">
                <span className="d-block small text-muted">
                  {SAP_MIGRATION_DOCUMENT_TYPE.BANK_TRANSFER.label}
                </span>
                {bankTransferDate ? <DateCell value={bankTransferDate} /> : '-'}
                {sapTransferDocNum ? (
                  <span className="d-block small text-muted">
                    {`Doc. SAP ${sapTransferDocNum}`}
                  </span>
                ) : null}
              </div>
            </>
          );
        },
      },
    ],
  },
  {
    Header: 'Resultado',
    accessor: 'matchResult',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={BANK_RECONCILIATION_DEPOSIT_RESULT}
        enumValue={row.value}
      />
    ),
  },
];

export const bankReconciliationManualVoucherPaymentColumns = ({
  manualVoucherId,
  corporate,
}) => [
  {
    Header: 'Pago',
    groupStyle: {
      background: 'rgba(0,0,0,.04)',
      borderBottom: '2px solid rgba(0,0,0,.15)',
    },
    columns: [
      {
        Header: 'ID pago',
        accessor: 'manualVoucherPaymentId',
        className: 'text-center',
        width: 90,
      },
      {
        Header: 'Entidad',
        accessor: 'bankName',
        Cell: (row) => row.value || '-',
      },
      {
        Header: 'Cuenta',
        accessor: 'accountNumber',
        className: 'text-center',
        Cell: (row) => row.value || '-',
      },
      {
        Header: 'N° operación',
        accessor: 'operationNumber',
        className: 'text-center',
        Cell: (row) => row.value || '-',
      },
      {
        Header: 'Fecha depósito',
        accessor: 'depositDate',
        className: 'text-center',
        Cell: (row) => (row.value ? <DateCell value={row.value} /> : '-'),
      },
      {
        Header: 'Monto',
        accessor: 'amount',
        className: 'text-center',
        Cell: (row) =>
          bankReconciliationCurrencyAmount(row.value, row.original.currency),
        Footer: bankReconciliationCurrencySumFooter('amount'),
      },
      {
        Header: 'Confirmado banco',
        accessor: 'approved',
        className: 'text-center',
        Cell: (row) =>
          row.value ? (
            <Badge color="success" text="Confirmado" />
          ) : (
            <Badge color="warning" text="Sin confirmar" />
          ),
      },
    ],
  },
  {
    Header: 'Migración a SAP',
    groupStyle: {
      background: 'rgba(0,100,200,.10)',
      borderBottom: '2px solid rgba(0,100,200,.35)',
    },
    columns: [
      {
        Header: 'Estado',
        accessor: 'migrationStatus',
        className: 'text-center',
        Cell: (row) => {
          const { manualVoucherPaymentId, sapErrorMessage, sapRetryAvailable } =
            row.original;

          if (!row.value) return '-';

          return bankReconciliationSapDocumentStatus({
            enumObject: DEPOSIT_MIGRATION_STATUS,
            status: row.value,
            errorMessage:
              row.value === DEPOSIT_MIGRATION_STATUS.FAILED.value
                ? sapErrorMessage
                : null,
            retryButton: sapRetryAvailable ? (
              <ManualVoucherPaymentSapRetryButton
                manualVoucherPaymentId={manualVoucherPaymentId}
                manualVoucherId={manualVoucherId}
                corporate={corporate}
              />
            ) : null,
          });
        },
      },
      {
        Header: 'Fecha migración',
        accessor: 'migratedDate',
        className: 'text-center',
        Cell: (row) => (row.value ? <DateCell value={row.value} /> : '-'),
      },
    ],
  },
];

export const DEPOSIT_MIGRATION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 70,
  },
  {
    Header: 'Fecha de carga',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    filterable: false,
  },
  {
    Header: 'Entidad',
    accessor: 'bankName',
    className: 'text-center',
    Cell: (row) => <Badge color="secondary" text={row.value} />,
    filterable: false,
    sortable: false,
  },
  {
    Header: 'Cuenta detectada',
    accessor: 'statementAccountNumber',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Archivo',
    accessor: 'fileName',
    Cell: (row) => (
      <LinkToModuleResource
        href={row.original.fileUrl}
        text={row.value}
        colorIcon="text-primary"
        isExternalPath
      />
    ),
  },
  {
    Header: 'Rango del archivo',
    id: 'statementRange',
    accessor: 'statementFrom',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <span>
          <DateCell value={row.value} /> -{' '}
          <DateCell value={row.original.statementTo} />
        </span>
      ) : (
        '-'
      ),
    filterable: false,
    sortable: false,
  },
  {
    Header: 'Movimientos',
    accessor: 'totalMovements',
    className: 'text-center',
    width: 100,
    filterable: false,
  },
  {
    Header: 'Resultado del cruce',
    id: 'movementBreakdown',
    accessor: 'processedCount',
    className: 'text-center',
    Cell: (row) =>
      bankReconciliationCountBadges(
        bankReconciliationEnumBreakdown(
          DEPOSIT_MIGRATION_MOVEMENT_CLASSIFICATION,
          {
            PROCESSED: row.original.processedCount,
            PARTIAL_MATCH: row.original.partialMatchCount,
            UNMATCHED: row.original.unmatchedCount,
            DISCARDED: row.original.discardedCount,
          },
        ),
      ),
    filterable: false,
    sortable: false,
  },
  {
    Header: 'Migrados / Fallidos',
    id: 'migrationBreakdown',
    accessor: 'migratedCount',
    className: 'text-center',
    Cell: (row) => (
      <span>
        <Badge color="success" className="mr-1" text={row.value} />
        <Badge
          color={row.original.failedCount > 0 ? 'danger' : 'light'}
          text={row.original.failedCount}
        />
      </span>
    ),
    filterable: false,
    sortable: false,
  },
  {
    Header: 'Creado por',
    id: 'operatorUserId',
    accessor: 'operatorUserName',
    className: 'text-center',
    dataType: ColumnFilterDataTypes.ARRAY,
    Filter: (row) => <UserFilter onChangeFilter={row.onChange} />,
    sortable: false,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={DEPOSIT_MIGRATION_FILE_STATUS}
        enumValue={row.value}
      />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
    Filter: (row) => (
      <EnumSelectFilter
        isMulti
        onChangeFilter={row.onChange}
        enumOptions={DEPOSIT_MIGRATION_FILE_STATUS}
      />
    ),
  },
];

export const DEPOSIT_MIGRATION_MOVEMENT_COLUMNS = [
  {
    Header: 'Archivo del banco',
    groupStyle: {
      background: 'rgba(13,110,253,.08)',
      borderBottom: '2px solid rgba(13,110,253,.30)',
    },
    columns: [
      {
        Header: 'Fila',
        accessor: 'sheetRowNumber',
        className: 'text-center',
        width: 60,
      },
      {
        Header: 'Fecha',
        accessor: 'operationDate',
        className: 'text-center',
        Cell: (row) => <DateCell value={row.value} />,
      },
      {
        Header: 'Descripción operación',
        accessor: 'description',
      },
      {
        Header: 'Sucursal',
        accessor: 'agencyCode',
        className: 'text-center',
        Cell: (row) => row.value || '-',
      },
      {
        Header: 'Operación',
        accessor: 'rawOperationNumber',
        className: 'text-center',
      },
      {
        Header: 'Monto',
        accessor: 'amount',
        className: 'text-center',
        Cell: (row) => numberFormatter({ value: row.value }),
      },
    ],
  },
  {
    Header: 'Normalizado',
    groupStyle: {
      background: 'rgba(91,42,134,.10)',
      borderBottom: '2px solid rgba(91,42,134,.35)',
    },
    columns: [
      {
        Header: 'Agencia',
        accessor: 'resolvedAgencyName',
        className: 'text-center',
        Cell: (row) => row.value || '-',
      },
      {
        Header: 'N° operación',
        accessor: 'normalizedOperationNumber',
        className: 'text-center',
        Cell: (row) => row.value || '-',
      },
    ],
  },
  {
    Header: 'Cruce contra FLIT',
    groupStyle: {
      background: 'rgba(0,0,0,.04)',
      borderBottom: '2px solid rgba(0,0,0,.15)',
    },
    columns: [
      {
        Header: 'Depósito / Pago',
        accessor: 'depositId',
        className: 'text-center',
        Cell: (row) => {
          if (row.value)
            return <Link to={`${DEPOSIT_PATH}/${row.value}`}>{row.value}</Link>;

          const { manualVoucherPaymentId } = row.original;

          return manualVoucherPaymentId ? (
            <Link
              to={`${MANUAL_VOUCHER_PAYMENT_PATH}/${manualVoucherPaymentId}`}
            >
              {`Pago ${manualVoucherPaymentId}`}
            </Link>
          ) : (
            '-'
          );
        },
      },
      {
        Header: 'Monto FLIT',
        accessor: 'depositAmount',
        className: 'text-center',
        Cell: (row) =>
          row.value === null || row.value === undefined
            ? '-'
            : numberFormatter({ value: row.value }),
      },
      {
        Header: 'Diferencia',
        accessor: 'matchedAmountDifference',
        className: 'text-center',
        Cell: (row) =>
          row.value === null || row.value === undefined ? (
            '-'
          ) : (
            <BankReconciliationDiffCell value={row.value} />
          ),
      },
      {
        Header: 'Resultado',
        accessor: 'classification',
        className: 'text-center',
        Cell: (row) => (
          <EnumStatus
            enumObject={DEPOSIT_MIGRATION_MOVEMENT_CLASSIFICATION}
            enumValue={row.value}
          />
        ),
      },
      {
        Header: 'Motivo',
        accessor: 'reason',
        Cell: (row) => row.value || '-',
        hoverPopover: (row) => row.reason,
      },
    ],
  },
];

export const FUEL_STATIONS_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'location.name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'location.description',
    className: 'text-center',
  },
  {
    Header: 'Empresa',
    accessor: 'business.name',
    className: 'text-center',
  },
];

export const EVENTS_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'URI',
    accessor: 'uri',
    className: 'text-center',
  },
  {
    Header: 'Método',
    accessor: 'method',
    className: 'text-center',
  },
  {
    Header: 'Usuario',
    accessor: 'user.customer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Inicio',
    accessor: 'startTime',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Duración',
    accessor: 'duration',
    className: 'text-center',
  },
];

export const IN_SYSTEM_NOTIFICATIONS_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Mensaje',
    accessor: 'message',
    className: 'text-center',
  },
  {
    Header: 'Gravedad',
    accessor: 'notificationSeverity',
    className: 'text-center',
    Cell: (row) => <Badge color={row.value.toLowerCase()} text={row.value} />,
  },
  {
    Header: 'Valido Desde',
    accessor: 'validFrom',
    className: 'text-center',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Valido Hasta',
    accessor: 'validUntil',
    className: 'text-center',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Usuario',
    accessor: 'userId',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(IN_SYSTEM_NOTIFICATION_SEVERITY)}
      />
    ),
  },
  {
    Header: 'Fecha de creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    filterable: false,
  },
];

export const EXPENSE_STATUS_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Agencia',
    accessor: 'agencyName',
    id: 'agencyName',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Beneficiario',
    accessor: 'payeeCustomerName',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
    width: 350,
  },
  {
    Header: 'Total',
    accessor: 'total',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Nuevo Monto',
    accessor: 'newAmount',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Tipo de egreso',
    accessor: 'expenseTypeName',
    id: 'expenseTypeName',
    Cell: (row) => {
      if (!row.value) return null;

      const expenseTypeList = [
        {
          text: row.value,
        },
      ];

      return <BadgeList cell textArray={expenseTypeList} />;
    },
    className: 'text-center',
    width: 120,
  },
  {
    Header: 'Centro de Costo',
    accessor: 'costCenter.name',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Tipo de comprobante',
    accessor: 'voucherTypeName',
    id: 'voucherTypeName',
    Cell: (row) => {
      if (!row.value) return null;

      const voucherTypeList = [
        {
          text: row.value,
        },
      ];

      return <BadgeList cell textArray={voucherTypeList} />;
    },
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Razón Social',
    accessor: 'businessName',
    id: 'businessName',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    Cell: (row) => padStart(row.value, 7),
    className: 'text-center',
  },
  {
    Header: 'RUC',
    accessor: 'businessTaxId',
    id: 'businessTaxId',
    className: 'text-center',
    width: 120,
  },
  {
    Header: 'Estado',
    accessor: 'expenseStatus',
    Cell: (row) => EXPENSE_STATUS[row.value].label,
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Autorizador',
    accessor: 'authorizerUserName',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Acción',
    className: 'text-center',
    accessor: 'id',
    Cell: (row) => (
      <i
        tabIndex={0}
        role="button"
        className="fa fa-search	text-info"
        style={{ cursor: 'pointer' }}
        onClick={(event) => {
          event.stopPropagation();
          window.open(`${EXPENSE_PATH}/${row.value}`, '_blank');
        }}
        onKeyPress={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.stopPropagation();
            window.open(`${EXPENSE_PATH}/${row.value}`, '_blank');
          }
        }}
      />
    ),
  },
];

export const ITINERARY_GROUPS_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Circuito',
    accessor: 'circuitId',
    className: 'text-center',
  },
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => ITINERARY_GROUP_STATUS[row.value].label,
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(ITINERARY_GROUP_STATUS)}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Itinerarios asociados',
    accessor: 'circuitGroupItineraryList',
    Cell: (row) => row.value.length,
    className: 'text-center',
  },
];

export const BASE_FUEL_REFILL_COLUMNS = [
  {
    Header: 'ID de Itinerario',
    accessor: 'itineraryId',
    Cell: (row) => {
      let itineraryId = row.value;

      if (row.original.duplicated)
        itineraryId = <Badge color="danger" text={row.value} />;

      return itineraryId;
    },
    className: 'text-center',
  },
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    id: 'registeredBusId',
    Filter: (row) => <RegisteredBusFilter onChangeFilter={row.onChange} />,
    className: 'text-center',
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => tzNormalizeDate({ date: row.value, format: DATE_FORMAT }),
    className: 'text-center',
  },
  {
    Header: 'Combustible Abastecido',
    accessor: 'fuelQuantity',
    Cell: (row) =>
      `${numberFormatter({
        style: 'decimal',
        value: row.value,
        minimumFractionDigits: 2,
      })} ${MATERIAL_MEASUREMENT_UNIT[1]}`,
    className: 'text-center',
  },
  {
    Header: 'AdBlue Abastecido',
    accessor: 'adblueQuantity',
    Cell: (row) =>
      `${numberFormatter({
        style: 'decimal',
        value: row.value,
        minimumFractionDigits: 2,
      })} ${MATERIAL_MEASUREMENT_UNIT[1]}`,
    className: 'text-center',
  },
];

export const ITINERARY_SALES_CONTROL_COLUMNS = [
  {
    className: 'text-center',
    Expander: (expander) => {
      if (expander.isExpanded) return <i className="fa fa-caret-up" />;
      return <i className="fa fa-caret-down" />;
    },
    getProps: () => ({
      className: 'show-pointer',
    }),
    expander: true,
  },
  {
    Header: 'Fecha de Salida',
    accessor: 'departuretime',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
    width: 150,
  },
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
    Cell: (row) => (
      <Link to={`${ITINERARY_PATH}/${row.value}`} target="_blank">
        {row.value}
      </Link>
    ),
    width: 100,
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
    width: 280,
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
    width: 280,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Hora de Salida',
    accessor: 'departuretime',
    className: 'text-center',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
    width: 130,
  },
  {
    Header: 'Capacidad de Asiento',
    accessor: 'numberOfSeats',
    className: 'text-center',
    width: 175,
  },
  {
    Header: 'Asientos Vendidos',
    accessor: 'soldSeats',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Ocupabilidad',
    accessor: 'occupancy',
    className: 'text-center',
    Cell: (row) => `${row.value}%`,
    width: 110,
  },
  {
    Header: 'Precio Inicial',
    columns: [
      {
        Header: 'Precio I. 1',
        accessor: 'prices',
        className: 'text-center',
        width: 120,
        Cell: (row) => row.value && numberFormatter({ value: row.value[0] }),
        filterable: false,
      },
      {
        Header: 'Precio I. 2',
        accessor: 'prices',
        className: 'text-center',
        width: 120,
        Cell: (row) => row.value && numberFormatter({ value: row.value[1] }),
        filterable: false,
      },
    ],
  },
  {
    Header: 'Precio Final',
    columns: [
      {
        Header: 'Precio F. 1',
        accessor: 'prices',
        className: 'text-center',
        width: 120,
        Cell: (row) => row.value && numberFormatter({ value: row.value[2] }),
        filterable: false,
      },
      {
        Header: 'Precio F. 2',
        accessor: 'prices',
        className: 'text-center',
        width: 120,
        Cell: (row) => row.value && numberFormatter({ value: row.value[3] }),
        filterable: false,
      },
    ],
  },
  {
    Header: 'Rentabilidad',
    accessor: 'profitability',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
    width: 110,
  },
  {
    Header: 'Rentabilidad Total',
    accessor: 'totalProfitability',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
    width: 150,
  },
  {
    Header: 'Programado',
    accessor: 'scheduled',
    Cell: (row) => <Checkbox checked={row.value} />,
    className: 'text-center',
    width: 110,
  },
  {
    Header: 'Estado',
    accessor: 'active',
    Cell: (row) => <IsActive value={row.value} />,
    className: 'text-center',
    width: 80,
  },
  {
    Header: 'Tipo de Itinerario',
    accessor: 'type',
    className: 'text-center',
    width: 140,
  },
  {
    Header: 'Ingreso Pasaje',
    accessor: 'ticketIncome',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
    width: 140,
  },
  {
    Header: 'Ingreso Carga',
    accessor: 'loadIncome',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
    width: 140,
  },
  {
    Header: 'Ingreso Equipajes',
    accessor: 'excessBaggageIncome',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
    width: 150,
  },
  {
    Header: 'Costo de Operación',
    accessor: 'operationalCost',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
    width: 160,
  },
  {
    Header: 'Kilometraje',
    accessor: 'kilometers',
    className: 'text-center',
    Cell: (row) => `${row.value} ${KILOMETER_SYMBOL}`,
    width: 140,
  },
];

export const ITINERARY_SALES_CONTROL_DETAIL_COLUMNS = [
  {
    Header: 'Fecha de Compra',
    accessor: 'documentAssignmentDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
    width: 150,
  },
  {
    Header: 'Hora de Compra',
    accessor: 'documentAssignmentDate',
    className: 'text-center',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
    width: 130,
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocation',
    className: 'text-center',
    // width: 280,
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocation',
    className: 'text-center',
    // width: 280,
  },
  {
    Header: 'Tipo de Comprobante',
    accessor: 'voucherType',
    className: 'text-center',
    // width: 280,
  },
  {
    Header: 'Asiento',
    accessor: 'seatNumber',
    className: 'text-center',
    width: 80,
  },
  {
    Header: 'Número de Boleto',
    accessor: 'ticketCode',
    className: 'text-center',
    Cell: (row) => (
      <Link to={`${TICKET_PATH}/${row.original.ticketId}`} target="_blank">
        {row.value}
      </Link>
    ),
    width: 160,
  },
  {
    Header: 'Nombre de Pasajero',
    accessor: 'customerName',
    className: 'text-center',
    // width: 280,
  },
  {
    Header: 'Teléfono',
    accessor: 'customerPhoneNumber',
    className: 'text-center',
    width: 140,
  },
  {
    Header: 'Email',
    accessor: 'customerMail',
    className: 'text-center',
    // width: 280,
  },
  {
    Header: 'Precio Lista',
    accessor: 'listPrice',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
    width: 140,
  },
  {
    Header: 'Precio Venta',
    accessor: 'salePrice',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value }),
    width: 140,
  },
  {
    Header: 'Embarque',
    accessor: 'embarking',
    className: 'text-center',
    // width: 280,
  },
  {
    Header: 'Desembarque',
    accessor: 'disembarking',
    className: 'text-center',
    // width: 280,
  },
  {
    Header: 'Agencia de Venta',
    accessor: 'sellingAgency',
    className: 'text-center',
    // width: 280,
  },
  {
    Header: 'Tipo de Pago',
    accessor: 'paymentType',
    className: 'text-center',
    // width: 160,
  },
];

export const SEGMENT_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Distancia',
    accessor: 'distance',
    className: 'text-center',
    Cell: (row) => `${row.value} ${KILOMETER_SYMBOL}`,
  },
  {
    Header: 'Duración',
    accessor: 'duration',
    className: 'text-center',
    Cell: (row) => `${row.value} ${MINUTE_SYMBOL}`,
  },
];

export const DRIVER_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'customer.firstName',
    className: 'text-center',
  },
  {
    Header: 'Apellido',
    accessor: 'customer.lastName',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Documento',
    accessor: 'customer.identificationType.name',
    Cell: (row) => row.value || null,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Número de Documento',
    accessor: 'customer.idDocumentNumber',
    Cell: (row) => row.value || null,
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'crewStatus.id',
    Cell: (row) => <DriverStatusCell value={row.value} />,
    className: 'text-center',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(DRIVER_STATUS_OPTION)}
      />
    ),
  },
];

export const DRIVER_TRIPS_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'departureTime',
    Cell: (row) =>
      tzNormalizeDate({ date: row.value, format: DATE_TIME_FORMAT }),
    className: 'text-center',
  },
  {
    Header: 'Número de Bus',
    accessor: 'companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    accessor: 'route.name',
    className: 'text-center',
  },
  {
    Header: 'KM',
    accessor: 'route.routeSegmentList',
    Cell: (row) => {
      const km = row.value.reduce(
        (accumulated, currentValue) =>
          accumulated + currentValue.segment.distance,
        0,
      );

      return km.toFixed(2);
    },
    className: 'text-center',
  },
  {
    Header: 'Horas',
    accessor: 'route.routeSegmentList',
    Cell: (row) =>
      row.value.reduce(
        (accumulated, currentValue) =>
          accumulated + currentValue.segment.duration,
        0,
      ),
    className: 'text-center',
  },
  {
    Header: 'Rendimiento',
    accessor: 'city.region.country.name',
    className: 'text-center',
  },
  {
    Header: 'Condición de Trabajo',
    accessor: 'city.region.country.name',
    className: 'text-center',
  },
];

export const PRIVATE_SERVICE_COLUMNS = [
  {
    Header: 'N° de Documento',
    accessor: 'business.businessTaxId',
    Cell: (row) => {
      const {
        original: { customer, business },
      } = row;
      const data = customer
        ? `${customer.identificationType.name}: ${customer.idDocumentNumber}`
        : `RUC: ${business.businessTaxId}`;

      return data;
    },
    className: 'text-center',
    width: 170,
  },
  {
    Header: 'Razón Social/Nombre',
    accessor: 'business.name',
    Cell: (row) => {
      const {
        original: { customer, business },
      } = row;
      const data = customer ? customer.fullName : business.name;

      return data;
    },
    className: 'text-center',
    filterable: false,
    width: 230,
  },
  {
    Header: 'Número de Contrato',
    accessor: 'contractNumber',
    className: 'text-center',
    width: 170,
  },
  {
    Header: 'Unidades',
    accessor: 'numberOfBusses',
    className: 'text-center',
    width: 60,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Origen',
    accessor: 'source',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Destino',
    accessor: 'destination',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Fecha de Contrato',
    accessor: 'createDate',
    Cell: (row) => tzNormalizeDate({ date: row.value, format: DATE_FORMAT }),
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 140,
  },
  {
    Header: 'Estado',
    accessor: 'contractStatus',
    Cell: (row) => (
      <EnumStatus enumObject={CONTRACT_STATUS} enumValue={row.value} />
    ),
    className: 'text-center',
    filterable: false,
    width: 100,
  },
  {
    Header: 'Monto',
    accessor: 'totalAmount',
    Cell: (row) => row.value && numberFormatter({ value: row.value }),
    className: 'text-right',
    width: 130,
  },
  {
    Header: 'Nombre del Ejecutivo',
    accessor: 'executiveName',
    className: 'text-center',
    width: 210,
  },
  {
    Header: 'Telf. del Ejecutivo',
    accessor: 'executivePhone',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const CREDIT_NOTE_COLUMNS = [
  {
    Header: 'Estado',
    accessor: 'valid',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(CREDIT_NOTE_STATUS_OPTIONS)}
      />
    ),
    width: 170,
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
    width: 140,
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
    width: 180,
  },
  {
    Header: 'Cliente',
    accessor: 'customerId',
    className: 'text-center',
    Cell: (row) =>
      `${row.original.customerIdDocumentNumber} (${row.original.customerIdCountryOfOrigin}) - ${row.original.customerFullName}`,
    Filter: (row) => <CustomerFilter onChangeFilter={row.onChange} />,
    width: 520,
  },
  {
    Header: 'Empresa',
    accessor: 'businessId',
    className: 'text-center',
    Cell: (row) =>
      row.original.business
        ? `${row.original.businessTaxId} - ${row.original.businessName}`
        : '',
    Filter: (row) => <BusinessFilter onChangeFilter={row.onChange} />,
    width: 400,
  },
  {
    Header: 'Referencia',
    accessor: 'reference',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    className: 'text-center',
    Cell: (row) => row.value && numberFormatter({ value: row.value }),
    width: 180,
  },
  {
    Header: 'Fecha de Expiración',
    accessor: 'expirationDate',
    className: 'text-center',
    Cell: (row) => tzNormalizeDate({ date: row.value, format: DATE_FORMAT }),
    width: 200,
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const ITINERARY_STATUS_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
    width: 60,
  },
  {
    Header: 'Ruta',
    accessor: 'routeName',
    className: 'text-center',
    width: 450,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Número de Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Activo',
    accessor: 'active',
    Cell: (row) => <Checkbox checked={row.value || false} />,
    className: 'text-center',
    width: 80,
  },
  {
    Header: 'Salida',
    accessor: 'departuretime',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Boletos Vendidos',
    accessor: 'ticketsSold',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Tipo de Itinerario',
    accessor: 'type',
    Cell: (row) => ITINERARY_TYPE[row.value.toLowerCase()].label,
    className: 'text-center',
    width: 220,
  },
];

export const generateManualVoucherColumns = (voucherTypeCleanupOnUnmount) => [
  {
    Header: 'N° de Documento',
    accessor: 'business.businessTaxId',
    Cell: (row) => {
      const {
        original: { customer, business },
      } = row;
      const data = customer
        ? `${customer.identificationType.name}: ${customer.idDocumentNumber}`
        : `RUC: ${business.businessTaxId}`;

      return data;
    },
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Razón Social/Nombre',
    accessor: 'business.name',
    Cell: (row) => {
      const {
        original: { customer, business },
      } = row;
      const data = customer ? customer.fullName : business.name;

      return data;
    },
    className: 'text-center',
    filterable: false,
    width: 350,
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
    width: 130,
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    Cell: (row) => padStart(row.value, 7),
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Tipo de Comprobante',
    accessor: 'voucherType.name',
    id: 'voucherTypeId',
    Filter: (row) => (
      <VoucherTypeFilter
        onChangeFilter={row.onChange}
        cleanupOnUnmount={voucherTypeCleanupOnUnmount}
      />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    width: 300,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType',
    Cell: (row) => MANUAL_VOUCHER_SERVICE_TYPE[row.value].label,
    className: 'text-center',
    filterable: false,
    width: 150,
  },
  {
    Header: 'Fecha de Expedición',
    accessor: 'issueDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 180,
  },
  {
    Header: 'Tipo de Pago',
    accessor: 'paymentType',
    Cell: (row) => MANUAL_VOUCHER_PAYMENT_TYPE[row.value].label,
    className: 'text-center',
    filterable: false,
    width: 160,
  },
  {
    Header: 'Cuotas',
    accessor: 'installments',
    Cell: (row) => (row.value || row.value > 0 ? row.value : '-'),
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Fecha de Expiración',
    accessor: 'dueDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 180,
  },
  {
    Header: 'Total Gravada',
    accessor: 'totalAmountWithoutTaxes',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'Total IGV 18%',
    accessor: 'taxes',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'Importe Total',
    accessor: 'totalAmount',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'Detracción %',
    accessor: 'detraction',
    Cell: (row) => numberFormatter({ value: row.value, style: 'percent' }),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'Monto Detracción',
    accessor: 'detractionAmount',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'Total a Pagar',
    accessor: 'totalAmountPayable',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const generateCreditNoteManualVoucherColumns = (useForCreditNote) => [
  {
    Header: 'N° de Documento',
    accessor: 'business.businessTaxId',
    Cell: (row) => {
      const {
        original: { customer, business },
      } = row;
      const data = customer
        ? `${customer.identificationType.name}: ${customer.idDocumentNumber}`
        : `RUC: ${business.businessTaxId}`;

      return data;
    },
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Razón Social/Nombre',
    accessor: 'business.name',
    Cell: (row) => {
      const {
        original: { customer, business },
      } = row;
      const data = customer ? customer.fullName : business.name;

      return data;
    },
    className: 'text-center',
    filterable: false,
    width: 350,
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
    width: 130,
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    Cell: (row) => padStart(row.value, 7),
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Tipo de Comprobante',
    accessor: 'voucherType.name',
    id: 'voucherTypeId',
    className: 'text-center',
    width: 300,
    filterable: false,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType',
    Cell: (row) => MANUAL_VOUCHER_SERVICE_TYPE[row.value].label,
    className: 'text-center',
    filterable: false,
    width: 150,
  },
  {
    Header: 'Fecha de Expedición',
    accessor: 'issueDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 180,
  },
  {
    Header: 'Tipo de Pago',
    accessor: 'paymentType',
    Cell: (row) => MANUAL_VOUCHER_PAYMENT_TYPE[row.value].label,
    className: 'text-center',
    filterable: false,
    width: 160,
  },
  {
    Header: 'Cuotas',
    accessor: 'installments',
    Cell: (row) => (row.value || row.value > 0 ? row.value : '-'),
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Fecha de Expiración',
    accessor: 'dueDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 180,
  },
  {
    Header: 'Total Gravada',
    accessor: 'totalAmountWithoutTaxes',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'Total IGV 18%',
    accessor: 'taxes',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'Importe Total',
    accessor: 'totalAmount',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={GENERAL_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(GENERAL_STATUS)}
      />
    ),
    className: 'text-right',
    width: 180,
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <ManualVoucherActionsCell
        id={row.original.id}
        status={row.original.status}
        useForCreditNote={useForCreditNote}
      />
    ),
    width: 150,
    filterable: false,
    notNavigateToModel: true,
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const ORGANIZATION_CHART_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
    minWidth: 320,
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
    minWidth: 320,
  },
  {
    Header: 'Tipo',
    accessor: 'companyAreaType.name',
    Filter: (row) => <HierarchyFilter onChangeFilter={row.onChange} />,
    id: 'companyAreaTypeId',
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    minWidth: 220,
  },
  {
    Header: 'Organigrama Padre',
    accessor: 'parentCompanyArea.name',
    className: 'text-center',
    minWidth: 320,
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const MECHANIC_COLUMNS = [
  {
    Header: 'Tipo de Documento',
    accessor: 'customer.identificationType.name',
    className: 'text-center',
    minWidth: 150,
  },
  {
    Header: 'Número de Documento',
    accessor: 'customer.idDocumentNumber',
    className: 'text-center',
    minWidth: 150,
  },
  {
    Header: 'Nombres',
    accessor: 'customer.firstName',
    className: 'text-center',
    minWidth: 200,
  },
  {
    Header: 'Apellidos',
    accessor: 'customer.lastName',
    className: 'text-center',
    minWidth: 200,
  },
  {
    Header: 'Tipo de Trabajador',
    accessor: 'employeeType',
    Cell: (row) =>
      row.value && MECHANIC_EMPLOYEE_TYPE[row.value]
        ? MECHANIC_EMPLOYEE_TYPE[row.value].label
        : '-',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(MECHANIC_EMPLOYEE_TYPE)}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Fecha de Cese',
    accessor: 'terminationDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Especialidad',
    accessor: 'speciality.name',
    Cell: (row) => row.value || '-',
    className: 'text-center',
    minWidth: 220,
  },
  {
    Header: 'Sección',
    accessor: 'section.name',
    Cell: (row) => row.value || '-',
    className: 'text-center',
    minWidth: 220,
  },
  {
    Header: 'Área',
    accessor: 'area.name',
    Cell: (row) => row.value || '-',
    className: 'text-center',
    minWidth: 220,
  },
  {
    Header: 'Departamento',
    accessor: 'department.name',
    Cell: (row) => row.value || '-',
    className: 'text-center',
    minWidth: 220,
  },
  {
    Header: 'Gerencia',
    accessor: 'management.name',
    Cell: (row) => row.value || '-',
    className: 'text-center',
    minWidth: 220,
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    minWidth: 100,
  },
];

export const ACTIVITY_COLUMNS = [
  {
    Header: 'Código',
    accessor: 'companyActivityId',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Acción',
    accessor: 'action',
    Cell: (row) =>
      row.value && ACTIVITY_ACTION[row.value]
        ? ACTIVITY_ACTION[row.value].label
        : '-',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(ACTIVITY_ACTION)}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Nombre de la Actividad',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Sistema',
    accessor: 'maintenanceActivitySystem.name',
    className: 'text-center',
  },
  {
    Header: 'Subsistema',
    accessor: 'maintenanceActivitySubsystem.name',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Mantenimiento',
    accessor: 'activityType',
    Cell: (row) =>
      row.value && MAINTENANCE_ACTIVITY_TYPE[row.value]
        ? MAINTENANCE_ACTIVITY_TYPE[row.value].label
        : '-',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(MAINTENANCE_ACTIVITY_TYPE)}
      />
    ),
    className: 'text-center',
  },
];

export const ENDPOINT_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    accessor: 'route',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Permiso',
    accessor: 'permissionType',
    Cell: (row) =>
      row.value ? ENDPOINT_PERMISSION_TYPE[row.value].label : '-',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(ENDPOINT_PERMISSION_TYPE)}
      />
    ),
    className: 'text-center',
  },
];

export const BUS_ACTIVITY_ASSIGNMENT_COLUMNS = [
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    id: 'registeredBusId',
    Filter: (row) => (
      <RegisteredBusFilter onChangeFilter={row.onChange} isMulti />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    minWidth: 160,
  },
  {
    Header: 'Actividad',
    accessor: 'activityName',
    id: 'activity.name',
    className: 'text-center',
    minWidth: 200,
  },
  {
    Header: 'Código de Actividad',
    accessor: 'companyActivityId',
    id: 'activity.companyActivityId',
    className: 'text-center',
    width: 180,
  },
];

export const MAINTENANCE_ACTIVITY_HISTORY_COLUMNS = [
  {
    Header: 'Bus/Recurso',
    accessor: 'companyBusIdOrResourceName',
    className: 'text-center',
    minWidth: 100,
  },
  {
    Header: 'Area',
    accessor: 'areaName',
    className: 'text-center',
    Filter: (row) => (
      <OrganizationChartSelect
        useForFilter
        labelAsValue
        onChangeFilter={row.onChange}
        isClearable
      />
    ),
  },
  {
    Header: 'Código Actividad',
    accessor: 'companyActivityId',
    className: 'text-center',
    minWidth: 100,
  },
  {
    Header: 'Orden de Actividad del Plan',
    accessor: 'activityOrder',
    className: 'text-center',
    minWidth: 100,
  },
  {
    Header: 'Actividad',
    accessor: 'activityName',
    className: 'text-center',
    minWidth: 320,
  },
  {
    Header: 'Factor',
    accessor: 'factor',
    Cell: (row) =>
      numberFormatter({
        style: 'decimal',
        value: row.value,
        minimumFractionDigits: 0,
      }),
    className: 'text-center',
    minWidth: 120,
  },
  {
    Header: 'Orden de Servicio',
    accessor: 'serviceOrderId',
    className: 'text-center',
    Cell: (row) => (
      <Link
        to={`${MAINTENANCE_SERVICE_ORDER_PATH}/${row.value}`}
        target="_blank"
      >
        {row.value}
      </Link>
    ),
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={ACTIVITY_STATUS} enumValue={row.value} />
    ),
    className: 'text-center',
    minWidth: 120,
  },
  {
    Header: 'Personal',
    accessor: 'employeeList',
    Cell: (row) => {
      if (!row.value) return null;
      const employeeList = row.value.map((employee) => ({
        text: employee.fullName,
      }));
      return <BadgeList cell textArray={employeeList} />;
    },
    className: 'text-center',
    minWidth: 320,
  },
  {
    Header: 'Fecha/Hora Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    minWidth: 180,
  },
  {
    Header: 'Fecha/Hora Final',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    minWidth: 180,
  },
];

export const MATERIAL_COLUMNS = [
  {
    Header: 'Código',
    accessor: 'externalId',
    className: 'text-center',
    minWidth: 180,
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
    minWidth: 320,
  },
  {
    Header: 'Unidad de Medida',
    accessor: 'measurementUnit',
    className: 'text-center',
    minWidth: 180,
  },
];

export const generateKidOnItineraryColumns = (onClickRemoveKidOnItinerary) => [
  {
    Header: 'Adulto Responsable',
    columns: [
      {
        Header: '',
        className: 'text-center',
        width: 50,
        Cell: (row) => {
          const {
            original: { id, itineraryId },
          } = row;

          return (
            <div className="actionsContainer">
              <i
                tabIndex="0"
                role="button"
                className="fa fa-times text-danger"
                onKeyPress={() => onClickRemoveKidOnItinerary(id, itineraryId)}
                onClick={() => onClickRemoveKidOnItinerary(id, itineraryId)}
              />
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: 'Doc. Ident. Pasajero',
        accessor: 'parentCustomer.idDocumentNumber',
        Cell: (row) => (
          <div>
            {row.original.parentCustomer &&
            row.original.parentCustomer.identificationType
              ? row.original.parentCustomer.identificationType.name
              : '-'}
            : {row.value} (
            {row.original.parentCustomer &&
              row.original.parentCustomer.idCountryOfOrigin}
            )
          </div>
        ),
        className: 'text-center',
        minWidth: 180,
      },
      {
        Header: 'Nombre Completo Pasajero',
        accessor: 'parentCustomer.fullName',
        className: 'text-center',
        minWidth: 250,
      },
      {
        Header: 'Asiento',
        accessor: 'seatNumber',
        className: 'text-center',
        Cell: (row) => row.value || '-',
        minWidth: 80,
      },
      {
        Header: 'Piso',
        accessor: 'floorNumber',
        className: 'text-center',
        Cell: (row) => row.value || '-',
        minWidth: 60,
      },
    ],
  },
  {
    Header: 'Menor de Edad',
    columns: [
      {
        Header: 'Doc. Ident. Menor de Edad',
        accessor: 'kidCustomer.idDocumentNumber',
        Cell: (row) => (
          <i>
            {row.original.kidCustomer.identificationType
              ? row.original.kidCustomer.identificationType.name
              : '-'}
            : {row.value} ({row.original.kidCustomer.idCountryOfOrigin})
          </i>
        ),
        className: 'text-center',
        minWidth: 180,
      },
      {
        Header: 'Nombre Completo Menor de Edad',
        accessor: 'kidCustomer.fullName',
        Cell: (row) => <i>{row.value}</i>,
        className: 'text-center',
        minWidth: 250,
      },
      {
        Header: 'Asiento',
        accessor: 'kidSeatNumber',
        className: 'text-center',
        Cell: (row) => row.value || '-',
        minWidth: 80,
      },
      {
        Header: 'Piso',
        accessor: 'kidFloorNumber',
        className: 'text-center',
        Cell: (row) => row.value || '-',
        minWidth: 60,
      },
    ],
  },
  {
    Header: 'Relación con el Menor',
    accessor: 'relationship',
    Cell: (row) => (row.value ? RELATIONSHIP_TO_MINOR[row.value].label : '-'),
    className: 'text-center',
    minWidth: 180,
  },
  {
    Header: 'Permiso N.',
    accessor: 'notarizedPermit',
    className: 'text-center',
  },
  {
    Header: 'Observaciones',
    accessor: 'comments',
    className: 'text-center',
    minWidth: 250,
  },
];

export const ACTIVITY_PROJECTION_COLUMNS = [
  {
    Header: 'Bus/Recurso',
    accessor: 'companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Marca de Bus/Recurso',
    accessor: 'busMake',
    className: 'text-center',
  },
  {
    Header: 'Area',
    accessor: 'areaName',
    className: 'text-center',
    Filter: (row) => (
      <OrganizationChartSelect
        useForFilter
        labelAsValue
        onChangeFilter={row.onChange}
        isClearable
      />
    ),
  },
  {
    Header: 'Código Actividad',
    accessor: 'companyActivityId',
    className: 'text-center',
  },
  {
    Header: 'Actividad',
    accessor: 'activityDescription',
    className: 'text-center',
  },
  {
    Header: 'Factor Actividad',
    accessor: 'factor',
    Cell: (row) =>
      numberFormatter({
        style: 'decimal',
        value: row.value,
        minimumFractionDigits: 0,
      }),
    className: 'text-center',
  },
  {
    Header: 'Factor Extendido',
    accessor: 'extensionFactor',
    Cell: (row) =>
      row.value != null
        ? numberFormatter({
            style: 'decimal',
            value: row.value,
            minimumFractionDigits: 0,
          })
        : '-',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Ultima Ejecución',
    accessor: 'executionDate',
    className: 'text-center',
  },
  {
    Header: 'Tipo Factor',
    accessor: 'factorType',
    Cell: (row) => MAINTENANCE_FACTOR_TYPE[row.value].label,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Km. Recorrido/Días Transcurridos',
    accessor: 'factorQuantity',
    Cell: (row) =>
      numberFormatter({
        style: 'decimal',
        value: row.value,
        minimumFractionDigits: 0,
      }),
    className: 'text-center',
  },
  {
    Header: 'Factor Restante/Excedido',
    accessor: 'factorQuantity',
    Cell: (row) => {
      const {
        activityStatus,
        resource,
        lastExtensionFactor,
        factor,
        accumulatedFactor,
        extensionLimit,
        busActualOdometer,
      } = row.original;

      let value;

      if (activityStatus === ACTIVITY_STATUS.EXTENDED.value) {
        if (resource) {
          // Mantener lógica existente para recursos
          if (lastExtensionFactor == null || row.value == null) {
            return '-';
          }

          value = lastExtensionFactor - row.value;
        } else {
          // Para buses:
          // límite de extensión - odómetro actual
          if (extensionLimit == null || busActualOdometer == null) {
            return '-';
          }

          value = extensionLimit - busActualOdometer;
        }
      } else {
        if (factor == null) {
          return '-';
        }

        if (resource) {
          if (row.value == null) {
            return '-';
          }

          value = row.value - factor;
        } else {
          if (accumulatedFactor == null) {
            return '-';
          }

          value = accumulatedFactor - factor;
        }
      }

      return numberFormatter({
        style: 'decimal',
        value,
        minimumFractionDigits: 0,
      });
    },
    className: 'text-center',
  },
  {
    Header: 'Estado de Alerta',
    accessor: 'activityStatus',
    Cell: (row) => (
      <EnumStatus
        enumObject={MAINTENANCE_WARNING_STATUS_ACTIVITY}
        enumValue={row.value}
      />
    ),
    className: 'text-center',
  },
];

export const BUSINESS_COLUMNS = [
  {
    Header: 'RUC',
    accessor: 'businessTaxId',
    className: 'text-center',
    minWidth: 150,
  },
  {
    Header: 'Razón Social',
    accessor: 'name',
    className: 'text-center',
    minWidth: 250,
  },
  {
    Header: 'Fecha Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} />,
    className: 'text-center',
    minWidth: 120,
  },
  {
    Header: 'Contacto',
    accessor: 'primaryContact',
    className: 'text-center',
    minWidth: 200,
  },
  {
    Header: 'Teléfono',
    accessor: 'phone',
    className: 'text-center',
    minWidth: 120,
  },
  {
    Header: 'Email',
    accessor: 'email',
    className: 'text-center',
    minWidth: 200,
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const generateExecutionRegistrationColumns = ({
  handleConfirm,
  handleClear,
}) => [
  {
    Header: '',
    className: 'text-center',
    Cell: (row) => (
      <ActionsCell
        handleConfirm={handleConfirm}
        handleClear={handleClear}
        data={row.original}
        id={row.index}
        showClearButton={!!row.original.mechanics}
      />
    ),
    width: 100,
    filterable: false,
  },
  {
    Header: 'Area',
    accessor: 'areaName',
    className: 'text-center',
    Filter: (row) => (
      <OrganizationChartSelect
        useForFilter
        labelAsValue
        onChangeFilter={row.onChange}
      />
    ),
    minWidth: 220,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={ACTIVITY_STATUS} enumValue={row.value} />
    ),
    className: 'text-center',
    minWidth: 100,
    filterable: false,
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    minWidth: 70,
  },
  {
    Header: 'Código Actividad',
    accessor: 'companyActivityId',
    className: 'text-center',
    minWidth: 100,
  },
  {
    Header: 'Actividad',
    accessor: 'activityName',
    className: 'text-center',
    minWidth: 320,
  },
  {
    Header: 'Factor',
    accessor: 'factor',
    Cell: (row) =>
      numberFormatter({
        style: 'decimal',
        value: row.value,
        minimumFractionDigits: 0,
      }),
    className: 'text-center',
    minWidth: 120,
    filterable: false,
  },
  {
    Header: 'Último Mantenimiento',
    accessor: 'lastExecutionDate',
    className: 'text-center',
    minWidth: 180,
    filterable: false,
  },
  {
    Header: 'KM a Agregar',
    accessor: 'extensionFactor',
    Cell: (row) =>
      row.value &&
      numberFormatter({
        style: 'decimal',
        value: row.value,
        minimumFractionDigits: 0,
      }),
    className: 'text-center',
    minWidth: 120,
    filterable: false,
  },
  {
    Header: 'Personal',
    accessor: 'mechanics',
    Cell: (row) => {
      if (!row.value) return null;
      const mechanicList = row.value.map(({ label }) => ({ text: label }));
      return <BadgeList cell textArray={mechanicList} />;
    },
    className: 'text-center',
    minWidth: 320,
    filterable: false,
  },
  {
    Header: 'Observaciones',
    accessor: 'comment',
    className: 'text-center',
    minWidth: 180,
    filterable: false,
  },
  {
    Header: 'Fecha/Hora Inicio',
    accessor: 'startDate',
    Cell: (row) =>
      row.value && <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    minWidth: 180,
    filterable: false,
  },
  {
    Header: 'Fecha/Hora Final',
    accessor: 'endDate',
    Cell: (row) =>
      row.value && <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    minWidth: 180,
    filterable: false,
  },
  {
    Header: 'Hrs. Trabajadas',
    accessor: 'workingHour',
    className: 'text-center',
    minWidth: 150,
    filterable: false,
  },
  {
    Header: 'Base',
    accessor: 'busHomeBaseName',
    className: 'text-center',
    minWidth: 150,
    filterable: false,
  },
];

export const generateItinerariesForSchedulingTableColumns = ({
  handleConfirm,
  handleClear,
  handleConfirmCabineCrew,
  handleClearCabineCrew,
  additionalButton,
}) => [
  {
    id: 'actions-bus',
    Header: 'Bus',
    className: 'text-center',
    Cell: (row) => (
      <ActionsCell
        handleConfirm={handleConfirm}
        handleClear={handleClear}
        data={row.original}
        id={row.index}
        showClearButton={
          !!row.original.highligth || !!row.original.highlightSuggestion
        }
        showConfirmButton={
          !row.original.tripId &&
          row.original.active &&
          !row.original.highlightSuggestion
        }
        additionalButton={additionalButton(row.original)}
      />
    ),
    width: 100,
    filterable: false,
  },
  {
    id: 'actions-cabin-crew',
    Header: 'Servicio a Bordo',
    className: 'text-center',
    Cell: (row) => (
      <ActionsCell
        handleConfirm={handleConfirmCabineCrew}
        handleClear={handleClearCabineCrew}
        data={row.original}
        id={row.index}
        showClearButton={row.original.highligthCrewCabine}
        showConfirmButton={Boolean(row.original.tripId)}
        confirmIcon="fa-user-plus"
      />
    ),
    width: 100,
    filterable: false,
  },
  {
    id: 'departuretime',
    Header: 'Fecha',
    accessor: 'departuretime',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    className: 'text-center',
    minWidth: 120,
    filterable: false,
  },
  {
    id: 'sourceLocationName',
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
    minWidth: 250,
  },
  {
    id: 'destinationLocationName',
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
    minWidth: 250,
  },
  {
    id: 'departuretime-hour',
    Header: 'Hora',
    accessor: 'departuretime',
    Cell: (row) => <DateCell value={row.value} format={TIME_FORMAT} />,
    className: 'text-center',
    minWidth: 80,
    filterable: false,
  },
  {
    id: 'serviceType',
    Header: 'Tipo Servicio',
    accessor: 'serviceType',
    className: 'text-center',
    minWidth: 180,
  },
  {
    id: 'companyBusId',
    Header: 'Bus',
    accessor: 'companyBusId',
    Cell: (row) => (row.value ? row.value.label : '-'),
    className: 'text-center',
    minWidth: 100,
    filterable: false,
  },
  {
    id: 'firstDriverName',
    Header: 'Conductor 1',
    accessor: 'firstDriverName',
    className: 'text-center',
    minWidth: 200,
    Cell: (row) => (row.value ? row.value : '-'),
  },
  {
    id: 'secondDriverName',
    Header: 'Conductor 2',
    accessor: 'secondDriverName',
    className: 'text-center',
    minWidth: 200,
    Cell: (row) => (row.value ? row.value : '-'),
  },
  {
    id: 'thirdDriverName',
    Header: 'Conductor 3',
    accessor: 'thirdDriverName',
    className: 'text-center',
    minWidth: 200,
    Cell: (row) => (row.value ? row.value : '-'),
  },
  {
    accessor: 'cabinCrewList',
    Header: 'Tripulantes',
    id: 'cabinCrewList',
    Cell: (row) => {
      if (!row.value) return null;
      const cabinCrewList = row.value.map(({ cabinCrewName }) => ({
        text: cabinCrewName,
      }));
      return (
        <BadgeList
          cell
          textArray={cabinCrewList.length > 0 ? cabinCrewList : []}
        />
      );
    },
    className: 'text-center',
    filterable: false,
  },
  {
    id: 'tripCircuitStatus',
    Header: 'Orden en Circuito',
    accessor: 'tripCircuitStatus',
    Cell: (row) => (row.value ? row.value.label : '-'),
    className: 'text-center',
    minWidth: 150,
    filterable: false,
  },
  {
    id: 'active',
    Header: 'Estado',
    accessor: 'active',
    Cell: (row) => <IsActive value={row.value} />,
    className: 'text-center',
    minWidth: 100,
    filterable: false,
  },
  {
    id: 'ticketsSold',
    Header: 'Boletos Vendidos',
    accessor: 'ticketsSold',
    className: 'text-center',
    minWidth: 150,
  },
  {
    id: 'type',
    Header: 'Tipo de Itinerario',
    accessor: 'type',
    className: 'text-center',
    minWidth: 250,
  },
  {
    id: 'routeName',
    Header: 'Ruta',
    accessor: 'routeName',
    className: 'text-center',
    minWidth: 400,
  },
  {
    id: 'id',
    Header: 'ID',
    accessor: 'id',
    Cell: (row) => (
      <LinkToModuleResource
        text={row.value}
        href={`${ITINERARY_FOR_COUNTER_PATH}/${row.value}`}
        isExternalPath
      />
    ),
    className: 'text-center',
    minWidth: 150,
  },
];

export const ODOMETER_BY_BUS_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'departureTime',
    // TODO the backend must return the date in UTC
    Cell: (row) =>
      tzNormalizeDate({
        date: row.value,
        format: DATE_TIME_FORMAT,
        addTime: { amount: 5, unit: 'hour' },
      }),
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
    width: 320,
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
    width: 320,
  },
  {
    Header: (row) =>
      `Kilometraje: (Total: ${numberFormatter({
        style: 'decimal',
        value: row.data.reduce(
          (accumulated, { kilometers }) => accumulated + kilometers,
          0,
        ),
        minimumFractionDigits: 0,
      })})`,
    accessor: 'kilometers',
    className: 'text-center',
    Cell: (row) =>
      row.value &&
      numberFormatter({
        style: 'decimal',
        value: row.value,
        minimumFractionDigits: 0,
      }),
    width: 320,
  },
];

export const BILLING_COLUMNS = [
  {
    Header: 'Procedencia',
    accessor: 'origin',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={BILL_PROCESS_ORIGIN} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={BILL_PROCESS_ORIGIN}
      />
    ),
    width: 100,
  },
  {
    Header: 'Tipo de Documento Cliente',
    accessor: 'clientDocumentType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={BILLING_DOCUMENT_TYPE} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={BILLING_DOCUMENT_TYPE}
      />
    ),
    width: 100,
  },
  {
    Header: 'Numero de Documento',
    accessor: 'clientIdDocumentNumber',
    className: 'text-center',
  },
  {
    Header: 'Nombre ó Razón Social',
    accessor: 'clientName',
    className: 'text-center',
  },
  {
    Header: 'Fecha Emisión',
    accessor: 'issueDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,

    className: 'text-center',
  },

  {
    Header: 'Tipo Documento',
    accessor: 'documentType',
    Cell: (row) => (
      <EnumStatus enumObject={BILLING_VOUCHER_TYPE} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={BILLING_VOUCHER_TYPE}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Sub Tipo Documento',
    accessor: 'roomType',
    className: 'text-center',
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Serie Referencia',
    accessor: 'refDocumentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo Referencia',
    accessor: 'refDocumentCode',
    className: 'text-center',
  },
  {
    Header: 'Moneda',
    accessor: 'currency',
    Cell: (row) => (
      <EnumStatus enumObject={CURRENCY_TYPE} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={CURRENCY_TYPE}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Total Cabecera',
    accessor: 'totalHeader',
    Cell: (row) =>
      numberFormatter({
        style: 'currency',
        value: row.value,
        currency: row.original.currency,
      }),
    className: 'text-center',
  },
  {
    Header: 'Tipo Pago',
    accessor: 'paymentMethod',
    className: 'text-center',
  },
  {
    Header: 'Forma Pago',
    accessor: 'paymentType',
    Cell: (row) =>
      row.original.paymentType ? (
        <EnumStatus
          enumObject={PAYMENT_TYPE}
          enumValue={row.original.paymentType}
        />
      ) : null,
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PAYMENT_TYPE}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Cód. Establecimiento',
    accessor: 'agencyCode',
    className: 'text-center',
  },
  {
    Header: 'Agencia',
    accessor: 'agencyName',
    className: 'text-center',
  },
  {
    Header: 'Centro de Costo',
    accessor: 'costCenter',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus
        enumObject={BILLING_PROCESS_REPORT_STATUS}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={BILLING_PROCESS_REPORT_STATUS}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Comentario ó Observación',
    accessor: 'observation',
    className: 'text-center',
    minWidth: 300,
    filterable: false,
  },
  {
    Header: 'Acción',
    className: 'text-center',
    accessor: 'billProcessId',
    minWidth: 230,
    filterable: false,
    Cell: (row) => {
      const { ticketId, status, billProcessId, origin, flitDocumentId } =
        row.original;

      const isNotProcessed = status !== BILLING_PROCESS_STATUS.PROCESSED.value;

      return (
        <div className="d-flex justify-content-center align-items-center">
          <div className="mr-3">
            <BillingPdfButton ticketId={ticketId} />
          </div>
          <div className="mr-3">
            <BillingCdrButton ticketId={ticketId} />
          </div>
          <div className="mr-3">
            <BillingXmlButton ticketId={ticketId} />
          </div>

          {isNotProcessed && (
            <div className="mr-3">
              <BillingViewButton
                billProcessId={billProcessId}
                origin={origin}
                flitDocumentId={flitDocumentId}
              />
            </div>
          )}
        </div>
      );
    },
  },
];

export const BILLING_ITINERARY_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Tipo de Proceso',
    accessor: 'processType',
    className: 'text-center',
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Serie Doc. Ref.',
    accessor: 'refDocumentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo Doc. Ref.',
    accessor: 'refDocumentCode',
    className: 'text-center',
  },
  {
    Header: 'ID Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Intentos',
    accessor: 'retry',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: ({ value }) => STATUS_TRANSLATIONS[value] || value,
    className: 'text-center',
  },
];

export const ACTIVITY_TASK_COLUMNS = [
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Horas Trabajadas',
    accessor: 'workingHours',
    className: 'text-center',
  },
  {
    Header: 'Organigrama',
    accessor: 'companyArea.name',
    className: 'text-center',
  },
  {
    Header: 'Tarea Ordenada',
    accessor: 'orderDependent',
    Cell: (row) => <Checkbox checked={row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Orden',
    accessor: 'taskOrder',
    className: 'text-center',
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const MAINTENANCE_WARNING_COLUMNS = [
  {
    Header: 'Fecha y hora',
    accessor: 'issueDate',
    Cell: (row) =>
      row.value ? (
        <DateCell value={row.value} format={DATE_TIME_FORMAT} />
      ) : (
        '-'
      ),
    className: 'text-center',
  },
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    className: 'text-center',
  },
  {
    Header: 'KM Actual',
    accessor: 'actualVirtualOdometer',
    Cell: (row) =>
      row.value
        ? numberFormatter({
            style: 'decimal',
            value: row.value,
            minimumFractionDigits: 0,
          })
        : '-',
    className: 'text-center',
  },
  {
    Header: 'KM Ocurrencia',
    accessor: 'actualRegisteredBusOdometer',
    Cell: (row) =>
      row.value
        ? numberFormatter({
            style: 'decimal',
            value: row.value,
            minimumFractionDigits: 0,
          })
        : '-',
    className: 'text-center',
  },
  {
    Header: 'Modo Fallo',
    accessor: 'maintenanceFailMode.description',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'Categoría Modo Fallo',
    accessor: 'maintenanceFailModeCategory.name',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'Tipo Alerta',
    accessor: 'maintenanceWarningType',
    Cell: (row) =>
      row.value ? MAINTENANCE_WARNING_TYPE[row.value].label : '-',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={MAINTENANCE_WARNING_TYPE}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Prioridad',
    accessor: 'priority',
    Cell: (row) =>
      row.value ? (
        <Badge
          text={MAINTENANCE_WARNING_PRIORITY[row.value].label}
          color={MAINTENANCE_WARNING_PRIORITY[row.value].color}
        />
      ) : (
        '-'
      ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={MAINTENANCE_WARNING_PRIORITY}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Reportado por',
    accessor: 'reporterCustomer.firstName',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) =>
      row.value ? (
        <EnumStatus
          enumObject={MAINTENANCE_WARNING_STATUS}
          enumValue={row.value}
        />
      ) : (
        '-'
      ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={MAINTENANCE_WARNING_STATUS}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const FORMATTED_MAINTENANCE_WARNING_COLUMNS = [
  {
    Header: 'Fecha y hora',
    accessor: 'issueDate',
    className: 'text-center',
  },
  {
    Header: 'Categoría',
    accessor: 'category',
    className: 'text-center',
  },
  {
    Header: 'Subcategoría',
    accessor: 'subCategory',
    className: 'text-center',
  },
  {
    Header: 'Modo Fallo',
    accessor: 'maintenanceFailMode',
    className: 'text-center',
  },
  {
    Header: 'Tipo Alerta',
    accessor: 'maintenanceWarningType',
    className: 'text-center',
  },
  {
    Header: 'Prioridad',
    accessor: 'priority',
    Cell: (row) =>
      row.value ? (
        <Badge
          text={MAINTENANCE_WARNING_PRIORITY[row.original.priorityValue].label}
          color={MAINTENANCE_WARNING_PRIORITY[row.original.priorityValue].color}
        />
      ) : (
        '-'
      ),
    className: 'text-center',
  },
  {
    Header: 'Reportado por',
    accessor: 'reporterCustomer',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const MAINTENANCE_SERVICE_ORDER_COLUMNS = [
  {
    Header: 'Fecha Creación',
    accessor: 'createDate',
    Cell: (row) =>
      row.value ? (
        <DateCell value={row.value} format={DATE_TIME_FORMAT} />
      ) : (
        '-'
      ),
    className: 'text-center',
  },
  {
    Header: 'Fecha Límite',
    accessor: 'deadline',
    Cell: (row) =>
      row.value ? (
        <DateCell value={row.value} format={DATE_TIME_FORMAT} />
      ) : (
        '-'
      ),
    className: 'text-center',
  },
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Prioridad',
    accessor: 'priority',
    Cell: (row) =>
      row.value ? (
        <Badge
          text={MAINTENANCE_SERVICE_ORDER_PRIORITY[row.value].label}
          color={MAINTENANCE_SERVICE_ORDER_PRIORITY[row.value].color}
        />
      ) : (
        '-'
      ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={MAINTENANCE_SERVICE_ORDER_PRIORITY}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) =>
      row.value ? (
        <EnumStatus
          enumObject={MAINTENANCE_SERVICE_ORDER_STATUS}
          enumValue={row.value}
        />
      ) : (
        '-'
      ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={MAINTENANCE_SERVICE_ORDER_STATUS}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];

export const MAINTENANCE_SERVICE_ORDER_ACTIVITY_BUS_EXECUTION_LIST_COLUMNS = [
  {
    Header: 'Actividad',
    accessor: 'activityName',
    className: 'text-center',
  },
  {
    Header: 'Tareas',
    accessor: 'taskList',
    className: 'text-center',
    Cell: (row) => {
      if (!row.value) return null;

      const taskList = row.value.map(({ name }) => ({
        text: name,
      }));

      return <BadgeList cell textArray={taskList} />;
    },
  },
  {
    Header: 'Materiales',
    accessor: 'materialList',
    className: 'text-center',
    Cell: (row) => {
      if (!row.value) return null;

      const materialList = row.value.map(({ name }) => ({
        text: name,
      }));

      return <BadgeList cell textArray={materialList} />;
    },
  },
  {
    Header: 'Empleados',
    accessor: 'employeeList',
    className: 'text-center',
    Cell: (row) => {
      if (!row.value) return null;

      const employeeList = row.value.map(({ name }) => ({
        text: name,
      }));

      return <BadgeList cell textArray={employeeList} />;
    },
  },
  {
    Header: 'Fecha/Hora Inicio',
    accessor: 'startDate',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell value={row.value} format={DATE_TIME_FORMAT} />
      ) : null,
  },
  {
    Header: 'Fecha/Hora Final',
    accessor: 'endDate',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell value={row.value} format={DATE_TIME_FORMAT} />
      ) : null,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
  },
];

export const BUS_COLUMN = [
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    minWidth: 70,
  },
  {
    Header: 'Placa',
    accessor: 'licensePlate',
    className: 'text-center',
    minWidth: 100,
  },
];

export const BUS_CHASSIS_COLUMN = [
  {
    Header: 'Marca',
    accessor: 'make',
    className: 'text-center',
  },
  {
    Header: 'Modelo',
    accessor: 'model',
    className: 'text-center',
  },
  {
    Header: 'Año',
    accessor: 'year',
    className: 'text-center',
    minWidth: 100,
  },
  {
    Header: 'Número de Ejes',
    accessor: 'numberOfAxles',
    className: 'text-center',
    minWidth: 100,
  },
];

export const BUS_BODY_WORK_COLUMN = [
  {
    Header: 'Marca',
    accessor: 'make',
    className: 'text-center',
  },
  {
    Header: 'Modelo',
    accessor: 'model',
    className: 'text-center',
  },
  {
    Header: 'Año',
    accessor: 'year',
    className: 'text-center',
    minWidth: 100,
  },
  {
    Header: 'Capacidad de Combustible (gal)',
    accessor: 'fuelCapacity',
    className: 'text-center',
    minWidth: 100,
  },
];

export const SERVICE_TYPE_COLUMN = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const DOCUMENT_TYPE_COLUMN = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const SEAT_MAP_ELEMENT_COLUMN = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Asiento Pasajero',
    accessor: 'isSeat',
    Cell: (row) => <Checkbox checked={row.value} />,
    className: 'text-center',
    maxWidth: 240,
    filterable: false,
  },
  {
    Header: 'Ícono',
    accessor: 'elementIcon',
    Cell: (row) => <i className={`fa ${row.value} fa-lg`} />,
    className: 'text-center',
    maxWidth: 100,
    filterable: false,
  },
];

export const ACTIVITY_COLUMN = [
  {
    Header: 'Código',
    accessor: 'companyActivityId',
    className: 'text-center',
    minWidth: 100,
  },
  {
    Header: 'Actividad',
    accessor: 'name',
    className: 'text-center',
    minWidth: 180,
  },
  {
    Header: 'Factor',
    accessor: 'factor',
    Cell: (row) =>
      row.value
        ? numberFormatter({
            style: 'decimal',
            value: row.value,
            minimumFractionDigits: 0,
          })
        : '-',
    className: 'text-center',
    minWidth: 100,
  },
  {
    Header: 'Tipo Factor',
    accessor: 'factorType',
    Cell: (row) => (row.value ? MAINTENANCE_FACTOR_TYPE[row.value].label : '-'),
    className: 'text-center',
    minWidth: 100,
  },
  {
    Header: 'Área',
    accessor: 'companyArea.name',
    Cell: (row) => row.value || '-',
    className: 'text-center',
    minWidth: 150,
  },
];

export const LEGAL_ABANDONMENT_CARGO_ITEMS_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Precio Lista',
    accessor: 'listPrice',
    className: 'text-center',
  },
  {
    Header: 'Precio Venta',
    accessor: 'salePrice',
    className: 'text-center',
  },
];

export const generateUnloadingCargoItemsColumns = (
  onClickRemoveItemFromItinerary,
) => [
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Remover',
    className: 'text-center',
    Cell: (row) => (
      <i
        tabIndex="0"
        role="button"
        className="fa fa-times text-danger"
        onClick={() =>
          onClickRemoveItemFromItinerary(
            row.original.correlation,
            row.original.id,
            row.original.internalCargoItem,
          )
        }
        onKeyPress={() =>
          onClickRemoveItemFromItinerary(
            row.original.correlation,
            row.original.id,
            row.original.internalCargoItem,
          )
        }
      />
    ),
    width: 150,
    filterable: false,
  },
];

export const CARGO_ITINERARY_COLUMNS = [
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
];

export const generateParcelsToPickupColumns = (
  onClickPickupParcel,
  handleSubmit,
) => [
  {
    className: 'text-center',
    Expander: (expander) => {
      if (expander.isExpanded) return <i className="fa fa-caret-up" />;

      return <i className="fa fa-caret-down" />;
    },
    getProps: () => ({
      className: 'show-pointer',
    }),
    expander: true,
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Número de serie',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceCityName',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationCityName',
    className: 'text-center',
  },
  {
    Header: 'Entregar',
    className: 'text-center',
    Cell: (row) =>
      row.original.status === 'DELIVERED' ? (
        <Checkbox checked />
      ) : (
        <i
          tabIndex="0"
          role="button"
          className="fa fa-plus-circle text-success"
          onClick={() => onClickPickupParcel(row.original, handleSubmit)}
          onKeyPress={() => onClickPickupParcel(row.original, handleSubmit)}
        />
      ),
    width: 150,
    sortable: false,
  },
];

export const CARGO_ITEMS_TO_PICKUP_COLUMNS = [
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
];

export const MANUAL_GRR_COLUMNS = [
  {
    Header: 'Codigo',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Número Guía',
    accessor: 'guideNumber',
    className: 'text-center',
  },
  {
    Header: 'Remitente',
    accessor: 'sender',
    className: 'text-center',
  },
  {
    Header: 'Destinatario',
    accessor: 'consignee',
    className: 'text-center',
  },
  {
    Header: 'Partida',
    accessor: 'sourceName',
    className: 'text-center',
  },
  {
    Header: 'Llegada',
    accessor: 'destinationName',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Motivo de Salida',
    accessor: 'exitReason',
    className: 'text-center',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={enumToSelectOptions(SENDER_REMISSION_GUIDE_EXIT_REASON)}
      />
    ),
    Cell: (row) => (
      <EnumStatus
        enumObject={SENDER_REMISSION_GUIDE_EXIT_REASON}
        enumValue={row.value}
      />
    ),
  },
  {
    Header: 'Estado de Cierre',
    accessor: 'closureStatus',
    className: 'text-center',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={enumToSelectOptions(SENDER_REMISSION_GUIDE_CLOSURE_STATUS)}
      />
    ),
    Cell: (row) => (
      <EnumStatus
        enumObject={SENDER_REMISSION_GUIDE_CLOSURE_STATUS}
        enumValue={row.value}
      />
    ),
  },
];

export const DETRACTION_COLUMNS = [
  {
    Header: 'País',
    accessor: 'country.name',
    className: 'text-center',
  },
  {
    Header: 'Código de detracción',
    accessor: 'detractionCode',
    Cell: (row) => numberFormatter({ value: row.value, digits: 3 }),
    className: 'text-center',
  },
  {
    Header: 'Porcentaje de detracción',
    accessor: 'detractionRate',
    Cell: (row) => numberFormatter({ value: row.value, style: 'percent' }),
    className: 'text-center',
  },
  {
    Header: 'Monto mínimo para la detracción',
    accessor: 'minDetractionAmount',
    className: 'text-center',
  },
  {
    Header: 'Número de cuenta',
    accessor: 'bankAccountNumber',
    className: 'text-center',
  },
];

export const TRIP_EXPENSE_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'driverFullName',
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    accessor: 'itinerarySourceAndDestination',
    className: 'text-center',
  },
  {
    Header: 'Peajes',
    accessor: 'tollPayment',
    className: 'text-center',
  },
  {
    Header: 'Condiciones de Trabajo',
    accessor: 'commissionPayment',
    className: 'text-center',
  },
  {
    Header: 'Total',
    accessor: 'totalPayment',
    className: 'text-center',
  },
];

export const VOUCHER_TYPE_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const PAYMENT_METHOD_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const SALES_TAX_COLUMNS = [
  {
    Header: 'País',
    accessor: 'country.name',
    className: 'text-center',
  },
  {
    Header: 'Tax Rate',
    accessor: 'taxRate',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value, style: 'percent' }),
  },
];

export const EXCHANGE_RATE_COLUMNS = [
  {
    Header: 'Moneda',
    accessor: 'currency',
    className: 'text-center',
  },
  {
    Header: 'Tasa',
    accessor: 'rate',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value, style: 'currency' }),
  },
];

export const LIQUIDATION_DIFFERENCE_REASON_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const GENERAL_INCOME_TYPE_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Clase de Tipo de Ingreso',
    accessor: 'generalIncomeTypeLabel',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={enumToSelectOptions(GENERAL_INCOME_TYPE_LABEL)}
      />
    ),
    Cell: (row) => (
      <EnumStatus
        enumObject={GENERAL_INCOME_TYPE_LABEL}
        enumValue={row.value}
      />
    ),
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];

export const TRANSACTION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: (row) => numberFormatter({ value: row.value, style: 'currency' }),
    className: 'text-center',
  },
  {
    Header: 'Método de Pago',
    accessor: 'paymentMethod.name',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Transacción',
    accessor: 'transactionType.transactionType',
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={enumToSelectOptions(TRANSACTION_TYPE)}
      />
    ),
    Cell: (row) => (
      <EnumStatus enumObject={TRANSACTION_TYPE} enumValue={row.value} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Sesión de Ventas',
    accessor: 'salesSessionId',
    className: 'text-center',
  },
  {
    Header: 'Egreso',
    accessor: 'expenseId',
    className: 'text-center',
  },
  {
    Header: 'Ingreso',
    accessor: 'generalIncomeId',
    className: 'text-center',
  },
];

export const CARGO_ITEM_MOVEMENT_COLUMNS = [
  {
    Header: 'Usuario',
    accessor: 'user.fullName',
    className: 'text-center',
  },
  {
    Header: 'Comentario',
    accessor: 'comments',
    className: 'text-center',
  },
  {
    Header: 'Ubicacion',
    accessor: 'location.name',
    className: 'text-center',
  },
  {
    Header: 'Tipo movimiento',
    accessor: 'movementType',
    Cell: (row) => <CargoItemMovementStatusCell value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Estado de Traqueo',
    accessor: 'cargoItemStatus',
    Cell: (row) => <CargoItemStatusCell value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
];
export const CARGO_ITEM_PARCEL_DETAIL_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'parcelCorrelation',
    className: 'text-center',
  },
  {
    Header: 'Creado Por',
    accessor: 'createUserFullName',
    className: 'text-center',
  },
  {
    Header: 'Correo Usuario',
    accessor: 'createUserEmail',
    className: 'text-center',
  },
  {
    Header: 'Fecha',
    accessor: 'parcelCreateDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Estado de Pago',
    accessor: 'parcelPaymentStatus',
    Cell: (row) => <ParcelPaymentStatusCell value={row.value} />,
    className: 'text-center',
  },
];

export const CARGO_CORPORATE_CREDIT_COLUMNS = [
  {
    Header: 'Código',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    id: 'customer.firstName',
    Header: 'Cliente',
    accessor: 'customer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Empresa',
    accessor: 'company.name',
    className: 'text-center',
  },
  {
    Header: 'Crédito Inicial',
    accessor: 'initialBalance',
    className: 'text-center',
  },
  {
    Header: 'Crédito Actual',
    accessor: 'actualBalance',
    className: 'text-center',
  },
];
export const LIVE_ITINERARY_SALES_CONTROL_COLUMNS = [
  {
    Header: 'Fecha de Salida',
    accessor: 'departuretime',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
    Cell: (row) => (
      <Link to={`${ITINERARY_PATH}/${row.value}`} target="_blank">
        {row.value}
      </Link>
    ),
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    hoverPopoverClassName: 'popover-xl',
    hoverPopoverComponent: (row) => {
      const flow = (row.authorizedStopDetail || [])
        .slice()
        .sort((a, b) => a.order - b.order);

      return (
        <>
          <b>Detalle Comercial:</b>
          <br />
          <table className="table table-sm table-bordered mb-0">
            <thead className="thead-purple text-center">
              <tr>
                <th>Escala comercial</th>
                <th>Embarque</th>
                <th>Desembarque</th>
              </tr>
            </thead>
            <tbody>
              {flow.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    Sin información
                  </td>
                </tr>
              ) : (
                flow.map((item) => (
                  <tr key={item.locationId}>
                    <td>{item.locationName}</td>
                    <td className="text-center">
                      {item.boardingPassengers || '-'}
                    </td>
                    <td className="text-center">
                      {item.leavingPassengers || '-'}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </>
      );
    },
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType',
    className: 'text-center',
    hoverPopoverClassName: 'popover-md',
    hoverPopoverComponent: (row) => (
      <table className="table table-sm table-bordered mb-0">
        <thead className="thead-purple text-center">
          <tr>
            <th>Concepto</th>
            <th className="text-center">Monto</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Ingreso Pasaje</td>
            <td className="text-center">
              {numberFormatter({ value: row.totalTicketSalesAmount || 0 })}
            </td>
          </tr>
          <tr>
            <td>Ingreso Carga</td>
            <td className="text-center">
              {numberFormatter({ value: row.totalParcelSalesAmount || 0 })}
            </td>
          </tr>
        </tbody>
      </table>
    ),
  },
  {
    Header: 'Hora de Salida',
    accessor: 'departuretime',
    className: 'text-center',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Capacidad de Asiento',
    accessor: 'numberOfSeats',
    className: 'text-center',
  },
  {
    Header: 'Asientos Vendidos',
    accessor: 'soldSeats',
    className: 'text-center',
    hoverPopoverClassName: 'popover-md',
    hoverPopoverComponent: (row) => {
      const agencies = (row.ticketCountByAgencyDto || [])
        .slice()
        .sort((a, b) => b.ticketCount - a.ticketCount);

      return (
        <table className="table table-sm table-bordered mb-0">
          <thead className="thead-purple text-center">
            <tr>
              <th>Agencia de Venta</th>
              <th className="text-center">Asientos</th>
            </tr>
          </thead>
          <tbody>
            {agencies.length === 0 ? (
              <tr>
                <td colSpan="2" className="text-center">
                  Sin información
                </td>
              </tr>
            ) : (
              agencies.map((agency) => (
                <tr key={agency.agencyId}>
                  <td>{agency.agencyName}</td>
                  <td className="text-center">
                    <strong>{agency.ticketCount}</strong>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      );
    },
    Cell: (row) => <span style={{ fontWeight: 'bold' }}>{row.value}</span>,
  },
  {
    Header: 'Ocupabilidad General',
    accessor: 'occupancy',
    className: 'text-center',
    Cell: (row) => (
      <span style={{ fontWeight: 'bold' }}>{`${row.value}%`}</span>
    ),
    hoverPopover: (data) => {
      if (!data || !data.lastTicketSaleDate) {
        return <span>Última venta: -</span>;
      }

      return (
        <div style={{ textAlign: 'center' }}>
          <strong>Última venta</strong>
          <div>
            <DateCell value={data.lastTicketSaleDate} format={DATE_FORMAT} />
          </div>
          <div>
            <DateCell format={TIME_FORMAT} value={data.lastTicketSaleDate} />
          </div>
        </div>
      );
    },
  },
  {
    Header: 'Ocupabilidad',
    columns: [
      {
        Header: '1er Piso',
        accessor: 'firstFloorOccupancy',
        className: 'text-center',
        Cell: (row) => (
          <span style={{ fontWeight: 'bold' }}>{`${row.value}%`}</span>
        ),
      },
      {
        Header: '2er Piso',
        accessor: 'secondFloorOccupancy',
        className: 'text-center',
        Cell: (row) => (
          <span style={{ fontWeight: 'bold' }}>{`${row.value}%`}</span>
        ),
      },
    ],
  },
  {
    Header: 'Precios Desde',
    columns: [
      {
        Header: '1er Piso',
        accessor: 'lowestPriceFloor1',
        className: 'text-center',
        Cell: ({ value }) => (value === 0 ? '-' : numberFormatter({ value })),
        filterable: false,
        hoverPopoverClassName: 'popover-sm',
        hoverPopoverComponent: (row) => {
          const prices = [
            ...new Set(
              (row.pricingZonePrices || [])
                .filter((zone) => zone.floorNumber === 1)
                .map((zone) => zone.lowestPrice),
            ),
          ].sort((a, b) => a - b);

          return (
            <table className="table table-sm table-bordered mb-0">
              <thead className="thead-purple text-center">
                <tr>
                  <th>Precio</th>
                </tr>
              </thead>
              <tbody>
                {prices.length === 0 ? (
                  <tr>
                    <td className="text-center">Sin información</td>
                  </tr>
                ) : (
                  prices.map((price) => (
                    <tr key={price}>
                      <td className="text-center">
                        {numberFormatter({ value: price })}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          );
        },
      },
      {
        Header: '2er Piso',
        accessor: 'lowestPriceFloor2',
        className: 'text-center',
        Cell: ({ value }) => (value === 0 ? '-' : numberFormatter({ value })),
        filterable: false,
        hoverPopoverClassName: 'popover-sm',
        hoverPopoverComponent: (row) => {
          const prices = [
            ...new Set(
              (row.pricingZonePrices || [])
                .filter((zone) => zone.floorNumber === 2)
                .map((zone) => zone.lowestPrice),
            ),
          ].sort((a, b) => a - b);

          return (
            <table className="table table-sm table-bordered mb-0">
              <thead className="thead-purple text-center">
                <tr>
                  <th>Precio</th>
                </tr>
              </thead>
              <tbody>
                {prices.length === 0 ? (
                  <tr>
                    <td className="text-center">Sin información</td>
                  </tr>
                ) : (
                  prices.map((price) => (
                    <tr key={price}>
                      <td className="text-center">
                        {numberFormatter({ value: price })}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          );
        },
      },
    ],
  },
];

export const SEATS_INFORMATION_COLUMS = [
  {
    Header: 'Asientos Ofertados',
    accessor: 'offeredSeats',
    className: 'text-center',
  },
  {
    Header: 'Asientos Vendidos',
    accessor: 'soldSeats',
    className: 'text-center',
  },
  {
    Header: 'Pendientes',
    accessor: 'pendingSeats',
    className: 'text-center',
  },
];

export const ITINERARIES_OCCUPANCY_COLUMS = [
  {
    Header: 'Servicio',
    accessor: 'serviceType',
    className: 'text-center',
  },
  {
    Header: 'Ocupabilidad',
    accessor: 'occupancy',
    className: 'text-center',
  },
  {
    Header: 'Itinerarios',
    accessor: 'itineraries',
    className: 'text-center',
  },
];

export const PAYMENT_METHOD_FOR_SECURITY_PROFILE_COLUMNS = [
  {
    Header: 'Metodo de Pago',
    accessor: 'paymentMethod.name',
    className: 'text-center',
  },
  {
    Header: 'Perfil de Seguridad',
    accessor: 'securityProfile.name',
    className: 'text-center',
  },
];

export const PARCEL_TRANSACTIONS_COLUMNS = [
  {
    Header: 'Método de Pago',
    accessor: 'paymentMethodName',
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: (row) =>
      numberFormatter({
        value: row.value,
      }),
    className: 'text-center',
  },
  {
    Header: 'Creado Por',
    accessor: 'userFullName',
    className: 'text-center',
  },
  {
    Header: 'Sesión de Ventas',
    accessor: 'salesSessionId',
    Cell: (row) => (
      <LinkToModuleResource
        text={row.value}
        href={`${SALES_SESSION_PATH}/${row.value}`}
        isExternalPath
      />
    ),
    className: 'text-center',
  },
];

export const PASSENGER_FLOW_COLUMNS = [
  {
    Header: 'Boleto',
    accessor: 'ticketCode',
    className: 'text-center',
  },
  {
    Header: 'Pasajero',
    accessor: 'customerFullName',
    className: 'text-center',
  },
  {
    Header: 'DNI del Pasajero',
    accessor: 'customerDocumentNumber',
    className: 'text-center',
  },
  {
    Header: 'Asiento',
    accessor: 'seatNumber',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'boarded',
    Cell: (row) => {
      let enumValue;

      switch (row.value) {
        case true:
          enumValue = TICKET_BOARDED_STATUS.BOARDED.value;
          break;
        case false:
          enumValue = TICKET_BOARDED_STATUS.UNBOARDED.value;
          break;
        case null:
        default:
          enumValue = TICKET_BOARDED_STATUS.UNREGISTERED.value;
          break;
      }

      return (
        <EnumStatus enumObject={TICKET_BOARDED_STATUS} enumValue={enumValue} />
      );
    },
    className: 'text-center',
  },
];

export const generateCargoItemManifestColumns = (printManifest) => [
  {
    Header: 'Itinerario',
    accessor: 'itinerary.id',
    className: 'text-center',
    Cell: (row) => (
      <Link to={`${ITINERARY_FOR_COUNTER_PATH}/${row.value}`} target="_blank">
        {row.value}
      </Link>
    ),
  },
  {
    Header: 'Fecha de Salida',
    accessor: 'exitDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Origen',
    id: 'sourceLocation',
    accessor: 'sourceLocation.name',
    className: 'text-center',
    Cell: (row) => row.value,
  },
  {
    Header: 'Destino',
    id: 'destinationLocation',
    accessor: 'destinationLocation.name',
    className: 'text-center',
    Cell: (row) => row.value,
  },
  {
    Header: 'Hora de Salida',
    accessor: 'exitDate',
    className: 'text-center',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <Button onClick={() => printManifest(row.original.id)}>Imprimir</Button>
    ),
  },
];

export const CARGO_CORPORATE_CREDIT_UNIFY_INVOICES_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'correlative',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'salePrice',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
];

export const generatePrintBillingColumns = (printBilling) => [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Tipo de Proceso',
    accessor: 'processType',
    className: 'text-center',
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Serie Doc. Ref.',
    accessor: 'refDocumentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo Doc. Ref.',
    accessor: 'refDocumentCode',
    className: 'text-center',
  },
  {
    Header: 'ID Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <Button onClick={() => printBilling(row.original.ticketId)}>
        Imprimir
      </Button>
    ),
  },
];

export const MANIFEST_CARGO_ITEM_TO_ITINERARY_COLUMNS = [
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Recepción',
    accessor: 'createDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    id: 'status',
    className: 'text-center',
    Cell: (row) =>
      row.original.itineraryId !== null ? (
        <Badge color="success" text="SUBIDO" />
      ) : (
        <Badge color="warning" text="NO SUBIDO" />
      ),
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={[
          { label: 'SUBIDO', value: 'SUBIDO' },
          { label: 'NO SUBIDO', value: 'NO_SUBIDO' },
        ]}
      />
    ),
    filterMethod: (filter, row) => {
      if (filter.value === 'SUBIDO') {
        // eslint-disable-next-line
        return row._original.itineraryId !== null;
      }
      if (filter.value === 'NO_SUBIDO') {
        // eslint-disable-next-line
        return row._original.itineraryId === null;
      }
      return true;
    },
  },
];

export const generateManifestCargoColumns = (printManifest) => [
  {
    className: 'text-center',
    Expander: (expander) => {
      if (expander.original.manifestCargoItemDetails === 0) return null;

      if (expander.isExpanded) return <i className="fa fa-caret-up" />;

      return <i className="fa fa-caret-down" />;
    },
    getProps: (state, rowInfo) => {
      if (rowInfo && rowInfo.original.manifestCargoItemDetails === 0) {
        return {
          onClick: () => {},
        };
      }
      return {
        className: 'show-pointer',
      };
    },
    expander: true,
  },
  {
    Header: 'Fecha de Salida',
    accessor: 'exitDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Origen',
    id: 'sourceLocation',
    accessor: 'sourceLocation.name',
    className: 'text-center',
    Cell: (row) => row.value,
  },
  {
    Header: 'Destino',
    id: 'destinationLocation',
    accessor: 'destinationLocation.name',
    className: 'text-center',
    Cell: (row) => row.value,
  },
  {
    Header: 'Hora de Salida',
    accessor: 'exitDate',
    className: 'text-center',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <Button onClick={() => printManifest(row.original.id)}>Imprimir</Button>
    ),
  },
];

export const generateManifestCargoDetailsColumns = (
  onClickRemoveItemFromManifest,
  disabledRemoved,
) => [
  {
    Header: 'Correlativo',
    accessor: 'item.correlation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'item.description',
    className: 'text-center',
  },
  {
    Header: 'Consignado',
    accessor: 'item.consigned',
    className: 'text-center',
  },
  {
    Header: 'Peso',
    accessor: 'item.weight',
    className: 'text-center',
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <i
        tabIndex="0"
        role="button"
        className={`fa fa-times ${
          disabledRemoved ? 'text-muted' : 'text-danger'
        }`}
        style={{ pointerEvents: disabledRemoved ? 'none' : 'auto' }}
        onClick={() =>
          !disabledRemoved && onClickRemoveItemFromManifest(row.original)
        }
        onKeyPress={() =>
          !disabledRemoved && onClickRemoveItemFromManifest(row.original)
        }
      />
    ),
    width: 150,
    filterable: false,
  },
];

export const generateManifestCargoItemsColumns = (onClickRemoveItem) => [
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <i
        tabIndex="0"
        role="button"
        className="fa fa-times text-danger"
        onClick={() => onClickRemoveItem(row.original)}
        onKeyPress={() => onClickRemoveItem(row.original)}
      />
    ),
    filterable: false,
  },
];

export const MANIFEST_CARGO_ITEM_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
    className: 'text-center',
  },
];

export const PAYMENT_COLUMNS = [
  {
    Header: 'Empresa',
    accessor: 'companyName',
    id: 'company.name',
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Fecha de pago',
    accessor: 'paymentDate',
    Cell: (row) => <DateCell format={DATE_FORMAT} value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={PAYMENT_STATUS} enumValue={row.value} />
    ),
    className: 'text-center',
  },
];

export const generateManualVoucherItemsColumns = ({ currencyCode }) => [
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Precio',
    accessor: 'unitaryPrice',
    Cell: (row) =>
      numberFormatter({
        style: 'currency',
        value: row.value,
        currency: currencyCode,
      }),
    className: 'text-center',
  },
  {
    Header: 'Total',
    accessor: 'totalPrice',
    Cell: (row) =>
      numberFormatter({
        style: 'currency',
        value: row.value,
        currency: currencyCode,
      }),
    className: 'text-center',
  },
];

export const CONTRACTOR_COLUMNS = [
  {
    Header: 'Contratista',
    accessor: 'customer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Empresa',
    accessor: 'business.name',
    className: 'text-center',
  },
  {
    Header: 'Company',
    accessor: 'company.name',
    className: 'text-center',
  },
];

export const TRIP_REQUEST_COLUMNS = [
  {
    Header: 'Contratista',
    accessor: 'businessName',
    id: 'contractor.business.businessTaxId',
    className: 'text-center',
  },
  {
    Header: 'Itinerario',
    accessor: 'itineraryRouteName',
    id: 'itinerary.route.name',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) =>
      row.value ? (
        <EnumStatus enumObject={TRIP_REQUEST_STATUS} enumValue={row.value} />
      ) : (
        '-'
      ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={TRIP_REQUEST_STATUS}
      />
    ),
    className: 'text-center',
  },
];

export const TRIP_REQUEST_CUSTOMER_COLUMNS = [
  {
    Header: 'Nombres',
    accessor: 'firstName',
    className: 'text-center',
  },
  {
    Header: 'Apellidos',
    accessor: 'lastName',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Documento',
    accessor: 'identificationType.name',
    className: 'text-center',
  },
  {
    Header: 'Número de Documento',
    accessor: 'idDocumentNumber',
    className: 'text-center',
  },
];

export const generatePersonnelColumns = (verifyCustomer) => [
  {
    Header: 'Nombres',
    accessor: 'firstName',
    className: 'text-center',
  },
  {
    Header: 'Apellidos',
    accessor: 'lastName',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Documento',
    accessor: 'identificationType.name',
    className: 'text-center',
  },
  {
    Header: 'Número de Documento',
    accessor: 'idDocumentNumber',
    className: 'text-center',
  },
  {
    Header: 'Tipo',
    accessor: 'type',
    Cell: (row) => (
      <EnumStatus enumObject={COMPANY_STAFF_TYPE} enumValue={row.value} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Asiento',
    accessor: 'seatNumber',
    className: 'text-center',
  },
  {
    Header: 'Estado de embarque',
    accessor: 'boarded',
    Cell: (row) => {
      let enumValue;

      switch (row.value) {
        case true:
          enumValue = TICKET_BOARDED_STATUS.BOARDED.value;
          break;
        case false:
          enumValue = TICKET_BOARDED_STATUS.UNBOARDED.value;
          break;
        case null:
        default:
          enumValue = TICKET_BOARDED_STATUS.UNREGISTERED.value;
          break;
      }

      return (
        <EnumStatus enumObject={TICKET_BOARDED_STATUS} enumValue={enumValue} />
      );
    },
    className: 'text-center',
  },
  {
    Header: 'Hora de embarque',
    accessor: 'boardingTime',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Apto',
    accessor: 'suitable',
    Cell: (row) => {
      let enumValue;

      switch (row.value) {
        case true:
          enumValue = SUITABLE_STATUS.SUITABLE.value;
          break;
        case false:
          enumValue = SUITABLE_STATUS.UNSUITABLE.value;
          break;
        case null:
        default:
          enumValue = SUITABLE_STATUS.UNREGISTERED.value;
          break;
      }

      return <EnumStatus enumObject={SUITABLE_STATUS} enumValue={enumValue} />;
    },
    className: 'text-center',
  },
  {
    Header: 'Verificar',
    notNavigateToModel: true,
    Cell: (row) => (
      <button
        className="btn btn-primary btn-sm"
        style={{
          padding: '0.1rem 0.3rem',
          fontSize: '0.75rem',
        }}
        onClick={() => verifyCustomer(row.original)}
      >
        Verificar
      </button>
    ),
    className: 'text-center',
  },
];

export const PROCESS_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Régimen',
    accessor: 'shift',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Salida',
    accessor: 'departureTime',
    Cell: (row) => <DateCell format={DATE_FORMAT} value={row.value} />,
    className: 'text-center',
  },
];

export const ITINERARY_PROCESS_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    accessor: 'routeName',
    className: 'text-center',
  },
  {
    Header: 'Hora de Salida',
    accessor: 'departureTime',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Número de pasajeros',
    accessor: 'numPassengers',
    Cell: (row) => (
      <>
        {row.value} / {COMPANY_BUS_SEAT_COUNT}
      </>
    ),
    className: 'text-center',
  },
];

export const PARCEL_PRICE_CONFIGURATION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Precio Base',
    accessor: 'basePrice',
    className: 'text-center',
  },
  {
    Header: 'Divisor Volumetrico',
    accessor: 'volumetricDivisor',
    className: 'text-center',
  },
  {
    Header: 'Máximo peso de Sobre',
    accessor: 'maxEnvelopeWeight',
    className: 'text-center',
  },
  {
    Header: 'Crédito Corporativo',
    id: 'cargoCorporateCredit.id',
    accessor: 'cargoCorporateCredit.name',
    className: 'text-center',
    Filter: (row) => (
      <CargoCorporateCreditFilter isClearable onChangeFilter={row.onChange} />
    ),
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Ultima Actualización',
    accessor: 'lastUpdate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    filterable: false,
  },
];

export const PARCEL_PRICE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Archivo',
    accessor: 'file',
    className: 'text-center',
    Cell: (row) => (
      <LinkToModuleResource
        href={row.value}
        text={row.value}
        colorIcon="text-primary"
        isExternalPath
      />
    ),
  },
  {
    Header: 'Corporativo',
    accessor: 'cargoCorporateCredit',
    className: 'text-center',
    Cell: (row) => (row.value ? row.value.name : ''),
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Activo',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_PRICE_STATUS} enumValue={row.value} />
    ),
    className: 'text-center',
  },
];

export const PARCEL_SERVICE_TYPE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Aumento Porcentual',
    accessor: 'increasePercentage',
    className: 'text-center',
    Cell: (row) => numberFormatter({ value: row.value, style: 'percent' }),
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Ultima Actualización',
    accessor: 'lastUpdate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
];

export const BUS_DOCUMENTS_COLUMNS = [
  {
    Header: 'Tipo de Documento',
    accessor: 'documentType.name',
    className: 'text-center',
  },
  {
    Header: 'Número de Serie',
    accessor: 'serialNumber',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Expedición',
    accessor: 'effectiveDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Fecha de Expiración',
    accessor: 'expirationDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
];

export const BUSSES_COLUMNS = [
  {
    Header: 'Número de Bus',
    accessor: 'companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Matrícula',
    accessor: 'licensePlate',
    className: 'text-center',
  },
  {
    Header: 'Base',
    accessor: 'homeBaseLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Chasís',
    accessor: 'busChassis.make',
    className: 'text-center',
  },
  {
    Header: 'Carrocería',
    accessor: 'busBodywork.make',
    className: 'text-center',
  },
  {
    Header: 'Mapa de Asientos',
    accessor: 'seatMap.name',
    className: 'text-center',
  },
];

export const INTERNAL_CARGO_ITEM_COLUMNS = [
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    className: 'text-center',
  },
  {
    Header: 'Producto Frecuente',
    accessor: 'commonProductName',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Categoría',
    accessor: 'cargoCategoryName',
    className: 'text-center',
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => <CargoItemStatusCell value={row.value} />,
  },
];

export const MAINTENANCE_PLANNING_ACTIVITY_ORDER_COLUMNS = [
  {
    Header: 'Descripción',
    accessor: 'activity.name',
    className: 'text-center',
  },
  {
    Header: 'Factor',
    accessor: 'factor',
    className: 'text-center',
  },
  {
    Header: 'Orden',
    accessor: 'activityOrder',
    className: 'text-center',
  },
];

export const MAINTENANCE_TASK_COLUMNS = [
  {
    Header: 'Código',
    accessor: 'companyMaintenanceTaskId',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Horas de Trabajo',
    accessor: 'workingHours',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'active',
    Cell: (row) => <IsActive value={row.value} />,
    className: 'text-center',
  },
];

export const ACTIVITY_MAINTENANCE_TASK_COLUMNS = [
  {
    Header: 'Descripción',
    accessor: 'taskName',
    className: 'text-center',
  },
  {
    Header: 'Horas de Trabajo',
    accessor: 'workingHours',
    className: 'text-center',
  },
  {
    Header: 'Materiales Asignados',
    accessor: 'materials',
    className: 'text-center',
  },
];

export const MAINTENANCE_PLANNINGS_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Organigrama',
    accessor: 'companyArea.name',
    className: 'text-center',
  },
];

export const MAINTENANCE_TASK_MATERIAL_COLUMNS = [
  {
    Header: 'Código',
    accessor: 'material.externalId',
    className: 'text-center',
    minWidth: 180,
  },
  {
    Header: 'Nombre',
    accessor: 'material.name',
    className: 'text-center',
    minWidth: 320,
  },
  {
    Header: 'Unidad de Medida',
    accessor: 'material.measurementUnit',
    className: 'text-center',
    minWidth: 180,
  },
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    className: 'text-center',
    minWidth: 180,
  },
];

export const MAINTENANCE_BUS_GROUP_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
    filterable: false,
  },
];

export const MAINTENANCE_PLANNING_RESOURCE_COLUMNS = [
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Grupo de Bus',
    accessor: 'maintenanceBusGroup.name',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={MAINTENANCE_PLANNING_STATUS}
        enumValue={row.value}
      />
    ),
  },
];

export const SERVICE_MERGE_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Itinerario inicial',
    accessor: 'sourceItineraryId',
    Cell: (row) =>
      `${row.original.sourceItineraryId} - ${row.original.sourceItineraryRouteName}`,
    className: 'text-center',
  },
  {
    Header: 'Itinerario final',
    accessor: 'destinationItineraryId',
    Cell: (row) =>
      `${row.original.destinationItineraryId} - ${row.original.destinationItineraryRouteName}`,
    className: 'text-center',
  },
  {
    Header: 'Usuario',
    accessor: 'operatorUserName',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Agencia',
    accessor: 'agencyName',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
  },
];

export const TICKET_REASSIGNMENT_COLUMNS = [
  {
    Header: 'Id del Ticket',
    accessor: 'ticketId',
    className: 'text-center',
  },
  {
    Header: 'Ticket',
    accessor: 'ticketCode',
    className: 'text-center',
  },
  {
    Header: 'Cliente',
    accessor: 'customerId',
    Cell: (row) =>
      `${row.original.customerIdentificationTypeName} ${row.original.customerIdDocumentNumber} (${row.original.customerIdCountryOfOrigin}) - ${row.original.customerFullName}`,
    Filter: (row) => (
      <CustomerFilter isClearable onChangeFilter={row.onChange} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Origen y destino anteriores',
    accessor: 'previousSourceLocationName',
    Cell: (row) =>
      `${row.original.previousSourceLocationName} - ${row.original.previousDestinationLocationName}`,
    filterable: false,
    sortable: false,
    className: 'text-center',
  },
  {
    Header: 'Origen y destino nuevos',
    accessor: 'newSourceLocationName',
    Cell: (row) =>
      `${row.original.newSourceLocationName} - ${row.original.newDestinationLocationName}`,
    filterable: false,
    sortable: false,
    className: 'text-center',
  },
  {
    Header: 'Número de asiento anterior',
    accessor: 'previousSeatNumber',
    className: 'text-center',
  },
  {
    Header: 'Nuevo número de asiento',
    accessor: 'newSeatNumber',
    className: 'text-center',
  },
];

export const COMPANY_RESOURCES_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Tipo',
    accessor: 'companyResourceType.description',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
  },
];

export const PRICING_PROFILE_ROUTES_COLUMNS = [
  { Header: 'Id', accessor: 'routeId', className: 'text-center' },
  { Header: 'Ruta', accessor: 'routeName', className: 'text-center' },
];

export const EXPENSE_AUTHORIZER_USERS_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'user.customer.firstName',
    className: 'text-center',
  },
  {
    Header: 'Apellido',
    accessor: 'user.customer.lastName',
    className: 'text-center',
  },
  {
    Header: 'Centro de Costo',
    accessor: 'costCenter.name',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Autorizador',
    accessor: 'authorizerType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={EXPENSE_AUTHORIZER_USER_TYPE}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        isMulti
        enumOptions={EXPENSE_AUTHORIZER_USER_TYPE}
      />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
  },
];

export const DRIVERS_MOVEMENT_HISTORY_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Conductor',
    id: 'driver.id',
    accessor: 'driver.customer.fullName',
    className: 'text-center',
    Filter: (row) => <DriverFilter isClearable onChangeFilter={row.onChange} />,
  },
  {
    Header: 'Número de Documento',
    accessor: 'driver.customer.idDocumentNumber',
    className: 'text-center',
  },
  {
    Header: 'Motivo',
    id: 'driverMovement.id',
    accessor: 'driverMovement.name',
    className: 'text-center',
    Filter: (row) => (
      <DriverMovementFilter isClearable onChangeFilter={row.onChange} />
    ),
  },
  {
    Header: 'Fecha de Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Mes Asignado',
    accessor: 'chargeMonth',
    className: 'text-center',
    Cell: (row) => {
      const {
        original: { chargeMonth, chargeYear },
      } = row;
      if (!chargeMonth || !chargeYear) return '-';
      const month = MONTH_OPTIONS.find((m) => m.value === chargeMonth);
      return `${month ? month.label : chargeMonth} / ${chargeYear}`;
    },
    filterable: false,
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
  },
];

export const DRIVER_MOVEMENT_HISTORY_COLUMNS = [
  {
    Header: 'id',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Motivo',
    accessor: 'driverMovementName',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Días Faltantes',
    accessor: 'startDate',
    Cell: (row) => {
      const startDate = new Date(row.value);
      const endDate = new Date();
      if (startDate < endDate) {
        return 0;
      }
      const diffTime = Math.abs(startDate - endDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    className: 'text-center',
  },
  {
    Header: 'Observación 1',
    accessor: 'note',
    className: 'text-center',
  },
  {
    Header: 'Observación 2',
    accessor: 'secondaryNote',
    className: 'text-center',
  },
];

export const DRIVER_TRIP_HISTORY_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'departureTime',
    Cell: (row) =>
      tzNormalizeDate({ date: row.value, format: DATE_TIME_FORMAT }),
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    accessor: 'route.name',
    className: 'text-center',
  },
  {
    Header: 'Condición de Trabajo',
    accessor: 'city.region.country.name',
    className: 'text-center',
  },
  {
    Header: 'Número de Bus',
    accessor: 'companyBusId',
    className: 'text-center',
  },
];

export const CIRCUIT_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <TicketActiveFilter
        onChangeFilter={row.onChange}
        options={CIRCUIT_ACTIVE_OPTIONS}
      />
    ),
  },
  {
    Header: 'Número de rutas',
    accessor: 'circuitRouteList.length',
    id: 'circuitRouteList',
    className: 'text-center',
  },
];

export const CIRCUIT_ROUTE_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'routeId',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'route.name',
    className: 'text-center',
  },
  {
    Header: 'Source',
    accessor: 'route.sourceLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Destination',
    accessor: 'route.destinationLocation.name',
    className: 'text-center',
  },
];

export const REJECTED_EXPENSE_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 130,
  },
  {
    Header: 'Agencia',
    accessor: 'transactionList',
    id: 'transaction.salesSession.agencyId',
    Cell: (row) =>
      row.value[0].salesSession ? row.value[0].salesSession.agency.name : null,
    Filter: (row) => (
      <AgencyFilter onChangeFilter={row.onChange} visibilityRestricted />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Estado',
    accessor: 'expenseStatus',
    Cell: (row) => (row.value ? EXPENSE_STATUS[row.value].label : '-'),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={EXPENSE_STATUS}
      />
    ),
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Centro de Costo',
    accessor: 'costCenter.name',
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Tipo de egreso',
    accessor: 'transactionList',
    id: 'transaction.expenseTypeId',
    Cell: (row) => {
      if (!row.value) return null;
      const expenseTypeList = row.value.map(({ expenseType }) => ({
        text: expenseType.name,
      }));
      return <BadgeList cell textArray={expenseTypeList} />;
    },
    Filter: (row) => <ExpenseTypeFilter onChangeFilter={row.onChange} />,
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    width: 350,
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
    width: 350,
  },
  {
    Header: 'Total',
    accessor: 'transaction.amount',
    Cell: (row) => row.value && numberFormatter({ value: row.value }),
    className: 'text-center',
  },
  {
    Header: 'Motivo de Rechazo',
    accessor: 'expenseUpdateHistory.comment',
    className: 'text-center',
    width: 350,
    Cell: ({ value }) => {
      if (!value) return '';

      const comment = value.toLowerCase();
      const motivoIndex = comment.indexOf('motivo:');

      if (motivoIndex !== -1) {
        return comment.slice(motivoIndex + 7).trim();
      }

      return comment;
    },
  },
  {
    Header: 'Acción',
    className: 'text-center',
    accessor: 'id',
    Cell: (row) => (
      <i
        tabIndex={0}
        role="button"
        className="fa fa-search	text-info"
        style={{ cursor: 'pointer' }}
        onClick={(event) => {
          event.stopPropagation();
          window.open(`${EXPENSE_PATH}/${row.value}`, '_blank');
        }}
        onKeyPress={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.stopPropagation();
            window.open(`${EXPENSE_PATH}/${row.value}`, '_blank');
          }
        }}
      />
    ),
  },
];

export const DELIVERY_BUSINESS_COLUMNS = [
  {
    Header: 'N° de Documento',
    accessor: 'business.businessTaxId',
    Cell: ({ original }) => {
      const { business } = original;

      return `RUC: ${business.businessTaxId}`;
    },
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Razón Social/Nombre',
    accessor: 'business.name',
    Cell: ({ original }) => {
      const { business } = original;

      return business.name;
    },
    className: 'text-center',
    width: 350,
  },
  {
    Header: 'Agencias',
    accessor: 'agencyList',
    id: 'agencyList.agencyId',
    Cell: (row) => {
      if (!row.value) return null;
      const agencies = row.value.map(({ agency }) => ({
        text: agency.name,
      }));
      return <BadgeList cell textArray={agencies} />;
    },
    dataType: ColumnFilterDataTypes.ARRAY,
    Filter: (row) => <AgencyFilter onChangeFilter={row.onChange} />,
    className: 'text-center',
    sortable: false,
  },
  {
    Header: 'Usuarios',
    accessor: 'userList',
    id: 'userList.userId',
    Cell: (row) => {
      if (!row.value) return null;
      const users = row.value.map(({ user }) => ({
        text: user.customer.fullName,
      }));
      return <BadgeList cell textArray={users} />;
    },
    dataType: ColumnFilterDataTypes.ARRAY,
    Filter: (row) => <UserFilter onChangeFilter={row.onChange} />,
    className: 'text-center',
    sortable: false,
  },
  {
    Header: 'Estado',
    accessor: 'active',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter onChangeFilter={row.onChange} options={ACTIVE_OPTIONS} />
    ),
    className: 'text-center',
  },
];

export const DELIVERY_BUSINESS_AGENCY_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'agencyId',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'agency.name',
    className: 'text-center',
  },
];

export const DELIVERY_BUSINESS_USER_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'userId',
    className: 'text-center',
  },
  {
    Header: 'Usuario',
    accessor: 'user.username',
    className: 'text-center',
  },
  {
    Header: 'Nombres y Apeliidos',
    accessor: 'user.customer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Documento',
    accessor: 'user.customer.identificationType.name',
    className: 'text-center',
  },
  {
    Header: 'Número de Documento',
    accessor: 'user.customer.idDocumentNumber',
    className: 'text-center',
  },
];

export const DELIVERY_COLUMNS = [
  {
    Header: 'Agencia',
    accessor: 'agencyName',
    id: 'agency.name',
    className: 'text-center',
  },
  {
    Header: 'Usuario asignado',
    accessor: 'userFullName',
    id: 'user.customerId',
    Filter: (row) => (
      <CustomerFilter isClearable onChangeFilter={row.onChange} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Empresa',
    accessor: 'businessId',
    Filter: (row) => (
      <BusinessFilter isClearable onChangeFilter={row.onChange} />
    ),
    Cell: (row) =>
      `RUC: ${row.original.businessTaxId} - ${row.original.businessName}`,
    className: 'text-center',
  },
  {
    Header: 'Fecha de asignación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Estado',
    accessor: 'deliveryStatus',
    Cell: (row) => (
      <EnumStatus enumObject={DELIVERY_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={DELIVERY_STATUS}
      />
    ),
    className: 'text-center',
  },
];

export const CARGO_ITEMS_TO_DELIVER_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Dirección',
    accessor: 'deliveryAddress',
    className: 'text-center',
  },
  {
    Header: 'Consignados',
    accessor: 'consigneeCustomers',
    Cell: (row) => {
      if (!row.value) return null;
      const consigneeCustomers = row.value.map((consigneeCustomer) => ({
        text: `${consigneeCustomer.fullName} - ${consigneeCustomer.identificationTypeName} ${consigneeCustomer.idDocumentNumber}`,
      }));
      return <BadgeList cell textArray={consigneeCustomers} />;
    },
    className: 'text-center',
    filterable: false,
  },
];

export const DELIVERY_CARGO_ITEMS_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'cargoItemCorrelation',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Descripción',
    accessor: 'cargoItemDescription',
    className: 'text-center',
    width: 300,
  },
  {
    Header: 'Dirección',
    accessor: 'cargoItemDeliveryAddress',
    className: 'text-center',
    width: 400,
  },
  {
    Header: 'Consignados',
    accessor: 'cargoItemConsigneeCustomers',
    Cell: (row) => {
      if (!row.value) return null;
      const consigneeCustomers = row.value.map((consigneeCustomer) => ({
        text: consigneeCustomer.label,
      }));
      return <BadgeList cell textArray={consigneeCustomers} />;
    },
    className: 'text-center',
    filterable: false,
    width: 400,
  },
  {
    Header: 'Estado',
    accessor: 'cargoItemStatus',
    Cell: (row) => (
      <EnumStatus enumObject={CARGO_ITEM_STATUS} enumValue={row.value} />
    ),
    className: 'text-center',
    width: 200,
  },
];

export const DELIVERY_RETURN_CARGO_ITEMS_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'cargoItemCorrelation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'cargoItemDescription',
    className: 'text-center',
  },
];

export const CARGO_CORPORATE_CREDIT_CITY_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'cargoCorporateCredit.name',
    className: 'text-center',
  },
  {
    Header: 'Ciudades',
    accessor: 'city.name',
    className: 'text-center',
  },
];

export const CARGO_CORPORATE_CREDIT_CITY_COMMON_PRODUCT_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre Producto',
    accessor: 'productName',
    className: 'text-center',
  },
  {
    Header: 'Categoria',
    accessor: 'cargoCategory.name',
    className: 'text-center',
    Filter: (row) => <CargoCategoryFilter onChangeFilter={row.onChange} />,
    id: 'cargoCategoryId',
    dataType: ColumnFilterDataTypes.ARRAY,
  },
  {
    Header: 'Descripción Producto',
    accessor: 'productDescription',
    className: 'text-center',
  },
  {
    Header: 'Activo',
    accessor: 'active',
    Cell: (row) => <IsActive value={row.value} />,
    className: 'text-center',
    filterable: false,
  },
];

export const CARGO_CORPORATE_CREDIT_CITY_CUSTOMER_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'customer.id',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Nombre Completo',
    accessor: 'customer.fullName',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Documento',
    accessor: 'customer.identificationType.name',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Nº de Documento',
    accessor: 'customer.idDocumentNumber',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Cliente',
    accessor: 'customerType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={CARGO_CUSTOMER_TYPE} enumValue={row.value} />
    ),
  },
];

export const generateCargoCorporateCreditCityCustomerColumns = () => [
  {
    className: 'text-center',
    Expander: (expander) => {
      if (expander.original.customerList === 0) return null;
      if (expander.isExpanded) return <i className="fa fa-caret-up" />;
      return <i className="fa fa-caret-down" />;
    },
    getProps: (state, rowInfo) => {
      if (rowInfo && rowInfo.original.customerList === 0) {
        return {
          onClick: () => {},
        };
      }
      return {
        className: 'show-pointer',
      };
    },
    expander: true,
  },
  {
    Header: 'Ciudades',
    accessor: 'city.name',
    className: 'text-center',
  },
];

export const SHELVES_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Ubicación',
    accessor: 'location.name',
    className: 'text-center',
  },
];

export const CARGO_ITEM_RELOCATION_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    id: 'cargoCategoryId',
    Header: 'Categoría',
    accessor: 'cargoCategoryName',
    className: 'text-center',
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Anaquel',
    accessor: 'shelfName',
    className: 'text-center',
    Cell: (row) => {
      if (!row.value) return '-';
      const { shelfSpaceName } = row.original;
      return `${row.value} - ${shelfSpaceName}`;
    },
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => <CargoItemStatusCell value={row.value} />,
  },
  {
    Header: 'Ubicación',
    accessor: 'locationName',
    className: 'text-center',
    id: 'locationId',
  },
  {
    Header: 'Estado de Pago',
    accessor: 'paymentStatus',
    className: 'text-center',
    id: 'parcel.paymentStatus',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_PAYMENT_STATUS} enumValue={row.value} />
    ),
  },
];

export const CARGO_ITEM_RELOCATION_FILTER_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    id: 'cargoCategoryId',
    Header: 'Categoría',
    accessor: 'cargoCategoryName',
    className: 'text-center',
    Filter: (row) => (
      <CargoCategoryFilter onChangeFilter={row.onChange} isClearable isMulti />
    ),
    filterMethod: (filter, row) => {
      if (!filter.value || filter.value.length === 0) return true;
      // eslint-disable-next-line
      return filter.value.includes(row._original.cargoCategoryId);
    },
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Filter: (row) => (
      <EnumSelectFilter
        enumOptions={CARGO_ITEM_STATUS}
        onChangeFilter={row.onChange}
      />
    ),
    Cell: (row) => (
      <EnumStatus enumObject={CARGO_ITEM_STATUS} enumValue={row.value} />
    ),
    filterMethod: (filter, row) => {
      if (!filter.value) return true;
      // eslint-disable-next-line
      return filter.value === row._original.status;
    },
  },
  {
    Header: 'Ubicación',
    accessor: 'locationName',
    className: 'text-center',
    id: 'locationId',
  },
  {
    Header: 'Estado de Pago',
    accessor: 'paymentStatus',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_PAYMENT_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PARCEL_PAYMENT_STATUS}
      />
    ),
    filterMethod: (filter, row) => {
      if (!filter.value) return true;
      // eslint-disable-next-line
      const parcelPaymentStatus = row._original.paymentStatus;
      return parcelPaymentStatus === filter.value;
    },
  },
];

export const DELIVERY_LOCATION_DISTRICT_COLUMNS = [
  {
    Header: 'Nombre de Ubicación',
    accessor: 'locationName',
    id: 'locationId',
    className: 'text-center',
    Filter: (row) => (
      <LocationFilter onChangeFilter={row.onChange} isClearable />
    ),
    sortable: false,
  },
  {
    Header: 'Sectores',
    accessor: 'districtPostalCodeList',
    Cell: (row) => {
      if (!row.value) return null;
      const districtPostalCodes = row.value.map((districtPostalCode) => ({
        text: districtPostalCode.name,
      }));
      return <BadgeList cell textArray={districtPostalCodes} />;
    },
    className: 'text-center',
    filterable: false,
    sortable: false,
  },
];

export const DELIVERY_DISTRICT_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
];

export const DELIVERY_PRICE_CONFIGURATION_COLUMNS = [
  {
    Header: 'Mínimo de Kilogramo',
    accessor: 'minKilograms',
    className: 'text-center',
  },
  {
    Header: 'Máximo de Kilogramo',
    accessor: 'maxKilograms',
    className: 'text-center',
  },
];

export const COMMON_PRODUCT_PRICE_SCHEDULE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Archivo',
    accessor: 'file',
    className: 'text-center',
    Cell: (row) => (
      <LinkToModuleResource
        href={row.value}
        text={row.value}
        colorIcon="text-primary"
        isExternalPath
      />
    ),
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={COMMON_PRODUCT_PRICE_SCHEDULE_STATUS}
        enumValue={row.value}
      />
    ),
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
];

export const ITINERARY_FLOOR_VARIATION_HISTORY_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Usuario',
    accessor: 'userCustomerFullName',
    className: 'text-center',
  },
  {
    Header: 'Anterior Variación del Primer Piso',
    accessor: 'previousFirstFloorVariation',
    className: 'text-center',
  },
  {
    Header: 'Nueva Variación del Primer Piso',
    accessor: 'nextFirstFloorVariation',
    className: 'text-center',
  },
  {
    Header: 'Anterior Variación del Segundo Piso',
    accessor: 'previousSecondFloorVariation',
    className: 'text-center',
  },
  {
    Header: 'Nueva Variación del Segundo Piso',
    accessor: 'nextSecondFloorVariation',
    className: 'text-center',
  },
];

export const CABIN_CREW_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Apellidos',
    accessor: 'customer.lastName',
    className: 'text-center',
  },
  {
    Header: 'Nombres',
    accessor: 'customer.firstName',
    className: 'text-center',
  },
  {
    Header: 'Pasaporte/DNI',
    accessor: 'customer.idDocumentNumber',
    className: 'text-center',
  },
];

export const CABIN_CREW_DOCUMENT_COLUMNS = [
  {
    Header: 'Tipo de Documento',
    accessor: 'cabinCrewDocumentType.name',
    className: 'text-center',
  },
  {
    Header: 'Número',
    accessor: 'documentNumber',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Expedición',
    accessor: 'effectiveDate',
    Cell: (row) => <DateCell value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Fecha de Expiración',
    accessor: 'expirationDate',
    Cell: (row) => <DateCell value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'PDF',
    accessor: 'fileUrl',
    Cell: (row) =>
      row.value != null && (
        <a href={row.value} target="_blank" rel="noopener noreferrer">
          <i className="fa fa-file-pdf-o mr-1" /> Ver PDF
        </a>
      ),
    className: 'text-center',
  },
  {
    Header: 'Notas',
    accessor: 'note',
    className: 'text-center',
  },
];

export const CABIN_CREW_CONTRACT_COLUMNS = [
  {
    Header: 'Tipo de Contrato',
    accessor: 'cabinCrewContractType.name',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Expedición',
    accessor: 'effectiveDate',
    Cell: (row) => <DateCell value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Fecha de Expiración',
    accessor: 'expirationDate',
    Cell: (row) => <DateCell value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Razón de Terminación',
    accessor: 'reason',
    className: 'text-center',
  },
  {
    Header: 'Notas',
    accessor: 'note',
    className: 'text-center',
  },
];

export const CABIN_CREW_ITINERARY_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'departureTime',
    Cell: (row) => <DateCell value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Número de Bus',
    accessor: 'companyBusId',
    id: 'trip.assignedRegisteredBus.companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    accessor: 'routeName',
    id: 'route.name',
    className: 'text-center',
  },
  {
    Header: 'KM',
    accessor: 'routeKM',
    sortable: false,
    className: 'text-center',
  },
  {
    Header: 'Horas',
    accessor: 'routeHours',
    sortable: false,
    className: 'text-center',
  },
];

export const TIMETABLE_TEMPLATE_COLUMNS = [
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
  },
  {
    Header: 'Hora de Salida',
    accessor: 'departureTime',
    className: 'text-center',
  },
  {
    Header: 'Duración',
    accessor: 'duration',
    className: 'text-center',
    Cell: (row) => timeFormat(row.value),
  },
  {
    Header: 'Ajuste de Duración',
    accessor: 'durationAdjustment',
    className: 'text-center',
    Cell: (row) => timeFormat(row.value),
  },
  {
    Header: 'Hora de Llegada',
    accessor: 'arrivalTime',
    className: 'text-center',
  },
  {
    Header: 'Tiempo de Escala',
    accessor: 'layover',
    className: 'text-center',
    Cell: (row) => timeFormat(row.value),
  },
];

export const TIMETABLE_TEMPLATE_WITH_REAL_TIME_COLUMNS = [
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
  },
  {
    Header: 'Hora de Salida',
    accessor: 'departureTime',
    className: 'text-center',
  },
  {
    Header: 'Duración',
    accessor: 'duration',
    className: 'text-center',
    Cell: (row) => timeFormat(row.value),
  },
  {
    Header: 'Ajuste de Duración',
    accessor: 'durationAdjustment',
    className: 'text-center',
    Cell: (row) => timeFormat(row.value),
  },
  {
    Header: 'Hora de Llegada',
    accessor: 'arrivalTime',
    className: 'text-center',
  },
  {
    Header: 'Tiempo de Escala',
    accessor: 'layover',
    className: 'text-center',
    Cell: (row) => timeFormat(row.value),
  },
  {
    Header: 'Hora real de Salida',
    accessor: 'realTimeDepartureTime',
    className: 'text-center',
  },
  {
    Header: 'Hora real de Llegada',
    accessor: 'realTimeArrivalTime',
    className: 'text-center',
  },
];

export const MY_RESERVATIONS_COLUMNS = [
  {
    Header: 'Fecha de Viaje',
    accessor: 'departureDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center align-self-center',
    width: 160,
    filterable: false,
  },
  {
    Header: 'Nro. documento',
    accessor: 'customer.idDocumentNumber',
    className: 'text-center align-self-center',
    width: 150,
  },
  {
    Header: 'Nombres',
    accessor: 'customer.firstName',
    className: 'text-center align-self-center',
    width: 200,
  },
  {
    Header: 'Apellidos',
    accessor: 'customer.lastName',
    className: 'text-center align-self-center',
    width: 200,
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocation.name',
    className: 'text-center align-self-center',
    width: 200,
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocation.name',
    className: 'text-center align-self-center',
    width: 200,
  },
  {
    Header: 'Núm. Asiento',
    accessor: 'seatReservation.seat.seatNumber',
    className: 'text-center align-self-center',
    width: 100,
    filterable: false,
  },
  {
    Header: 'Estado',
    accessor: 'ticketStatus',
    className: 'text-center align-self-center',
    Cell: (row) => (
      <EnumStatus enumObject={TICKET_STATUS} enumValue={row.value} />
    ),
    width: 200,
    filterable: false,
  },
  {
    Header: '',
    className: 'text-center',
    notNavigateToModel: true,
    Cell: (row) =>
      row.original.ticketStatus === TICKET_STATUS.ACTIVE.value && (
        <VoidTicketButton
          ticketId={row.original.id}
          email={row.original.customer.email}
          className="p-1"
          afterVoidTicket={row.tdProps.rest.rest.fetch}
        />
      ),
    filterable: false,
  },
];

export const genereateMyReservationsActiveProcessColumns = (
  dispatchGetActiveProcess,
  dispatchPush,
  mobilizing,
) => [
  {
    Header: 'Fecha de Embarque',
    className: 'text-center',
    accessor: 'departureTime',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Día',
    className: 'text-center',
    accessor: 'id',
    Cell: (row) => <>{getDayFromTimestamp(row.original.departureTime)}</>,
    filterMethod: (filter, row) => {
      if (!filter.value) return true;
      const day = getDayFromTimestamp(row.departureTime).toLowerCase();
      return day.includes(filter.value.toLowerCase());
    },
  },
  {
    Header: 'Programación',
    className: 'text-center',
    accessor: 'name',
  },
  {
    Header: 'Tipo',
    className: 'text-center',
    accessor: 'staffType',
    Cell: (row) => (
      <EnumStatus enumObject={COMPANY_STAFF_TYPE} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={COMPANY_STAFF_TYPE}
      />
    ),
  },
  {
    Header: 'Reservar',
    className: 'text-center',
    Cell: (row) => (
      <i
        tabIndex="0"
        role="button"
        className="fa fa-list"
        onClick={async () => {
          await dispatchGetActiveProcess(row.original);
          dispatchPush(
            `/my-reservations/booking/search?mobilizing=${mobilizing}`,
          );
        }}
        onKeyPress={async () => {
          await dispatchGetActiveProcess(row.original);
          dispatchPush(
            `/my-reservations/booking/search?mobilizing=${mobilizing}`,
          );
        }}
      />
    ),
  },
];

export const generatePrintBillingColumnsDelivery = (
  printBilling,
  printContingency,
) => [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Serie Doc. Ref.',
    accessor: 'refDocumentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo Doc. Ref.',
    accessor: 'refDocumentCode',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: ({ value }) => STATUS_TRANSLATIONS[value] || value,
    className: 'text-center',
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => {
      if (row.original.status === 'PROCESSED') {
        return (
          <Button
            color="primary"
            onClick={() => printBilling(row.original.ticketId)}
          >
            Imprimir
          </Button>
        );
      }

      return (
        <Button
          color="warning"
          onClick={() => printContingency(row.original.id)}
        >
          Imprimir Contingencia
        </Button>
      );
    },
  },
];

export const BUS_ASSIGNMENT_SCHEDULE_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Circuitos',
    accessor: 'circuitList',
    className: 'text-center',
    Cell: (row) => {
      if (!row.value) return null;
      const circuits = row.value.map(({ name, id }) => ({
        text: `${id} - ${name}`,
      }));
      return <BadgeList cell textArray={circuits} />;
    },
    filterable: false,
  },
  {
    Header: 'Bus',
    accessor: 'busAssignmentScheduleBusList',
    id: 'registeredBus',
    className: 'text-center',
    Cell: (row) => {
      if (!row.value) return null;
      const buses = row.value.map(({ registeredBus }) => ({
        text: registeredBus.companyBusId,
      }));
      return <BadgeList cell textArray={buses} />;
    },
    filterable: false,
  },
  {
    Header: 'Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Fin',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'active',
    Cell: (row) => <Checkbox checked={row.value} />,
    className: 'text-center',
  },
];

export const ROUTE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'name',
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <TicketActiveFilter
        onChangeFilter={row.onChange}
        options={ROUTE_ACTIVE_OPTIONS}
      />
    ),
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
];
export const ROUTE_SEGMENT_COLUMNS = [
  {
    Header: 'Origen',
    accessor: 'segment.sourceLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'segment.destinationLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Distancia',
    accessor: 'segment.distance',
    className: 'text-center',
  },
];

export const ROUTE_DATA_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Inicio del Servicio',
    accessor: 'serviceStartDate',
    Cell: (row) => <DateCell format={DATE_FORMAT} value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Fin del Servicio',
    accessor: 'serviceEndDate',
    Cell: (row) => <DateCell format={DATE_FORMAT} value={row.value} />,
    className: 'text-center',
  },
];

export const CITIES_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Región',
    accessor: 'region.name',
    className: 'text-center',
  },
  {
    Header: 'País',
    accessor: 'region.country.name',
    className: 'text-center',
  },
];

export const generateBusMaintenanceStayColumnsForBulk = ({
  handleEdit,
  handleMarkForDelete,
  handleClearRow,
}) => [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Número de Bus',
    accessor: 'registeredBus.companyBusId',
    className: 'text-center',
    width: 130,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'registeredBus.serviceTypeName',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Origen',
    accessor: 'originCity.name',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Fecha de Llegada',
    accessor: 'estimatedArrivalDate',
    Cell: (row) =>
      row.value ? (
        <DateCell format={DATE_TIME_FORMAT} value={row.value} />
      ) : (
        '-'
      ),
    className: 'text-center',
    filterable: false,
    width: 200,
  },
  {
    Header: 'Fecha de Entrega',
    accessor: 'estimatedCompletionDate',
    Cell: (row) =>
      row.value ? (
        <DateCell format={DATE_TIME_FORMAT} value={row.value} />
      ) : (
        '-'
      ),
    className: 'text-center',
    filterable: false,
    width: 200,
  },
  {
    Header: 'Estado',
    accessor: 'maintenanceStayStatus',
    Cell: (row) =>
      row.value
        ? (BUS_MAINTENANCE_STATUS_TYPE[row.value] &&
            BUS_MAINTENANCE_STATUS_TYPE[row.value].label) ||
          row.value
        : '-',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(BUS_MAINTENANCE_STATUS_TYPE)}
      />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Observación',
    accessor: 'observation',
    className: 'text-center',
  },
  {
    Header: 'Acción',
    className: 'text-center',
    accessor: 'id',
    Cell: (cell) => {
      const { original, index } = cell;
      return (
        <div className="d-flex justify-content-center align-items-center">
          <EditBusMaintenanceStayButton
            handleEdit={handleEdit}
            busMaintenanceStay={original}
            index={index}
          />

          <BusMaintenanceStayDeleteButton
            maintenanceStay={original}
            handleMarkForDelete={handleMarkForDelete}
          />

          <BusMaintenanceStayClearButton
            handleClearRow={handleClearRow}
            busMaintenanceStay={original}
          />
        </div>
      );
    },
    filterable: false,
    width: 200,
  },
];

export const BUSINESS_TICKET_CHANGE_HISTORY_COLUMNS = [
  {
    Header: 'Usuario',
    accessor: 'user.fullName',
    className: 'text-center',
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    className: 'text-center',
    Cell: ({ value }) =>
      tzNormalizeDate({
        date: value,
        format: DATE_TIME_FORMAT,
      }),
  },
  {
    Header: 'Metodo de Pago',
    accessor: 'newPaymentMethod.name',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <>
          <span>{row.original.oldPaymentMethod.name}</span>{' '}
          <i className="fa fa-long-arrow-right" aria-hidden="true" />{' '}
          <span>{row.value}</span>
        </>
      ) : (
        '-'
      ),
  },
  {
    Header: 'Razón Social',
    accessor: 'newBusinessName',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <>
          <span>{row.original.oldBusinessName}</span>{' '}
          <i className="fa fa-long-arrow-right" aria-hidden="true" />{' '}
          <span>{row.value}</span>
        </>
      ) : (
        '-'
      ),
  },
  {
    Header: 'Ruc',
    accessor: 'newBusinessTaxId',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <>
          <span>{row.original.oldBusinessTaxId}</span>{' '}
          <i className="fa fa-long-arrow-right" aria-hidden="true" />{' '}
          <span>{row.value}</span>
        </>
      ) : (
        '-'
      ),
  },
  {
    Header: 'Comentario',
    accessor: 'comment',
    className: 'text-center',
  },
];

export const CUSTOMER_TICKET_CHANGE_HISTORY_COLUMNS = [
  {
    Header: 'Usuario',
    accessor: 'user.fullName',
    className: 'text-center',
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    className: 'text-center',
    Cell: ({ value }) =>
      tzNormalizeDate({
        date: value,
        format: DATE_TIME_FORMAT,
      }),
  },
  {
    Header: 'Metodo de Pago',
    accessor: 'newPaymentMethod.name',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <>
          <span>{row.original.oldPaymentMethod.name}</span>{' '}
          <i className="fa fa-long-arrow-right" aria-hidden="true" />{' '}
          <span>{row.value}</span>
        </>
      ) : (
        '-'
      ),
  },
  {
    Header: 'Número de Documento',
    accessor: 'newIdDocumentNumber',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <>
          <span>{row.original.oldIdDocumentNumber}</span>{' '}
          <i className="fa fa-long-arrow-right" aria-hidden="true" />{' '}
          <span>{row.value}</span>
        </>
      ) : (
        '-'
      ),
  },
  {
    Header: 'Comentario',
    accessor: 'comment',
    className: 'text-center',
  },
];

export const IDLING_CONSUMPTION_OBSERVATION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'ID Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
    Cell: (row) => (
      <LinkToModuleResource
        href={`${ITINERARY_FOR_COUNTER_PATH}/${row.value}`}
        text={row.value}
        colorIcon="text-primary"
        isExternalPath
      />
    ),
  },
  {
    Header: 'Ruta',
    id: 'itinerary.route.id',
    Filter: (row) => <RouteSelect onChangeFilter={row.onChange} useForFilter />,
    accessor: 'routeName',
    className: 'text-center',
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    id: 'itinerary.trip.assignedRegisteredBus.companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Galones Autorizados',
    accessor: 'idlingConsumptionNumberOfGallon',
    className: 'text-center',
  },
  {
    Header: 'Galones Consumidos (Real)',
    accessor: 'realIdlingConsumptionNumberOfGallon',
    className: 'text-center',
  },
  {
    Header: 'Tiempo Parado (Minutos)',
    accessor: 'idlingConsumptionTime',
    className: 'text-center',
  },
  {
    Header: 'Tiempo Parado Real (Minutos)',
    accessor: 'realIdlingConsumptionTime',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 130,
  },
];

export const ITINERARY_HISTORY_ALERT_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'timestamp',
    Cell: ({ value }) =>
      tzNormalizeDate({
        date: value,
        format: DATE_TIME_FORMAT,
      }),
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Descripción',
    accessor: 'alertDescription',
    className: 'text-center',
  },
  {
    Header: 'Dirección',
    accessor: 'address',
    className: 'text-center',
  },
  {
    Header: 'Velocidad (km/h)',
    accessor: 'speed',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Latitud',
    accessor: 'latitude',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Longitud',
    accessor: 'longitude',
    className: 'text-center',
    width: 200,
  },
];

export const ITINERARY_GEOFENCE_ALERT_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'timestamp',
    Cell: ({ value }) =>
      tzNormalizeDate({
        date: value,
        format: DATE_TIME_FORMAT,
      }),
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Ubicación',
    accessor: 'location.name',
    className: 'text-center',
  },
  {
    Header: 'Dirección',
    accessor: 'location.address',
    className: 'text-center',
  },
  {
    Header: 'Tipo',
    accessor: 'geofenceAlertType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={GEOFENCE_ALERT_TYPE} enumValue={row.value} />
    ),
  },
];

export const ITINERARY_FOR_COUNTER_PASSENGER_FLOW_COLUMNS = [
  {
    Header: 'Asiento',
    accessor: 'seatNumber',
    className: 'text-center',
  },
  {
    Header: 'Pasajero',
    accessor: 'customerFullName',
    className: 'text-center',
    minWidth: 350,
  },
  {
    Header: 'Edad',
    accessor: 'age',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'DOC ID',
    accessor: 'customerDocumentNumber',
    className: 'text-center',
    minWidth: 150,
  },
  {
    Header: 'Boleto',
    accessor: 'ticketCode',
    className: 'text-center',
    minWidth: 150,
  },
  {
    Header: 'Estado',
    accessor: 'boarded',
    Cell: (row) => {
      let enumValue;

      switch (row.value) {
        case true:
          enumValue = TICKET_BOARDED_STATUS_CODE.BOARDED.value;
          break;
        case false:
          enumValue = TICKET_BOARDED_STATUS_CODE.UNBOARDED.value;
          break;
        case null:
        default:
          enumValue = TICKET_BOARDED_STATUS_CODE.UNREGISTERED.value;
          break;
      }

      return (
        <EnumStatus
          enumObject={TICKET_BOARDED_STATUS_CODE}
          enumValue={enumValue}
        />
      );
    },
    className: 'text-center',
  },
];

export const LEGAL_CARGO_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
    width: 110,
  },
  {
    Header: 'Cliente',
    accessor: 'customerFullName',
    className: 'text-center',
  },
  {
    Header: 'Empresa',
    accessor: 'businessName',
    className: 'text-center',
  },
  {
    Header: 'Remitente',
    accessor: 'senderCustomerFullName',
    className: 'text-center',
  },
  {
    Header: 'Consignado',
    accessor: 'consigneeCustomerFullName',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
  },
  {
    Header: 'Fecha de creación',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
];

export const generateLegalTicketColumns = (printAction) => [
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    Cell: (row) => padStart(row.value, '7'),
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Fecha de Emisión',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 160,
  },
  {
    Header: 'Cliente',
    accessor: 'customerFullName',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Viaje',
    accessor: 'departureDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Precio',
    accessor: 'salePrice',
    Cell: (row) =>
      numberFormatter({
        style: 'currency',
        value: row.value,
      }),
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Acción',
    accessor: 'idSourceSystem',
    className: 'text-center',
    Cell: (row) => {
      const system = row.original.idSourceSystem.split('-')[0];
      return (
        system === LEGAL_SOURCE_SYSTEM.FLIT.value && (
          <Button color="secondary" onClick={() => printAction(row.original)}>
            Imprimir
          </Button>
        )
      );
    },
    width: 150,
  },
];

export const generateLegalManifestCargoColumns = (generateExcel) => [
  {
    className: 'text-center',
    Expander: (expander) => {
      if (expander.original.manifestCargoItemDetails === 0) return null;

      if (expander.isExpanded) return <i className="fa fa-caret-up" />;

      return <i className="fa fa-caret-down" />;
    },
    getProps: (state, rowInfo) => {
      if (rowInfo && rowInfo.original.manifestCargoItemDetails === 0) {
        return {
          onClick: () => {},
        };
      }
      return {
        className: 'show-pointer',
      };
    },
    expander: true,
  },
  {
    Header: 'Fecha de Salida',
    accessor: 'exitDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Origen',
    id: 'sourceLocationName',
    accessor: 'sourceLocationName',
    className: 'text-center',
    Cell: (row) => row.value,
  },
  {
    Header: 'Destino',
    id: 'destinationLocationName',
    accessor: 'destinationLocationName',
    className: 'text-center',
    Cell: (row) => row.value,
  },
  {
    Header: 'Hora de Salida',
    accessor: 'exitDate',
    className: 'text-center',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Acción',
    accessor: 'idSourceSystem',
    className: 'text-center',
    Cell: (row) => (
      <Button color="secondary" onClick={() => generateExcel(row)}>
        Imprimir
      </Button>
    ),
  },
];

export const LEGAL_MANIFEST_CARGO_DETAIL_COLUMNS = [
  {
    Header: 'Correlativo',
    accessor: 'correlation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Consignado',
    accessor: 'consigneeName',
    className: 'text-center',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
    className: 'text-center',
  },
];

export const generateManifestTicketColumns = (generateFileExport) => [
  {
    Header: 'Código de Manifiesto',
    id: 'manifestCode',
    accessor: 'manifestCode',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    id: 'sourceLocationName',
    accessor: 'sourceLocationName',
    className: 'text-center',
    Cell: (row) => row.value,
  },
  {
    Header: 'Destino',
    id: 'destinationLocationName',
    accessor: 'destinationLocationName',
    className: 'text-center',
    Cell: (row) => row.value,
  },
  {
    Header: 'Fecha de Salida',
    accessor: 'departureDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Hora de Salida',
    accessor: 'departureDate',
    className: 'text-center',
    Cell: (row) => <DateCell format={TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <Button color="secondary" onClick={() => generateFileExport(row)}>
        Imprimir
      </Button>
    ),
    width: 150,
  },
];

export const LEGAL_MANIFEST_PASSENGER_DETAIL_COLUMNS = [
  {
    Header: 'Nº de Documento',
    accessor: 'ticketNumber',
    className: 'text-center',
  },
  {
    Header: 'Nombre del Pasajero',
    accessor: 'customerName',
    className: 'text-center',
  },
  {
    Header: 'Piso',
    accessor: 'floorNumber',
    className: 'text-center',
  },
  {
    Header: 'Nª de Asiento',
    accessor: 'seatNumber',
    className: 'text-center',
  },
  {
    Header: 'Costo',
    accessor: 'amount',
    className: 'text-center',
  },
];

export const generateLegalManifestBaggageColumns = (action) => [
  {
    Header: 'Fecha de Salida',
    accessor: 'departureDate',
    className: 'text-center',
    Cell: (row) =>
      tzNormalizeDate({ date: row.value, format: DATE_TIME_FORMAT }),
  },
  {
    Header: 'Origen',
    id: 'sourceLocationName',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    id: 'destinationLocationName',
    accessor: 'destinationLocationName',
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    id: 'routeName',
    accessor: 'routeName',
    className: 'text-center',
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <Button color="secondary" onClick={() => action(row.original)}>
        Imprimir
      </Button>
    ),
    width: 150,
  },
];

export const LEGAL_MANIFEST_BAGGAGE_DETAIL_COLUMNS = [
  {
    Header: 'N° Boleto',
    accessor: 'ticketFullDocumentCode',
    className: 'text-center',
    Cell: (row) => row.value.join(', '),
  },
  {
    Header: 'N° Ticket Equipaje',
    accessor: 'itemCorrelation',
    className: 'text-center',
  },
  {
    Header: 'Embarque',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Desembarque',
    accessor: 'destinationLocationName',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Exceso P',
    accessor: 'excessDocumentCode',
    className: 'text-center',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
    className: 'text-center',
  },
];

export const DISCOUNT_CODE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Código',
    accessor: 'code',
    className: 'text-center',
  },
  {
    Header: 'Descuento',
    accessor: 'discount',
    Cell: ({ value }) => `${value}%`,
    className: 'text-center',
  },
  {
    Header: 'Válido',
    accessor: 'isValid',
    Cell: (row) => <Checkbox checked={row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Restricciones',
    accessor: 'isRestriction',
    Cell: (row) => <Checkbox checked={row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Estado',
    accessor: 'isValid',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <TicketActiveFilter
        onChangeFilter={row.onChange}
        options={ITINERARY_ACTIVE_OPTIONS}
      />
    ),
  },
];

export const DISCOUNT_CODE_EXCLUDE_DATE_COLUMN = [
  {
    Header: 'Desde',
    accessor: 'dateFrom',
    Cell: (row) => <DateCell format={DATE_FORMAT} value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Hasta',
    accessor: 'dateUntil',
    Cell: (row) => <DateCell format={DATE_FORMAT} value={row.value} />,
    className: 'text-center',
  },
];

export const DISCOUNT_CODE_ROUTE_COLUMN = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
  },
];

export const DISCOUNT_CODE_CLIENT_COLUMN = [
  {
    Header: 'Nombre',
    accessor: 'fullName',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Documento',
    accessor: 'identificationType.name',
    className: 'text-center',
  },
  {
    Header: 'Número de Documento',
    accessor: 'idDocumentNumber',
    className: 'text-center',
  },
];

export const DISCOUNT_CODE_USER_COLUMN = [
  {
    Header: 'Nombre',
    accessor: 'fullName',
    className: 'text-center',
  },
  {
    Header: 'Usuario',
    accessor: 'username',
    className: 'text-center',
  },
];

export const DISCOUNT_CODE_SERVICE_TYPE_COLUMN = [
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType.name',
    className: 'text-center',
  },
  {
    Header: 'Piso',
    accessor: 'discountFloorRule',
    Cell: (row) => (
      <EnumStatus enumObject={DISCOUNT_CODE_FLOOR_RULE} enumValue={row.value} />
    ),
    className: 'text-center',
  },
];

export const DISCOUNT_CODE_CATEGORY_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Activo',
    accessor: 'active',
    className: 'text-center',
    filterable: false,
    Cell: (row) => <IsActive value={row.value} />,
  },
];

export const DISCOUNT_CODE_SUB_CATEGORY_COLUMN = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Activo',
    accessor: 'active',
    className: 'text-center',
    filterable: false,
    Cell: (row) => <IsActive value={row.value} />,
  },
  {
    Header: 'Autorizadores',
    accessor: 'discountCodeSubCategoryAuthorizerList',
    id: 'authorizers',
    Cell: (row) => {
      if (!Array.isArray(row.value) || row.value.length === 0) return null;

      const names = row.value
        .map(
          (a) =>
            a.discountCodeAuthorizer.customer.fullName ||
            [
              a.discountCodeAuthorizer.customer.firstName,
              a.discountCodeAuthorizer.customer.lastName,
            ]
              .filter(Boolean)
              .join(' '),
        )
        .filter(Boolean);

      const discountAuthorizer = names.map((n) => ({ text: n }));

      return <BadgeList cell textArray={discountAuthorizer} />;
    },
    className: 'text-center',
    filterable: false,
  },
];

export const DELIVERY_POSTAL_CODE_PRICE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Ubicación',
    accessor: 'location.name',
    id: 'locationId',
    className: 'text-center',
    Filter: (row) => (
      <LocationFilter onChangeFilter={row.onChange} isClearable />
    ),
  },
  {
    Header: 'Archivo',
    accessor: 'file',
    className: 'text-center',
    Cell: (row) => (
      <LinkToModuleResource
        href={row.value}
        text={row.value}
        colorIcon="text-primary"
        isExternalPath
      />
    ),
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Activo',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_PRICE_STATUS} enumValue={row.value} />
    ),
    className: 'text-center',
  },
];

export const DISCOUNT_CODE_AUTHORIZER_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'customer.firstName',
    className: 'text-center',
  },
  {
    Header: 'Apellido',
    accessor: 'customer.lastName',
    className: 'text-center',
  },
  {
    Header: 'Activo',
    accessor: 'active',
    className: 'text-center',
    filterable: false,
    Cell: (row) => <IsActive value={row.value} />,
  },
];

export const SENDER_REMISSION_GUIDE_ITEM_COLUMNS = [
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Área',
    accessor: 'companyArea.name',
    className: 'text-center',
  },
  {
    Header: 'Peso (Kg)',
    accessor: 'weight',
    className: 'text-center',
  },
  {
    Header: 'Observación',
    accessor: 'observation',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={SENDER_REMISSION_GUIDE_ITEM_PICKUP_STATUS}
        enumValue={row.value}
      />
    ),
  },
  {
    Header: 'Estado de Cierre',
    accessor: 'closureStatus',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={SENDER_REMISSION_GUIDE_CLOSURE_STATUS}
        enumValue={row.value}
      />
    ),
  },
];

export const BANK_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'País',
    accessor: 'country.name',
    className: 'text-center',
  },
];

export const BANK_ACCOUNT_COLUMNS = [
  {
    Header: 'Entidad Financiera',
    accessor: 'bank.name',
    className: 'text-center',
  },
  {
    Header: 'Cuenta Corriente',
    accessor: 'accountNumber',
    className: 'text-center',
  },
  {
    Header: 'Moneda',
    accessor: 'currency',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={CURRENCY_TYPE} enumValue={row.value} />
    ),
  },
  {
    Header: 'Convenio/Recaudación',
    accessor: 'receipt',
    className: 'text-center',
  },
  {
    Header: 'Cuenta Interbancario (CCI)',
    accessor: 'interbankNumber',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
  },
  {
    Header: 'Empresa',
    accessor: 'business.name',
    className: 'text-center',
  },
  {
    Header: 'Tabla Sunat',
    accessor: 'sunatTableCode',
    className: 'text-center',
  },
  {
    Header: 'Orden',
    accessor: 'orderNumber',
    className: 'text-center',
  },
];

export const DRIVER_FOR_SCHEDULING_COLUMNS = [
  {
    id: 'departureDate',
    Header: 'Fecha',
    accessor: 'departureDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    width: 150,
    filtered: false,
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
    width: 250,
  },
  {
    id: 'departureTime',
    Header: 'Hora',
    accessor: (d) => d.departureDate,
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={TIME_FORMAT} />,
    width: 100,
    filtered: false,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceTypeName',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    width: 150,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Base del Bus',
    accessor: 'registeredBusHomeBaseName',
    className: 'text-center',
    width: 200,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Conductor 1',
    accessor: 'driverOneName',
    className: 'text-center',
    width: 500,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Conductor 2',
    accessor: 'driverTwoName',
    className: 'text-center',
    width: 500,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Conductor 3',
    accessor: 'driverThreeName',
    className: 'text-center',
    width: 500,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Itinerario ID',
    accessor: 'itineraryId',
    className: 'text-center',
    Cell: (row) => (
      <LinkToModuleResource
        href={`${ITINERARY_FOR_COUNTER_PATH}/${row.value}`}
        text={row.value}
        isExternalPath
      />
    ),
    width: 150,
  },
  {
    Header: 'Estado',
    accessor: 'itineraryActive',
    className: 'text-center',
    width: 150,
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter onChangeFilter={row.onChange} options={ACTIVE_OPTIONS} />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];

      if (filterValue === undefined || filterValue === null) {
        return true;
      }

      if (Array.isArray(filterValue)) {
        if (filterValue.length === 0) {
          return true;
        }
        return filterValue.includes(rowValue);
      }

      return filterValue === rowValue;
    },
  },
  {
    Header: 'Dirección',
    accessor: 'itineraryDirection',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={ITINERARY_DIRECTION} enumValue={row.value} />
    ),
    width: 250,
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(ITINERARY_DIRECTION)}
      />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
  },
  {
    Header: 'Ruta',
    accessor: 'routeName',
    className: 'text-center',
    width: 400,
  },
];

export const REGISTERED_BUS_FLEET_COLUMNS = [
  {
    Header: 'Número de Bus',
    accessor: 'companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Placa',
    accessor: 'licensePlate',
    className: 'text-center',
  },
  {
    Header: 'Itinerario',
    accessor: 'lastItineraryId',
    className: 'text-center',
    Cell: (row) => {
      const { lastDestinationLocation } = row.original;
      if (!row.value) return '-';
      return (
        <LinkToModuleResource
          href={`${ITINERARY_FOR_COUNTER_PATH}/${row.value}`}
          text={lastDestinationLocation}
          isExternalPath
        />
      );
    },
  },
  {
    Header: 'Tipo de Servicio',
    id: 'serviceTypeId',
    accessor: 'serviceTypeId',
    className: 'text-center',
    Cell: (row) => row.original.serviceTypeName || '-',
    Filter: (row) => (
      <ServiceTypeFilter onChangeFilter={row.onChange} isClearable />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
  },
  {
    Header: 'Estado de Mantenimiento',
    accessor: 'maintenanceStatus',
    className: 'text-center',
    Cell: (row) =>
      row.value
        ? MAINTENANCE_STAY_STATUS_OPTIONS.find(
            (option) => option.value === row.value,
          ).label
        : '-',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={MAINTENANCE_STAY_STATUS_OPTIONS}
      />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
  },
  {
    Header: 'Estado Comercial',
    accessor: 'eventStatus',
    className: 'text-center',
    Cell: (row) =>
      row.value
        ? COMMERCIAL_STATUS_OPTIONS.find((option) => option.value === row.value)
            .label
        : '-',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={COMMERCIAL_STATUS_OPTIONS}
      />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
  },
  {
    accessor: 'eventStartDate',
    Header: 'Inicio Estado Comercial',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell format={DATE_TIME_FORMAT} value={row.value} />
      ) : (
        '-'
      ),
    filterable: false,
  },
  {
    Header: 'Fin Estado Comercial',
    accessor: 'eventEndDate',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell format={DATE_TIME_FORMAT} value={row.value} />
      ) : (
        '-'
      ),
    filterable: false,
  },
  {
    Header: 'Estado de retén',
    accessor: 'activatedItineraryId',
    className: 'text-center',
    Cell: (row) => {
      const { eventStatus } = row.original;

      if (eventStatus === COMMERCIAL_STATUS.STANDBY.value) {
        const { activatedItineraryId } = row.original;
        if (activatedItineraryId) {
          return (
            <>
              <IsActive value />
              <LinkToModuleResource
                href={`${ITINERARY_FOR_COUNTER_PATH}/${activatedItineraryId}`}
                isExternalPath
              />
            </>
          );
        }
        return <IsActive value={false} />;
      }
      return null;
    },
    filterable: false,
  },
  {
    Header: 'Acciones',
    accessor: 'registeredBusId',
    className: 'text-center',
    Cell: (row) => (
      <BusRetentionScheduleActionsCell registeredBusFleet={row.original} />
    ),
    filterable: false,
  },
];

export const generateBusCurrentStatusColumns = ({ evaluatedAt, onRefresh }) => [
  {
    Header: 'Número de Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Placa',
    accessor: 'licensePlate',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Tipo de Servicio',
    id: 'serviceTypeId',
    accessor: 'serviceTypeId',
    className: 'text-center',
    Cell: (row) => row.original.serviceTypeName || '-',
    Filter: (row) => (
      <ServiceTypeFilter onChangeFilter={row.onChange} isClearable />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
  },
  {
    Header: 'Estado',
    accessor: 'currentStatus',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={COMMERCIAL_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={COMMERCIAL_STATUS_OPTIONS}
      />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
  },
  {
    Header: 'En este estado desde',
    accessor: 'currentStatusSince',
    className: 'text-center',
    Cell: (row) => {
      if (!row.value) return '-';

      const { currentStatus, statusEvidence } = row.original;
      const departureDate =
        currentStatus === COMMERCIAL_STATUS.PROGRAMMED.value &&
        statusEvidence &&
        statusEvidence.eventType === STATUS_EVENT_TYPE.ITINERARY.value &&
        statusEvidence.startDate;

      const isFutureDeparture =
        departureDate &&
        tzDiff({
          startDate: evaluatedAt || undefined,
          endDate: departureDate,
          unit: 'minutes',
        }) > 0;

      if (isFutureDeparture) {
        const remaining = elapsedTimeFormat(
          tzDiff({
            startDate: evaluatedAt || undefined,
            endDate: departureDate,
            unit: 'minutes',
          }),
        );

        return (
          <>
            <DateCell format={DATE_TIME_FORMAT} value={departureDate} />
            <div className="text-muted small">{`sale en ${remaining}`}</div>
          </>
        );
      }

      const elapsed = elapsedTimeFormat(
        tzDiff({
          startDate: row.value,
          endDate: evaluatedAt || undefined,
          unit: 'minutes',
        }),
      );

      return (
        <>
          <DateCell format={DATE_TIME_FORMAT} value={row.value} />
          <div className="text-muted small">{`hace ${elapsed}`}</div>
        </>
      );
    },
    filterable: false,
  },
  {
    Header: 'Evento',
    id: 'statusEvidenceLabel',
    accessor: ({ statusEvidence }) =>
      (statusEvidence && statusEvidence.label) || '',
    className: 'text-center',
    Cell: (row) => {
      const { statusEvidence } = row.original;

      if (!statusEvidence || !statusEvidence.eventType) return '-';

      const { eventType, eventId, eventCode, label } = statusEvidence;
      const shortText = eventCode || (eventId ? `#${eventId}` : '-');

      let content = shortText;

      if (eventId && eventType === STATUS_EVENT_TYPE.ITINERARY.value) {
        content = (
          <LinkToModuleResource
            href={`${ITINERARY_FOR_COUNTER_PATH}/${eventId}`}
            text={shortText}
            isExternalPath
          />
        );
      } else if (eventId && eventType === STATUS_EVENT_TYPE.MAINTENANCE.value) {
        content = (
          <LinkToModuleResource
            href={`${BUS_MAINTENANCE_STAY_PATH}/${eventId}`}
            text={shortText}
          />
        );
      }

      return (
        <>
          <EnumStatus enumObject={STATUS_EVENT_TYPE} enumValue={eventType} />
          <div>{content}</div>
          {label ? <div className="text-muted small">{label}</div> : null}
        </>
      );
    },
  },
  {
    Header: 'Fin del evento',
    id: 'statusEvidenceEndDate',
    accessor: ({ statusEvidence }) =>
      (statusEvidence && statusEvidence.endDate) || null,
    className: 'text-center',
    Cell: (row) => {
      const { currentStatus, statusEvidence } = row.original;

      if (!statusEvidence || !statusEvidence.endDate) return '-';

      const { endDate, endDateSource } = statusEvidence;

      const isEstimated = endDateSource === END_DATE_SOURCE.GRACE_PERIOD.value;

      const remainingMinutes = tzDiff({
        startDate: evaluatedAt || undefined,
        endDate,
        unit: 'minutes',
      });
      const isOverdue = remainingMinutes <= 0;
      const remaining = elapsedTimeFormat(Math.abs(remainingMinutes));

      let isBusyStatus = true;
      let pendingText = `termina en ${remaining}`;

      switch (currentStatus) {
        case COMMERCIAL_STATUS.ON_TRIP.value:
          pendingText = `llega en ${remaining}`;
          break;
        case COMMERCIAL_STATUS.NOT_PROGRAMMABLE.value:
          pendingText = `sale de taller en ${remaining}`;
          break;
        case COMMERCIAL_STATUS.STANDBY.value:
          pendingText = `retén termina en ${remaining}`;
          break;
        case COMMERCIAL_STATUS.PROGRAMMED.value:
          break;
        default:
          isBusyStatus = false;
      }

      let relativeText = pendingText;
      if (isOverdue) {
        relativeText = isBusyStatus
          ? `vencido hace ${remaining}`
          : `libre desde hace ${remaining}`;
      }

      let relativeClassName = 'text-muted small';
      if (isOverdue && isBusyStatus) {
        relativeClassName = 'text-danger small';
      } else if (isEstimated) {
        relativeClassName = 'text-warning font-italic small';
      }

      return (
        <>
          <DateCell format={DATE_TIME_FORMAT} value={endDate} />
          <div className={relativeClassName}>
            {isEstimated ? `${relativeText} (estimado)` : relativeText}
          </div>
          {isEstimated ? (
            <div>
              <EnumStatus
                enumObject={END_DATE_SOURCE}
                enumValue={endDateSource}
              />
            </div>
          ) : null}
        </>
      );
    },
    filterable: false,
  },
  {
    Header: 'Conductores',
    id: 'assignedDrivers',
    accessor: ({ assignedDrivers }) =>
      (assignedDrivers || []).map(({ fullName }) => fullName).join(' '),
    className: 'text-center',
    Cell: (row) => {
      const { assignedDrivers } = row.original;

      if (!assignedDrivers || !assignedDrivers.length) return '-';

      return assignedDrivers.map(({ driverId, fullName }) => (
        <div key={driverId}>
          <p>{fullName}</p>
        </div>
      ));
    },
    filterMethod: (filter, row) =>
      String(row[filter.id] || '')
        .toLowerCase()
        .includes(String(filter.value || '').toLowerCase()),
  },
  {
    Header: 'Acciones',
    accessor: 'registeredBusId',
    className: 'text-center',
    Cell: (row) => (
      <BusRetentionScheduleActionsCell
        registeredBusFleet={row.original}
        onSuccess={onRefresh}
      />
    ),
    filterable: false,
    width: 150,
  },
];

export const generateMaintenanceBusFleetColumnsForBulk = ({
  handleEdit,
  handleClearRow,
}) => [
  {
    Header: 'Número de Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Placa de bus',
    accessor: 'licensePlate',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Carrocería',
    accessor: 'busBodyworkName',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceTypeId',
    className: 'text-center',
    Cell: (row) => row.original.serviceTypeName || '-',
    Filter: (row) => (
      <ServiceTypeFilter onChangeFilter={row.onChange} isClearable />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
    width: 200,
  },
  {
    Header: 'Estado de Mantenimiento',
    accessor: 'maintenanceStayStatus',
    className: 'text-center',
    Cell: (row) =>
      row.value
        ? MAINTENANCE_STAY_STATUS_OPTIONS.find(
            (option) => option.value === row.value,
          ).label
        : '-',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={MAINTENANCE_STAY_STATUS_OPTIONS}
      />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
    width: 200,
  },
  {
    accessor: 'estimatedArrivalDate',
    Header: 'Fecha Estimada de Llegada',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell format={DATE_TIME_FORMAT} value={row.value} />
      ) : (
        '-'
      ),
    filterable: false,
    width: 180,
  },
  {
    accessor: 'estimatedCompletionDate',
    Header: 'Fecha Estimada de Entrega',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell format={DATE_TIME_FORMAT} value={row.value} />
      ) : (
        '-'
      ),
    filterable: false,
    width: 180,
  },
  {
    Header: 'Tiempo fuera de servicio',
    accessor: 'id',
    className: 'text-center',
    Cell: (row) => {
      const original = row && row.original ? row.original : {};
      const { noArrivalTime, estimatedArrivalDate, estimatedCompletionDate } =
        original;
      if (noArrivalTime === true || !estimatedArrivalDate) {
        return '-';
      }
      const endDate = estimatedCompletionDate || Date.now();
      const totalMinutes = tzDiff({
        startDate: estimatedArrivalDate,
        endDate,
        unit: 'minutes',
      });
      if (typeof totalMinutes !== 'number' || totalMinutes < 0) {
        return '-';
      }
      const days = Math.floor(totalMinutes / (24 * 60));
      const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
      const minutes = Math.floor(totalMinutes % 60);
      if (days > 0) {
        return `${days}d ${hours}h ${minutes}min`;
      }
      if (hours > 0) {
        return `${hours}h ${minutes}min`;
      }
      return `${minutes}min`;
    },
    filterable: false,
    width: 150,
  },
  {
    Header: 'Observación',
    accessor: 'observation',
    className: 'text-center',
    filterMethod: (filter, row) => {
      const { value } = filter || {};

      const filterValue = (value || '').toString().trim().toLowerCase();

      if (!filterValue) return true;

      const rowValue = (row[filter.id] || '').toString().toLowerCase();
      return rowValue.includes(filterValue);
    },
  },
  {
    Header: 'Acción',
    accessor: 'busMaintenanceStayId',
    className: 'text-center',
    Cell: (cell) => {
      const { original, index } = cell;
      return (
        <div className="d-flex justify-content-center align-items-center">
          <MaintenanceBusFleetHistoryButton busMaintenanceStayId={cell.value} />

          <EditMaintenanceBusFleetButton
            handleEdit={handleEdit}
            maintenanceBusFleet={original}
            index={index}
          />

          <MaintenanceBusFleetClearButton
            handleClearRow={handleClearRow}
            maintenanceBusFleet={original}
          />
        </div>
      );
    },
    filterable: false,
    width: 200,
  },
];

export const HISTORY_OF_BUS_MAINTENANCE_STAY_COLUMNS = [
  {
    Header: 'Usuario',
    accessor: 'userFullName',
    className: 'text-center',
  },
  {
    Header: 'Fecha del Cambio',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell format={DATE_TIME_FORMAT} value={row.value} />
      ) : (
        '-'
      ),
  },
  {
    Header: 'Estado de Mantenimiento',
    accessor: 'maintenanceStayStatus',
    className: 'text-center',
    Cell: (row) =>
      row.value
        ? MAINTENANCE_STAY_STATUS_OPTIONS.find(
            (option) => option.value === row.value,
          ).label
        : '-',
  },
  {
    Header: 'Fecha Estimada de Llegada',
    accessor: 'estimatedArrivalDate',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell format={DATE_TIME_FORMAT} value={row.value} />
      ) : (
        '-'
      ),
  },
  {
    Header: 'Fecha Estimada de Entrega',
    accessor: 'estimatedCompletionDate',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell format={DATE_TIME_FORMAT} value={row.value} />
      ) : (
        '-'
      ),
  },
  {
    Header: 'Observación',
    accessor: 'observation',
    className: 'text-center',
  },
];

export const COUNTER_BUS_MAINTENANCE_STAY = [
  {
    Header: 'Servicio',
    accessor: 'serviceTypeName',
    width: 200,
  },
  {
    Header: 'Lima → Prov',
    accessor: 'limaToProvinceCount',
    Cell: (row) => <div style={{ textAlign: 'center' }}>{row.value || 0}</div>,
    width: 150,
  },
  {
    Header: 'Prov → Prov',
    accessor: 'provinceToProvinceCount',
    Cell: (row) => <div style={{ textAlign: 'center' }}>{row.value || 0}</div>,
    width: 150,
  },
  {
    Header: 'Prov → Lima',
    accessor: 'provinceToLimaCount',
    Cell: (row) => <div style={{ textAlign: 'center' }}>{row.value || 0}</div>,
    width: 150,
  },
  {
    Header: 'Total',
    accessor: 'total',
    Cell: (row) => (
      <div style={{ textAlign: 'center' }}>
        <strong>{row.value || 0}</strong>
      </div>
    ),
    width: 150,
  },
];

export const COMPANY_RESOURCES_EXECUTION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Recurso de Compania',
    accessor: 'companyResource.name',
    className: 'text-center',
  },
  {
    Header: 'Actividad',
    accessor: 'actividad',
    id: 'actividad',
    className: 'text-center',
    Cell(cell) {
      const row = cell.original;
      if (!row) return '-';

      if (
        row.maintenancePlanningActivityResource &&
        row.maintenancePlanningActivityResource
          .maintenancePlanningActivityOrder &&
        row.maintenancePlanningActivityResource.maintenancePlanningActivityOrder
          .activity
      ) {
        return row.maintenancePlanningActivityResource
          .maintenancePlanningActivityOrder.activity.name;
      }

      if (row.activityCompanyResource && row.activityCompanyResource.activity) {
        return row.activityCompanyResource.activity.name;
      }

      return '-';
    },
  },

  {
    Header: 'Fecha de Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell format={DATE_FORMAT} value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'endDate',
    className: 'text-center',
    Cell: (row) => <DateCell format={DATE_FORMAT} value={row.value} />,
  },
];

export const TICKET_POSTPONE_PROCESS_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Comentario',
    accessor: 'comment',
    className: 'text-center',
  },
  {
    Header: 'Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Usuario',
    accessor: 'operatorUserName',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Agencia',
    accessor: 'agencyName',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Fecha',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
  },
];

export const TICKET_POSTPONE_PROCESS_TICKET_COLUMNS = [
  {
    Header: 'Id del Ticket',
    accessor: 'ticketId',
    className: 'text-center',
  },
  {
    Header: 'Ticket',
    accessor: 'ticketCode',
    className: 'text-center',
  },
  {
    Header: 'Cliente',
    accessor: 'customerId',
    Cell: (row) =>
      `${row.original.customerIdentificationTypeName} ${row.original.customerIdDocumentNumber} (${row.original.customerIdCountryOfOrigin}) - ${row.original.customerFullName}`,
    Filter: (row) => (
      <CustomerFilter isClearable onChangeFilter={row.onChange} />
    ),
    className: 'text-center',
  },
];

export const BOARDING_GROUPS_COLUMN = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre del Grupo',
    accessor: 'name',
    className: 'text-center',
  },
  {
    id: 'routeId',
    Header: 'Ruta',
    accessor: 'route',
    className: 'text-center',
    Cell: (row) => {
      const route = row.value;
      if (!route) return '-';
      return `${route.id} - ${route.name}`;
    },
  },
  {
    Header: 'ubicaciones',
    accessor: 'boardingGroupLocations',
    className: 'text-center',
    Cell: (row) => {
      if (!row.value) return null;
      const locationList = row.value.map(({ location: { name } }) => ({
        text: name,
      }));
      return <BadgeList cell textArray={locationList} />;
    },
    filterable: false,
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter onChangeFilter={row.onChange} options={ACTIVE_OPTIONS} />
    ),
  },
];

export const buildTicketReassignmentItineraryColumns = ({
  onView,
  onEdit,
  canSeePostSale,
}) => {
  const columns = [
    {
      Header: 'ITINERARIO INICIAL',
      groupStyle: {
        background: '#1D4ED8',
        color: '#FFFFFF',
      },
      columns: [
        {
          Header: 'ASIENTO',
          accessor: 'previousSeatNumber',
          className: 'text-center',
        },
        {
          Header: 'NUMERO DE BOLETO',
          accessor: 'ticketDocumentCorrelation',
          className: 'text-center',
        },
        {
          Header: 'NOMBRE DE PASAJERO',
          accessor: 'customer.fullName',
          className: 'text-center',
        },
        {
          Header: 'TELEFONO',
          accessor: 'customer.mobilePhone',
          className: 'text-center',
        },
        {
          Header: 'MAIL',
          accessor: 'customer.email',
          className: 'text-center',
        },
        {
          Header: 'MONTO S/.',
          accessor: 'previousTicketAmount',
          className: 'text-center',
        },
        {
          Header: 'EMBARQUE',
          accessor: 'previousSourceLocationName',
          className: 'text-center',
        },
        {
          Header: 'DESEMBARQUE',
          accessor: 'previousDestinationLocationName',
          className: 'text-center',
        },
      ],
    },
    {
      Header: 'ITINERARIO FINAL',
      groupStyle: {
        background: '#15803D',
        color: '#fff',
      },
      columns: [
        {
          Header: 'ESTADO',
          accessor: 'ticketStatus',
          className: 'text-center',
          Cell: (row) => (
            <EnumStatus enumObject={TICKET_STATUS} enumValue={row.value} />
          ),
        },
        {
          Header: 'ASIENTO',
          accessor: 'newSeatNumber',
          className: 'text-center',
        },
        {
          Header: 'NUMERO DE BOLETO',
          accessor: 'ticketDocumentCorrelation',
          className: 'text-center',
        },
        {
          Header: 'NUEVO HORARIO',
          accessor: 'newDepartureTime',
          Cell: (row) => (
            <DateCell value={row.value} format={DATE_TIME_FORMAT} />
          ),
          className: 'text-center',
        },
        {
          Header: 'SERVICIO',
          accessor: 'newItineraryServiceType.name',
          className: 'text-center',
        },
        {
          Header: 'MONTO S/.',
          accessor: 'ticketAmount',
          className: 'text-center',
        },
        {
          Header: 'EMBARQUE',
          accessor: 'newSourceLocationName',
          className: 'text-center',
        },
        {
          Header: 'DESEMBARQUE',
          accessor: 'newDestinationLocationName',
          className: 'text-center',
        },
      ],
    },
  ];

  if (canSeePostSale) {
    columns.push({
      Header: 'POSTVENTA',
      groupStyle: {
        background: '#D97706',
        color: '#fff',
      },
      columns: [
        {
          Header: 'ACEPTA FUSIÓN',
          accessor: 'acceptMerge',
          className: 'text-center',
          Cell: (row) => (
            <EnumStatus
              enumObject={TICKET_REASSINGMENT_ACCEPT_MERGE}
              enumValue={row.value}
            />
          ),
        },
        {
          Header: 'NEGOCIACIÓN',
          accessor: 'negotiation',
          className: 'text-center',
          Cell: (row) => (
            <EnumStatus
              enumObject={TICKET_REASSINGMENT_NEGOTIATION}
              enumValue={row.value}
            />
          ),
        },
        {
          Header: 'TIPO DE DEVOLUCIÓN',
          accessor: 'refundType',
          className: 'text-center',
          Cell: (row) => (
            <EnumStatus
              enumObject={TICKET_REASSINGMENT_RETURN_TYPE}
              enumValue={row.value}
            />
          ),
        },
        {
          Header: 'OBSERVACION',
          accessor: 'comment',
          className: 'text-center',
        },
        {
          Header: 'OPERADOR',
          accessor: 'operatorUserList',
          className: 'text-center',
          Cell: (row) => {
            const operators = row.value;

            if (
              !operators ||
              !Array.isArray(operators) ||
              operators.length === 0
            ) {
              return '-';
            }

            return operators.map((op) => op.fullName).join(', ');
          },
        },
      ],
    });
  }

  columns.push({
    Header: 'Acción',
    accessor: 'id',
    className: 'text-center',
    Cell: (row) => (
      <div className="d-flex justify-content-center">
        {onView && (
          <i
            tabIndex={0}
            role="button"
            className="fa fa-eye text-info mx-2"
            title="Ver detalles"
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              onView({ id: row.value, item: row.original });
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                onView({ id: row.value, item: row.original });
              }
            }}
          />
        )}

        {canSeePostSale && onEdit && (
          <i
            tabIndex={0}
            role="button"
            className="fa fa-edit text-warning mx-2"
            title="Editar"
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              onEdit({ id: row.value, item: row.original });
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                onEdit({ id: row.value, item: row.original });
              }
            }}
          />
        )}
      </div>
    ),
  });

  return columns;
};

export const BUS_WAIT_TIME_VIOLATION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Itinerario Anterior',
    accessor: 'previousItineraryId',
    className: 'text-center',
    Cell: (row) => {
      const itineraryId = row.value;
      return (
        <LinkToModuleResource
          href={`${ITINERARY_FOR_COUNTER_PATH}/${itineraryId}`}
          text={itineraryId}
          isExternalPath
        />
      );
    },
  },
  {
    Header: 'Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
    Cell: (row) => {
      const itineraryId = row.value;
      return (
        <LinkToModuleResource
          href={`${ITINERARY_FOR_COUNTER_PATH}/${itineraryId}`}
          text={itineraryId}
          isExternalPath
        />
      );
    },
  },
  {
    accessor: 'actualWaitTimeMinutes',
    Header: 'Tiempo de Permanencia (minutos)',
    className: 'text-center',
  },
  {
    accessor: 'requiredWaitTimeMinutes',
    Header: 'Tiempo de Permanencia Requerido (minutos)',
    className: 'text-center',
  },
  {
    accessor: 'user.fullName',
    Header: 'Usuario',
    className: 'text-center',
  },
];

export const ITINERARY_SEGMENT_COLUMNS = [
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
    width: 400,
  },
  {
    Header: 'Escala Siguiente',
    accessor: 'destinationLocationName',
    className: 'text-center',
    width: 400,
  },
  {
    Header: 'Hora de Salida',
    accessor: 'departureTime',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
    width: 300,
    filterable: false,
  },
  {
    Header: 'Hora de Llegada',
    accessor: 'arrivalTime',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
    width: 300,
    filterable: false,
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceTypeName',
    className: 'text-center',
    width: 300,
  },
  {
    Header: 'Ruta',
    accessor: 'routeString',
    className: 'text-center',
  },
];

export const ITINERARY_INCIDENT_COLUMNS = [
  {
    accessor: 'id',
    Header: 'ID',
    className: 'text-center',
  },
  {
    accessor: 'incidentRecordType',
    Header: 'Incidente',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={INCIDENT_RECORD_TYPE} enumValue={row.value} />
    ),
  },
  {
    Header: 'Bus',
    accessor: 'registeredBus',
    className: 'text-center',
    Cell: (row) => {
      const { value } = row;
      if (!value) return '-';
      return `${value.companyBusId}`;
    },
  },
  {
    accessor: 'incidentDate',
    Header: 'Fecha del Incidente',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
  },
  {
    accessor: 'userFullName',
    Header: 'Usuario',
    className: 'text-center',
  },
  {
    accessor: 'createDate',
    Header: 'Fecha de Registro',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
  },
];

export const AGENCY_INCIDENTS_COLUMNS = [
  {
    accessor: 'id',
    Header: 'ID',
    className: 'text-center',
  },
  {
    accessor: 'incidentRecordType',
    Header: 'Tipo de Incidente',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={INCIDENT_RECORD_TYPE} enumValue={row.value} />
    ),
  },
  {
    accessor: 'incidentDate',
    Header: 'Fecha del Incidente',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    filterable: false,
  },
  {
    accessor: 'userFullName',
    Header: 'Usuario',
    className: 'text-center',
  },
];

export const TOLL_LIQUIDATION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Fecha de liquidación',
    accessor: 'createDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Fecha de salida',
    accessor: 'itineraryDepartureTime',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Conductor que Recibio',
    accessor: 'originalPayeeCustomerId',
    className: 'text-center',
    Filter: (row) => (
      <CustomerFilter onChangeFilter={row.onChange} isClearable />
    ),
    Cell: (row) => {
      const payee = row.original.originalPayeeCustomer;

      if (!payee) return '-';

      return `${payee.fullName} - ${payee.identificationType.name} ${payee.idDocumentNumber}`;
    },
  },
  {
    Header: 'Conductor Liquidador',
    accessor: 'payeeCustomerId',
    className: 'text-center',
    Filter: (row) => (
      <CustomerFilter onChangeFilter={row.onChange} isClearable />
    ),
    Cell: (row) => {
      const payee = row.original.payeeCustomer;

      if (!payee) return '-';

      return `${payee.fullName} - ${payee.identificationType.name} ${payee.idDocumentNumber}`;
    },
  },
  {
    Header: 'Monto Total',
    accessor: 'totalAmount',
    className: 'text-center',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
  },
  {
    Header: 'Fundición',
    accessor: 'tollLiquidationAdditionalChargeList',
    className: 'text-center',
    Cell: (row) => {
      const additionalCharges = row.value || [];

      const funditionAmount = additionalCharges
        .filter((item) => item.chargeType === 'FUNDITION_ENTRY' && item.applied)
        .reduce((total, item) => total + Number(item.amount || 0), 0);

      return numberFormatter({
        currency: row.original.currencyCode,
        value: funditionAmount,
      });
    },
  },
  {
    Header: 'Monto Liquidado',
    accessor: 'tollLiquidateAmount',
    className: 'text-center',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
  },

  {
    Header: 'Monto Discrepancia',
    accessor: 'differenceAmount',
    className: 'text-center',
  },
  {
    Header: 'Motivo Discrepancia',
    accessor: 'differenceAmountReasonId',
    id: 'differenceAmountReasonId',
    className: 'text-center',
    Filter: (row) => (
      <TollLiquidationDifferenceReasonFilter
        onChangeFilter={row.onChange}
        isClearable
      />
    ),
    Cell: (row) => {
      const { differenceReason } = row.original || {};

      return differenceReason ? differenceReason.name : '-';
    },
  },
];

export const TOLL_ITINERARY_LIQUIDATION_COLUMNS = [
  {
    Header: 'Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Salida',
    accessor: 'itineraryDepartureTime',
    className: 'text-center',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
  },
  {
    Header: 'N° Vale',
    accessor: 'expenseDocumentCode',
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'tollAmount',
    className: 'text-center',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
  },
  {
    Header: 'Monto Fundición',
    accessor: 'additionalAmount',
    className: 'text-center',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.currencyCode,
        value: row.value,
      }),
  },
];

export const TOLL_LIQUIDATION_DETAIL_COLUMNS = [
  {
    Header: 'Peaje',
    accessor: 'tollName',
    className: 'text-center',
  },
  {
    Header: 'RUC',
    accessor: 'business.businessTaxId',
    className: 'text-center',
  },
  {
    Header: 'Razón Social',
    accessor: 'business.name',
    className: 'text-center',
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Código',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Peaje',
    accessor: 'tollAmount',
    Cell: ({ value }) => numberFormatter({ value }),
    className: 'text-center',
  },
  {
    Header: 'Aplicado',
    accessor: 'tollAmountApplied',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Detracción',
    accessor: 'detractionAmount',
    Cell: ({ value }) => numberFormatter({ value }),
    className: 'text-center',
  },
  {
    Header: 'Aplicado',
    accessor: 'detractionApplied',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Total',
    accessor: 'totalAmount',
    Cell: ({ value }) => numberFormatter({ value }),
    className: 'text-center',
  },
];

export const BILLING_REPORT_DETAIL_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Fecha Desde',
    accessor: 'fromDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Fecha Hasta',
    accessor: 'toDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={BILLING_REPORT_DETAIL_STATUS}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={BILLING_REPORT_DETAIL_STATUS}
      />
    ),
  },
];

export const BILLING_REPORT_RETENTION_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Proceso',
    accessor: 'processType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={BILLING_PROCESS_TYPE} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={BILLING_PROCESS_TYPE}
      />
    ),
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Serie de Referencia',
    accessor: 'refDocumentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo de Referencia',
    accessor: 'refDocumentCode',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={BILLING_PROCESS_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={BILLING_PROCESS_STATUS}
      />
    ),
    className: 'text-center',
  },
];

export const DRIVER_COMMISION_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Base',
    accessor: 'baseCommission',
    className: 'text-center',
  },
  {
    Header: 'Número de Rangos de Condición de Trabajo',
    accessor: 'driverCommissionRangeList',
    className: 'text-center',
    Cell: ({ value }) => {
      if (!value) return 0;
      return value.length;
    },
    filterable: false,
  },
];

export const PRICING_PROFILE_DATE_RANGE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Año',
    accessor: 'year',
    className: 'text-center',
  },
  {
    Header: 'Fecha Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Fecha Fin',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Motivo',
    accessor: 'reason',
    className: 'text-center',
  },
];

export const PRICING_PROFILE_MASSIVE_UPDATE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Archivo',
    accessor: 'file',
    className: 'text-center',
    Cell: (row) => (
      <LinkToModuleResource
        href={row.value}
        text={row.value}
        colorIcon="text-primary"
        isExternalPath
      />
    ),
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Activo',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={PARCEL_PRICE_STATUS} enumValue={row.value} />
    ),
    className: 'text-center',
  },
];

export const generateItineraryTicketColumns = (
  sourceOptions,
  destinationOptions,
) => [
  {
    Header: 'Boleto',
    id: 'documentCode',
    accessor: (row) => {
      const serie = row.documentSeries || '';
      const correlativo = row.documentCode
        ? row.documentCode.toString().padStart(7, '0')
        : '';
      const full = `${serie}-${correlativo}`;
      return {
        serie,
        correlativo,
        full,
      };
    },
    Cell: ({ value }) => value.full,
    filterMethod: (filter, row) => {
      const { serie, correlativo, full } = row.documentCode;
      const search = filter.value.toLowerCase().trim();
      return (
        serie.toLowerCase().includes(search) ||
        correlativo.includes(search) ||
        full.toLowerCase().includes(search)
      );
    },
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Pasajero',
    id: 'customer',
    accessor: (row) =>
      `${row.customer.fullName} - ${row.customer.identificationTypeName}: ${row.customer.idDocumentNumber}`,
    className: 'text-center',
  },
  {
    Header: 'Edad',
    accessor: 'age',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Origen',
    id: 'sourceLocation',
    accessor: (row) => row.sourceLocation.name,
    // eslint-disable-next-line
    Filter: ({ onChange }) => (
      <SelectFilter
        onChangeFilter={onChange}
        options={sourceOptions}
        isClearable
      />
    ),
    filterMethod: (filter, row) => {
      if (!filter.value) return true;
      // eslint-disable-next-line
      return row._original.sourceLocation.id === filter.value;
    },
    className: 'text-center',
  },
  {
    Header: 'Destino',
    id: 'destinationLocation',
    accessor: (row) => row.destinationLocation.name,
    // eslint-disable-next-line react/prop-types
    Filter: ({ onChange }) => (
      <SelectFilter
        onChangeFilter={onChange}
        options={destinationOptions}
        isClearable
      />
    ),
    filterMethod: (filter, row) => {
      if (!filter.value) return true;
      // eslint-disable-next-line
      return row._original.destinationLocation.id === filter.value;
    },
    className: 'text-center',
  },
  {
    Header: 'Piso',
    accessor: 'floorNumber',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Asiento',
    accessor: 'seatNumber',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Estado',
    accessor: 'boardingStatus',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => (
      <EnumStatus enumObject={TICKET_BOARDING_STATUS} enumValue={value} />
    ),
    // eslint-disable-next-line react/prop-types
    Filter: ({ onChange }) => (
      <SelectFilter
        onChangeFilter={onChange}
        options={Object.values(TICKET_BOARDING_STATUS).map(
          ({ value, label }) => ({
            value,
            label,
          }),
        )}
        isClearable
      />
    ),
    filterMethod: (filter, row) => {
      if (!filter.value) return true;
      const rowValue = row.boardingStatus;
      if (!rowValue) return false;
      return rowValue === filter.value;
    },
    className: 'text-center',
  },
];

export const ADMINISTRATIVE_CHECKLIST_COLUMNS = [
  {
    accessor: 'id',
    Header: 'ID',
    className: 'text-center',
  },
  {
    accessor: 'incidentRecordType',
    Header: 'Tipo de Incidente',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={INCIDENT_RECORD_TYPE} enumValue={row.value} />
    ),
  },
  {
    accessor: 'incidentDate',
    Header: 'Fecha del Registro',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    filterable: false,
  },
  {
    accessor: 'userFullName',
    Header: 'Usuario',
    className: 'text-center',
  },
];

export const FREE_OF_CHARGE_SUB_CATEGORY_COLUMN = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Activo',
    accessor: 'active',
    className: 'text-center',
    filterable: false,
    Cell: (row) => <IsActive value={row.value} />,
  },
  {
    Header: 'Autorizadores',
    accessor: 'freeOfChargeSubCategoryUserList',
    id: 'authorizers',
    Cell: (row) => {
      if (!Array.isArray(row.value) || row.value.length === 0) return null;

      const names = row.value
        .map(
          (a) =>
            a.customer.fullName ||
            [a.customer.firstName, a.customer.lastName]
              .filter(Boolean)
              .join(' '),
        )
        .filter(Boolean);

      const freeOfChargeAuthorizer = names.map((n) => ({ text: n }));

      return <BadgeList cell textArray={freeOfChargeAuthorizer} />;
    },
    className: 'text-center',
    filterable: false,
  },
];

export const FREE_OF_CHARGE_RULE_COLUMN = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Activo',
    accessor: 'active',
    className: 'text-center',
    filterable: false,
    Cell: (row) => <IsActive value={row.value} />,
  },
  {
    Header: 'Usuarios Incluidos',
    accessor: 'userList',
    id: 'userList',
    Cell: (row) => {
      if (!row.value) return null;
      const users = row.value.map(({ fullName }) => ({ text: fullName }));
      return <BadgeList cell textArray={users} />;
    },
    className: 'text-center',
    filterable: false,
  },
];

export const ITEMS_COLUMNS = [
  {
    Header: 'Serie',
    accessor: 'itemSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'itemCode',
    className: 'text-center',
  },
  {
    Header: 'Correlativo del Equipaje',
    accessor: 'itemCorrelation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    id: 'itemCategoryId',
    Header: 'Categoria',
    accessor: 'itemCategoryName',
    className: 'text-center',
    Filter: (row) => (
      <ItemCategoryFilter onChangeFilter={row.onChange} isClearable />
    ),
  },
  {
    Header: 'Peso (kg)',
    accessor: 'weight',
    className: 'text-center',
    Cell: (row) => `${row.value} ${KILOGRAM_SYMBOL}`,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={NEW_BAGGAGE_ITEM_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={NEW_BAGGAGE_ITEM_STATUS}
      />
    ),
  },
  {
    Header: 'Especial',
    accessor: 'isSpecial',
    Cell: (row) => <Checkbox checked={!!row.value} />,
    className: 'text-center',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={[
          { value: true, label: 'Sí' },
          { value: false, label: 'No' },
        ]}
        isClearable
      />
    ),
  },
  {
    id: 'currentLocationId',
    Header: 'Ubicación Actual',
    accessor: 'currentLocationName',
    className: 'text-center',
    headerColor: '#ed1e79',
    Filter: (row) => (
      <LocationFilter
        onChangeFilter={row.onChange}
        isClearable
        placeholder="Filtrar por Embarque"
      />
    ),
  },
  {
    id: 'sourceLocationId',
    Header: 'Origen',
    accessor: 'sourceLocation.name',
    className: 'text-center',
    Filter: (row) => (
      <LocationFilter
        onChangeFilter={row.onChange}
        isClearable
        placeholder="Filtrar por Embarque"
      />
    ),
  },
  {
    id: 'destinationLocationId',
    Header: 'Destino',
    accessor: 'destinationLocation.name',
    className: 'text-center',
    Filter: (row) => (
      <LocationFilter
        onChangeFilter={row.onChange}
        isClearable
        placeholder="Filtrar por Desembarque"
      />
    ),
  },
];

export const BAGGAGE_TICKET_COLUMNS = [
  {
    Header: 'Número',
    accessor: 'documentSeries',
    Cell: (row) => `${row.value}-${padStart(row.original.documentCode, 7)}`,
    width: 150,
    className: 'text-center',
  },
  {
    Header: 'Pasajero',
    accessor: 'customer.fullName',
    width: 400,
    className: 'text-center',
  },
  {
    Header: 'Documento de Identidad',
    accessor: 'customer.identificationType.name',
    Cell: (row) => `${row.value}: ${row.original.customer.idDocumentNumber}`,
    width: 300,
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocation.name',
    width: 300,
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocation.name',
    width: 300,
    className: 'text-center',
  },
  {
    Header: 'Fecha de Viaje',
    accessor: 'departureDate',
    Cell: (row) =>
      row.value
        ? tzNormalizeDate({
            date: row.value,
            format: DATE_TIME_FORMAT,
          })
        : '-',
    width: 200,
    className: 'text-center',
  },
];

export const BAGGAGE_ITEM_COLUMNS = [
  {
    Header: 'Categoría',
    accessor: 'itemCategory.name',
    className: 'text-center',
  },
  {
    Header: 'Serie',
    accessor: 'itemSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'itemCode',
    className: 'text-center',
  },
  {
    Header: 'Correlativo Automático',
    accessor: 'itemCorrelation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Categoria',
    accessor: 'itemCategoryName',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Observación',
    accessor: 'conditionDescription',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
    Cell: (row) => `${row.value} ${KILOGRAM_SYMBOL}`,
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={NEW_BAGGAGE_ITEM_STATUS} enumValue={row.value} />
    ),
    className: 'text-center',
  },
  {
    Header: 'Ver',
    accessor: 'id',
    className: 'text-center',
    notNavigateToModel: true,
    Cell: (row) => (
      <a
        href={`${ITEM_PATH}/${row.value}`}
        onClick={(e) => e.stopPropagation()}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-eye" />
      </a>
    ),
    width: 150,
  },
];

export const generateBaggageItemManifestColumns = (
  sourceOptions,
  destinationOptions,
  statusOptions,
) => [
  {
    Header: 'Boleto',
    accessor: 'mainTicket.ticketCode',
    className: 'text-center',
  },
  {
    Header: 'Correlativo del Equipaje',
    accessor: 'itemCorrelation',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Categoria',
    accessor: 'itemCategoryName',
    className: 'text-center',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
    className: 'text-center',
    width: 80,
  },
  {
    Header: 'Origen',
    id: 'sourceLocation',
    accessor: (row) => row.sourceLocation.name,
    // eslint-disable-next-line react/prop-types
    Filter: ({ onChange }) => (
      <SelectFilter
        onChangeFilter={onChange}
        options={sourceOptions}
        isClearable
      />
    ),
    filterMethod: (filter, row) => {
      if (!filter.value) return true;
      // eslint-disable-next-line no-underscore-dangle
      return row._original.sourceLocation.id === filter.value;
    },
    className: 'text-center',
  },
  {
    Header: 'Destino',
    id: 'destinationLocation',
    accessor: (row) => row.destinationLocation.name,
    // eslint-disable-next-line react/prop-types
    Filter: ({ onChange }) => (
      <SelectFilter
        onChangeFilter={onChange}
        options={destinationOptions}
        isClearable
      />
    ),
    filterMethod: (filter, row) => {
      if (!filter.value) return true;
      // eslint-disable-next-line no-underscore-dangle
      return row._original.destinationLocation.id === filter.value;
    },
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: (row) => (
      <EnumStatus enumObject={NEW_BAGGAGE_ITEM_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={statusOptions}
        isClearable
      />
    ),
    filterMethod: (filter, row) => {
      if (!filter.value) return true;
      return row.status === filter.value;
    },
    className: 'text-center',
    width: 150,
  },
];

export const SUPPLIERS_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'RUC',
    accessor: 'business.businessTaxId',
    className: 'text-center',
  },
  {
    Header: 'Razon Social',
    accessor: 'business.name',
    className: 'text-center',
  },
  {
    Header: 'Tipo',
    accessor: 'type',
    className: 'text-center',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => (
      <EnumStatus enumObject={SUPPLIER_TYPE} enumValue={value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={SUPPLIER_TYPE}
      />
    ),
  },
  {
    Header: 'Ubicación',
    id: 'locationId',
    accessor: 'location.name',
    className: 'text-center',
    Filter: (row) => (
      <LocationFilter
        onChangeFilter={row.onChange}
        isClearable
        placeholder="Filtrar por Desembarque"
      />
    ),
  },
];

export const ITINERARY_SUPPLIER_FOOD_COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Proveedor',
    accessor: 'supplierName',
    className: 'text-center',
    id: 'supplierId',
    Filter: (row) => (
      <SupplierFilter onChangeFilter={row.onChange} isClearable />
    ),
  },
  {
    Header: 'Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Ruta',
    accessor: 'routeName',
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Tripulante SAB',
    accessor: 'cabinCrewName',
    className: 'text-center',
    id: 'cabinCrewId',
    Filter: (row) => (
      <CabinCrewFilter onChangeFilter={row.onChange} isClearable />
    ),
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    id: 'registeredBusId',
    className: 'text-center',
    Filter: (row) => (
      <RegisteredBusFilter onChangeFilter={row.onChange} isClearable />
    ),
  },
  {
    Header: 'Fecha Creación',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
];

export const ITINERARY_SUPPLIER_FOOD_SERVICES_COLUMNS = [
  {
    Header: 'Id Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'origin',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destination',
    className: 'text-center',
  },
  {
    Header: 'Fecha Salida',
    accessor: 'departureDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
  },
  {
    Header: 'Hora Salida',
    accessor: 'departureDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={TIME_FORMAT} />,
  },
  {
    Header: 'N° Bus',
    accessor: 'busNumber',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType',
    className: 'text-center',
  },
  {
    Header: 'Tipo',
    accessor: 'itineraryType',
    className: 'text-center',
  },
  {
    Header: 'Estado Itinerario',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={ITINERARY_ACTIVE_OPTIONS}
      />
    ),
  },
  {
    Header: 'Estado',
    accessor: 'attendedStatus',
    className: 'text-center',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => (
      <EnumStatus
        enumObject={SUPPLIER_ASSIGNED_SERVICE_STATUS}
        enumValue={value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={SUPPLIER_ASSIGNED_SERVICE_STATUS}
      />
    ),
  },
];

export const getItinerarySupplierFoodReportColumns = (showAction = true) => {
  const columns = [
    {
      Header: 'Fecha Registro',
      accessor: 'createDate',
      className: 'text-center',
      Cell: (row) => <DateCell value={row.value} />,
    },
    {
      Header: 'Fecha Entrega Programada',
      accessor: 'scheduleDeliveredDate',
      className: 'text-center',
      Cell: (row) => <DateCell value={row.value} />,
    },
    {
      Header: 'Origen',
      accessor: 'origin',
      className: 'text-center',
    },
    {
      Header: 'Destino',
      accessor: 'destination',
      className: 'text-center',
    },
    {
      Header: 'Fecha de Salida',
      accessor: 'departureTime',
      className: 'text-center',
      Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    },
    {
      Header: 'Hora Salida',
      accessor: 'departureTime',
      className: 'text-center',
      Cell: (row) => <DateCell value={row.value} format={TIME_FORMAT} />,
    },
    {
      Header: 'N° Bus',
      accessor: 'companyBus',
      className: 'text-center',
    },
    {
      Header: 'Tipo de Servicio',
      accessor: 'serviceType',
      className: 'text-center',
    },
    {
      Header: 'Tipo',
      accessor: 'itineraryType',
      className: 'text-center',
    },
    {
      Header: 'Cantidad',
      accessor: 'quantity',
      className: 'text-center',
    },
    {
      Header: 'Costo',
      accessor: 'cost',
      className: 'text-center',
      Cell: (row) => Number(row.value || 0).toFixed(2),
    },
  ];

  if (showAction) {
    columns.push({
      Header: 'Acción',
      accessor: 'id',
      className: 'text-center',
      filterable: false,
      sortable: false,
      minWidth: 120,
      Cell: (row) => (
        <div className="d-flex justify-content-center align-items-center">
          <ItinerarySupplierFoodReportDetailButton
            itinerarySupplierFoodId={row.value}
          />
        </div>
      ),
    });
  }

  return columns;
};

export const ITINERARY_FOOD_INVOICES_COLUMNS = [
  {
    Header: 'Proveedor',
    accessor: 'supplierBusinessName',
    id: 'supplierId',
    className: 'text-center',

    Filter: (row) => (
      <SupplierFilter onChangeFilter={row.onChange} isClearable />
    ),
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    className: 'text-center',
  },
  {
    Header: 'Monto Total',
    accessor: 'amount',
    className: 'text-center',
    Cell: (row) => Number(row.value || 0).toFixed(2),
  },
  {
    Header: 'Fecha de facturación',
    accessor: 'billingDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Desde',
    accessor: 'periodStartDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Hasta',
    accessor: 'periodEndDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Fecha de Entrega a Contabilidad',
    accessor: 'accountingDeliveredDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
];

export const ITINERARY_FOOD_INVOICE_DETAIL_COLUMNS = [
  {
    Header: 'Fecha Registro',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Fecha Entrega Programada',
    accessor: 'scheduleDeliveredDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} />,
  },
  {
    Header: 'Origen',
    accessor: 'origin',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destination',
    className: 'text-center',
  },
  {
    Header: 'Fecha Salida',
    accessor: 'departureTime',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
  },
  {
    Header: 'Hora Salida',
    accessor: 'departureTime',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={TIME_FORMAT} />,
  },
  {
    Header: 'N° Bus',
    accessor: 'companyBus',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceType',
    className: 'text-center',
  },
  {
    Header: 'Tipo',
    accessor: 'itineraryType',
    className: 'text-center',
  },
  {
    Header: 'Alimento',
    accessor: 'foodName',
    className: 'text-center',
  },
  {
    Header: 'Público',
    accessor: 'publicType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={FOOD_PUBLIC_TYPE} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={FOOD_PUBLIC_TYPE}
        isMulti
      />
    ),
  },
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    className: 'text-center',
  },
  {
    Header: 'Costo Unitario',
    accessor: 'unitCost',
    className: 'text-center',
    Cell: (row) => Number(row.value || 0).toFixed(2),
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    className: 'text-center',
    Cell: (row) => Number(row.value || 0).toFixed(2),
  },
];

export const ITINERARY_CHANGE_ROUTE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Ruta Original',
    accessor: 'oldRouteNames',
    className: 'text-center',
    filterable: false,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Ruta Nueva',
    accessor: 'newRoute.name',
    className: 'text-center',
    filterable: false,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Usuario',
    accessor: 'user.fullName',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Fecha de Cambio',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={ITINERARY_CHANGE_ROUTE_STATUS}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={ITINERARY_CHANGE_ROUTE_STATUS}
      />
    ),
  },
];

export const ITINERARY_COUNTER_REPORT_COLUMNS = [
  { Header: 'ID', accessor: 'id', className: 'text-center' },
  {
    Header: 'Solicitado',
    accessor: 'requestedAt',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
  },
  {
    Header: 'Completado',
    accessor: 'completedAt',
    className: 'text-center',
    Cell: (row) =>
      row.value ? (
        <DateCell value={row.value} format={DATE_TIME_FORMAT} />
      ) : (
        '-'
      ),
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={ITINERARY_COUNTER_REPORT_STATUS}
        enumValue={row.value}
      />
    ),
  },
  {
    Header: 'Archivo',
    accessor: 'fileUrl',
    className: 'text-center',
    filterable: false,
    Cell: (row) =>
      // eslint-disable-next-line no-nested-ternary
      row.value ? (
        <LinkToModuleResource
          href={row.value}
          text="Descargar"
          colorIcon="text-primary"
          isExternalPath
        />
      ) : row.original.status === 'FAILED' ? (
        <span className="text-danger" title={row.original.errorMessage}>
          Error
        </span>
      ) : (
        '-'
      ),
  },
  {
    Header: 'Notas',
    accessor: 'notes',
    className: 'text-center',
    filterable: false,
    Cell: (row) =>
      row.value ? (
        <span title={row.value}>
          {row.value.length > 40 ? `${row.value.slice(0, 40)}…` : row.value}
        </span>
      ) : (
        '-'
      ),
  },
];

export const PREVENTIVE_TASK_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Acción',
    accessor: 'actionType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={ACTIVITY_ACTION} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={ACTIVITY_ACTION}
      />
    ),
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter onChangeFilter={row.onChange} options={ACTIVE_OPTIONS} />
    ),
  },
  {
    Header: 'Prioridad',
    accessor: 'priority',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={MAINTENANCE_SERVICE_ORDER_PRIORITY}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={MAINTENANCE_SERVICE_ORDER_PRIORITY}
      />
    ),
  },
  {
    Header: 'Notificación Programada',
    accessor: 'deviation',
    className: 'text-center',
    Cell: (row) =>
      row.value !== null && row.value !== undefined
        ? `${row.value} día(s)`
        : '-',
  },
  {
    Header: 'Frecuencia',
    accessor: 'repeatType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={PREVENTIVE_TASK_REPEAT_TYPE}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PREVENTIVE_TASK_REPEAT_TYPE}
      />
    ),
  },
];

export const PREVENTIVE_TASK_RESOURCE_COLUMNS = [
  {
    Header: 'Recurso de la Compañia',
    accessor: 'companyResource.name',
    className: 'text-center',
  },
  {
    Header: 'Grupo de Recursos',
    accessor: 'companyResourceGroup.name',
    className: 'text-center',
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter onChangeFilter={row.onChange} options={ACTIVE_OPTIONS} />
    ),
  },
];

export const PREVENTIVE_TASK_ASSIGNEE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Código Tarea',
    accessor: 'preventiveTask.companyPreventiveTaskId',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Tarea Programada',
    accessor: 'preventiveTask.name',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Tipo de Acción',
    accessor: 'preventiveTask.actionType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={ACTIVITY_ACTION} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={ACTIVITY_ACTION}
      />
    ),
  },
  {
    Header: 'Prioridad',
    accessor: 'preventiveTask.priority',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={MAINTENANCE_SERVICE_ORDER_PRIORITY}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={MAINTENANCE_SERVICE_ORDER_PRIORITY}
      />
    ),
  },
  {
    Header: 'Frecuencia',
    accessor: 'preventiveTask.repeatType',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={PREVENTIVE_TASK_REPEAT_TYPE}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PREVENTIVE_TASK_REPEAT_TYPE}
      />
    ),
  },
  {
    Header: 'Asignado a',
    accessor: 'assignmentScope',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={PREVENTIVE_TASK_ASSIGNEE_SCOPE}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PREVENTIVE_TASK_ASSIGNEE_SCOPE}
      />
    ),
  },
  {
    Header: 'Departamento',
    accessor: 'departamentName',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Área',
    accessor: 'areaName',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Cargo / Rol',
    accessor: 'positionName',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Usuario',
    accessor: 'user.fullName',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Estado',
    accessor: 'active',
    className: 'text-center',
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter onChangeFilter={row.onChange} options={ACTIVE_OPTIONS} />
    ),
  },
];

export const PREVENTIVE_TASK_EXECUTION_RESOURCE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Recurso',
    accessor: 'companyResource.name',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Fecha Inicio',
    accessor: 'startedDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
  },
  {
    Header: 'Fecha Culminación',
    accessor: 'completedDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={PREVENTIVE_TASK_EXECUTION_STATUS}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PREVENTIVE_TASK_EXECUTION_STATUS}
      />
    ),
  },
  {
    Header: 'Comentario',
    accessor: 'comment',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
];

export const PREVENTIVE_TASK_EXECUTION_COLUMNS = [
  {
    Header: 'Codigo Tarea',
    accessor: 'preventiveTaskId',
    className: 'text-center',
  },
  {
    Header: 'Tarea',
    accessor: 'preventiveTaskName',
    className: 'text-center',
  },
  {
    Header: 'Recurso Asignado',
    accessor: 'resourceName',
    className: 'text-center',
  },
  {
    Header: 'Fecha Programada',
    accessor: 'scheduleDate',
    className: 'text-center',

    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
  },
  {
    Header: 'Fecha Inicio',
    accessor: 'startedDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
  },
  {
    Header: 'Fecha Fin',
    accessor: 'completedDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus
        enumObject={PREVENTIVE_TASK_EXECUTION_STATUS}
        enumValue={row.value}
      />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={PREVENTIVE_TASK_EXECUTION_STATUS}
      />
    ),
  },
  {
    Header: 'Modo',
    className: 'text-center',
    accessor: 'resourceExecutionMode',
    Cell: (row) => (
      <EnumStatus enumObject={RESOURCE_EXECUTION_MODE} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={RESOURCE_EXECUTION_MODE}
      />
    ),
  },
  {
    Header: 'Ejecutor',
    accessor: 'executorName',
    id: 'executorUserId',
    className: 'text-center',
  },
  {
    Header: 'Comentario',
    accessor: 'comment',
    className: 'text-center',
    Cell: ({ value }) => value || '-',
  },

  {
    Header: 'Acción',
    className: 'text-center',
    accessor: 'executionId',
    Cell: (row) => (
      <i
        tabIndex={0}
        role="button"
        className="fa fa-search	text-info"
        style={{ cursor: 'pointer' }}
        onClick={(event) => {
          event.stopPropagation();
          window.open(
            `${PREVENTIVE_TASK_EXECUTION_PATH}/${row.value}`,
            '_blank',
          );
        }}
        onKeyPress={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.stopPropagation();
            window.open(
              `${PREVENTIVE_TASK_EXECUTION_PATH}/${row.value}`,
              '_blank',
            );
          }
        }}
      />
    ),
  },
];

export const MAINTENANCE_FAIL_MODE_COLUMNS = [
  {
    Header: 'Código',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
  },
  {
    Header: 'Categoría',
    accessor: 'category',
    Cell: (row) => (row.value ? row.value.name : '-'),
    className: 'text-center',
  },
  {
    Header: 'Sub Categoría',
    accessor: 'subCategory',
    id: 'subCategory.name',

    Cell: (row) => (row.value ? row.value.name : '-'),
    className: 'text-center',
  },
  {
    Header: 'Código Actividad',
    accessor: 'activity',

    id: 'activity.companyActivityId',

    Cell: (row) =>
      row.value && row.value.companyActivityId
        ? row.value.companyActivityId
        : '-',
    className: 'text-center',
    width: 130,
  },
  {
    Header: 'Actividad',
    accessor: 'activity',
    id: 'activity.name',

    Cell: (row) => (row.value ? row.value.name : '-'),
    className: 'text-center',
  },
  {
    Header: 'Prioridad',
    accessor: 'priority',
    Cell: (row) =>
      row.value && MAINTENANCE_WARNING_PRIORITY[row.value]
        ? MAINTENANCE_WARNING_PRIORITY[row.value].label
        : '-',
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(MAINTENANCE_WARNING_PRIORITY)}
      />
    ),
    className: 'text-center',
  },
];

export const MAINTENANCE_FAIL_MODE_CATEGORY_COLUMNS = [
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
];

export const MAINTENANCE_FAIL_MODE_ACTIVITY_COLUMNS = [
  {
    Header: 'Código de la Actividad',
    accessor: 'companyActivityId',
    className: 'text-center',
  },
  {
    Header: 'Nombre de la Actividad',
    accessor: 'activityName',
    className: 'text-center',
  },
];

export const MAINTENANCE_CHECKLIST_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Orden de Servicio',
    accessor: 'serviceOrderId',
    className: 'text-center',
  },
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    Cell: (row) =>
      row.original.registeredBus
        ? row.original.registeredBus.companyBusId
        : '-',
    className: 'text-center',
  },
  {
    Header: 'Fecha Límite',
    accessor: 'deadLine',
    Cell: (row) =>
      row.value
        ? tzNormalizeDate({
            date: row.value,
            format: DATE_FORMAT,
          })
        : '-',
    className: 'text-center',
  },
  {
    Header: 'Conductor',
    accessor: 'driver.driverName',
    Cell: (row) => (row.original.driver ? row.original.driver.driverName : '-'),
    className: 'text-center',
  },
  {
    Header: 'Documento',
    accessor: 'driver.driverIdDocumentNumber',
    Cell: (row) =>
      row.original.driver ? row.original.driver.driverIdDocumentNumber : '-',
    className: 'text-center',
  },
  {
    Header: 'Actividades',
    accessor: 'maintenanceChecklistActivityList',
    Cell: (row) => (row.value && row.value.length > 0 ? row.value.length : 0),
    className: 'text-center',
    filterable: false,
  },
];

export const TOLL_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'location.name',
    className: 'text-center',
  },
  {
    Header: 'RUC',
    accessor: 'business.businessTaxId',
    className: 'text-center',
  },
  {
    Header: 'Razón Social',
    accessor: 'business.name',
    className: 'text-center',
  },
  {
    Header: 'Precio Por Eje',
    accessor: 'pricePerAxle',
    Cell: (row) => numberFormatter({ value: row.value }),
    filterable: false,
    className: 'text-center',
  },
  {
    Header: 'Impuesto Por eje',
    accessor: 'taxPrePaymentPerAxle',
    Cell: (row) => numberFormatter({ value: row.value }),
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Extraordinario',
    accessor: 'isExtraordinary',
    Cell: ({ value }) => (value ? 'Sí' : 'No'),
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Electronico',
    accessor: 'electronic',
    Cell: ({ value }) => (value ? 'Sí' : 'No'),
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Provia',
    accessor: 'provia',
    Cell: ({ value }) => (value ? 'Sí' : 'No'),
    className: 'text-center',
    filterable: false,
  },
];

export const TOLL_EXTRAORDINARY_ASSIGNMENT_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Tipo de Servicio',
    id: 'serviceTypeId',
    accessor: 'serviceType',
    Cell: ({ value }) => (value && value.name ? value.name : '-'),
    Filter: (row) => (
      <ServiceTypeFilter onChangeFilter={row.onChange} isClearable />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    filterable: true,
    sortable: false,
  },
  {
    Header: 'Ruta',
    id: 'routeId',
    accessor: 'routeName',
    Filter: (row) => <RouteSelect onChangeFilter={row.onChange} useForFilter />,
    dataType: ColumnFilterDataTypes.ARRAY,
    className: 'text-center',
    filterable: true,
    sortable: false,
    Cell: (row) => `${row.original.routeId} - ${row.value}`,
  },
  {
    Header: 'Fecha Inicial',
    accessor: 'startDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    sortable: false,
  },
  {
    Header: 'Fecha Final',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    sortable: false,
  },
  {
    Header: 'Peajes Extraordinarios',
    accessor: 'tolls',
    Cell: ({ value }) =>
      value && value.length ? value.map(({ name }) => name).join(', ') : '-',
    className: 'text-center',
    filterable: false,
    sortable: false,
  },
  {
    Header: 'Creado Por',
    accessor: 'userFullName',
    className: 'text-center',
    filterable: false,
    sortable: false,
  },
  {
    Header: 'Fecha de Registro',
    accessor: 'createDate',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
    sortable: false,
  },
];

export const TOLL_EXTRAORDINARY_ASSIGNMENT_BY_ITINERARY_COLUMNS = [
  {
    Header: 'Peaje',
    accessor: 'tollName',
    className: 'text-center',
  },
  {
    Header: 'Fecha Inicial',
    accessor: 'startDate',
    Cell: (row) => <DateCell value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Fecha Final',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} />,
    className: 'text-center',
  },
];

export const TOLL_LIQUIDATION_ADDITIONAL_CHARGE_COLUMNS = [
  {
    Header: 'Tipo',
    accessor: 'chargeType',
    Cell: ({ value }) => {
      switch (value) {
        case 'FUNDITION_ENTRY':
          return 'Ingreso a fundición';

        default:
          return value || '-';
      }
    },
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: ({ value }) => numberFormatter({ value }),
    className: 'text-center',
  },
  {
    Header: 'Aplicado',
    accessor: 'applied',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => <Checkbox checked={!!value} />,
    className: 'text-center',
    filterable: false,
  },
];

export const generateExpenseSapMigrationColumns = ({
  handleEdit,
  handleView,
}) => [
  {
    Header: 'Acción',
    className: 'text-center',
    accessor: 'id',
    Cell: (cell) => {
      const { original, index } = cell;

      const isEditable =
        !original.migrationStatus ||
        original.migrationStatus === 'PENDING' ||
        original.migrationStatus === 'EDITED' ||
        original.migrationStatus === 'ERROR';

      return (
        <div className="d-flex justify-content-center align-items-center">
          <ViewExpenseSapMigrationButton
            handleView={handleView}
            expenseSapMigration={original}
            index={index}
          />
          {isEditable && (
            <EditExpenseSapMigrationButton
              handleEdit={handleEdit}
              expenseSapMigration={original}
              index={index}
            />
          )}
        </div>
      );
    },
    filterable: false,
    sortable: false,
    width: 150,
  },
  {
    Header: 'Estado',
    id: 'migrationStatus',
    accessor: 'migrationStatus',
    Cell: (row) => (
      <EnumStatus enumObject={MIGRATION_STATUS} enumValue={row.value} />
    ),
    Filter: (row) => (
      <EnumSelectFilter
        onChangeFilter={row.onChange}
        enumOptions={MIGRATION_STATUS}
      />
    ),
    className: 'text-center',
    sortable: false,
    closeMenuOnSelect: false,
  },
  {
    Header: 'Nombre Agencia',
    id: 'agency.id',
    accessor: 'agency.name',
    Filter: (row) => (
      <AgencyFilter onChangeFilter={row.onChange} visibilityRestricted />
    ),
    dataType: ColumnFilterDataTypes.ARRAY,
    width: 150,
  },
  {
    Header: 'Fecha de Emisión',
    accessor: 'issueDate',
    Cell: (row) => <DateCell value={row.value} />,
    sortable: false,
    filterQuery: (value) => `issueDate>${value},issueDate<${value}`,
  },
  {
    Header: 'Tipo Egreso',
    accessor: 'expenseTypeName',
    sortable: false,
    width: 150,
  },
  {
    Header: 'Descripción',
    id: 'description',
    accessor: 'description',
    sortable: false,
  },
  {
    Header: 'RUC Proveedor',
    accessor: 'businessTaxId',
  },
  {
    Header: 'Nombre Proveedor',
    accessor: 'businessName',
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
  },
  {
    Header: 'Tax Code',
    id: 'taxCode',
    accessor: () => 'EXO',
    filterable: false,
    sortable: false,
    width: 60,
  },
  {
    Header: 'Importe Total',
    accessor: 'totalAmount',
    Cell: (row) => numberFormatter({ value: row.value }),
    sortable: false,
  },
  {
    Header: 'Cód. Tipo Comprobante',
    id: 'voucherType.voucherCode',
    accessor: 'voucherType.voucherCode',
    sortable: false,
    width: 60,
  },
  {
    Header: 'Tipo Comprobante',
    id: 'voucherType.name',
    accessor: 'voucherType.name',
    sortable: false,
  },
  {
    Header: 'N° Centro Costo',
    id: 'costCenter.costCenterCode',
    accessor: 'costCenter.costCenterCode',
    width: 60,
  },
  {
    Header: 'Centro Costo',
    id: 'costCenter.name',
    accessor: 'costCenter.name',
    width: 150,
  },
  {
    Header: 'Número Cta',
    accessor: 'accountCode',
    sortable: false,
    width: 150,
  },
  {
    Header: 'Nombre Cta',
    accessor: 'accountName',
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    sortable: false,
  },
  {
    Header: 'Conductores',
    accessor: 'driversInfo',
    sortable: false,
    width: 150,
  },
];

export const CABIN_CREWS_MOVEMENT_HISTORY_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Servicio a Bordo',
    id: 'cabinCrew.id',
    accessor: 'cabinCrew.customer.fullName',
    className: 'text-center',
    Filter: (row) => (
      <CabinCrewFilter isClearable onChangeFilter={row.onChange} />
    ),
  },
  {
    Header: 'Número de Documento',
    accessor: 'cabinCrew.customer.idDocumentNumber',
    className: 'text-center',
  },
  {
    Header: 'Motivo',
    id: 'cabinCrewMovement.id',
    accessor: 'cabinCrewMovement.name',
    className: 'text-center',
    Filter: (row) => (
      <DriverMovementFilter isClearable onChangeFilter={row.onChange} />
    ),
  },
  {
    Header: 'Fecha de Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
  },
  {
    Header: 'Mes Asignado',
    accessor: 'chargeMonth',
    className: 'text-center',
    Cell: (row) => {
      const {
        original: { chargeMonth, chargeYear },
      } = row;
      if (!chargeMonth || !chargeYear) return '-';
      const month = MONTH_OPTIONS.find((m) => m.value === chargeMonth);
      return `${month ? month.label : chargeMonth} / ${chargeYear}`;
    },
    filterable: false,
  },
  {
    Header: 'Fecha de Creación',
    accessor: 'createDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
    dataType: ColumnFilterDataTypes.DATE,
  },
];

export const CABIN_CREW_MOVEMENT_HISTORY_COLUMNS = [
  {
    Header: 'id',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
  {
    Header: 'Motivo',
    accessor: 'cabinCrewMovementName',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Inicio',
    accessor: 'startDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Fecha de Fin',
    accessor: 'endDate',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT} />,
    className: 'text-center',
  },
  {
    Header: 'Días Faltantes',
    accessor: 'startDate',
    Cell: (row) => {
      const startDate = new Date(row.value);
      const endDate = new Date();
      if (startDate < endDate) {
        return 0;
      }
      const diffTime = Math.abs(startDate - endDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    className: 'text-center',
  },
  {
    Header: 'Observación 1',
    accessor: 'note',
    className: 'text-center',
  },
  {
    Header: 'Observación 2',
    accessor: 'secondaryNote',
    className: 'text-center',
  },
];

export const CABIN_CREW_BUS_ASSIGNMENT_COLUMNS = [
  {
    Header: 'Bus',
    accessor: 'registeredBus.companyBusId',
    id: 'companyBusId',
    className: 'text-center',
  },
  {
    Header: 'Servicio a Bordo',
    accessor: 'cabinCrewAssignmentDateList[0].cabinCrew.customer.fullName',
    id: 'fullName',
    className: 'text-center',
  },
  {
    Header: 'DNI',
    accessor:
      'cabinCrewAssignmentDateList[0].cabinCrew.customer.idDocumentNumber',
    id: 'idDocumentNumber',
    className: 'text-center',
  },
];

export const CABIN_CREW_FOR_SCHEDULING_COLUMNS = [
  {
    id: 'departureDate',
    Header: 'Fecha',
    accessor: 'departureDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
    width: 150,
    filtered: false,
  },
  {
    Header: 'Origen',
    accessor: 'sourceLocationName',
    className: 'text-center',
    width: 250,
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocationName',
    className: 'text-center',
    width: 250,
  },
  {
    id: 'departureTime',
    Header: 'Hora',
    accessor: (d) => d.departureDate,
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={TIME_FORMAT} />,
    width: 100,
    filtered: false,
  },
  {
    Header: 'Tipo de Servicio',
    accessor: 'serviceTypeName',
    className: 'text-center',
    width: 200,
  },
  {
    Header: 'Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    width: 150,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Base del Bus',
    accessor: 'registeredBusHomeBaseName',
    className: 'text-center',
    width: 200,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Tripulante',
    accessor: 'cabinCrewName',
    className: 'text-center',
    width: 500,
    Cell: (row) => row.value || '-',
  },
  {
    Header: 'Itinerario ID',
    accessor: 'itineraryId',
    className: 'text-center',
    Cell: (row) => (
      <LinkToModuleResource
        href={`${ITINERARY_FOR_COUNTER_PATH}/${row.value}`}
        text={row.value}
        isExternalPath
      />
    ),
    width: 150,
  },
  {
    Header: 'Estado',
    accessor: 'itineraryActive',
    className: 'text-center',
    width: 150,
    Cell: (row) => <IsActive value={row.value} />,
    Filter: (row) => (
      <SelectFilter onChangeFilter={row.onChange} options={ACTIVE_OPTIONS} />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];

      if (filterValue === undefined || filterValue === null) {
        return true;
      }

      if (Array.isArray(filterValue)) {
        if (filterValue.length === 0) {
          return true;
        }
        return filterValue.includes(rowValue);
      }

      return filterValue === rowValue;
    },
  },
  {
    Header: 'Dirección',
    accessor: 'itineraryDirection',
    className: 'text-center',
    Cell: (row) => (
      <EnumStatus enumObject={ITINERARY_DIRECTION} enumValue={row.value} />
    ),
    width: 250,
    Filter: (row) => (
      <SelectFilter
        onChangeFilter={row.onChange}
        options={enumToSelectOptions(ITINERARY_DIRECTION)}
      />
    ),
    filterMethod: (filter, row) => {
      const filterValue = filter.value;
      const rowValue = row[filter.id];
      if (!filterValue || filterValue.length === 0) {
        return true;
      }
      return filterValue.includes(rowValue);
    },
  },
  {
    Header: 'Ruta',
    accessor: 'routeName',
    className: 'text-center',
    width: 400,
  },
];

export const HOLIDAY_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'holidayDate',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_FORMAT} />,
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Descripción',
    accessor: 'description',
    className: 'text-center',
    Cell: (row) => row.value || '-',
  },
];

export const TASK_SUMMARY_MOVEMENT_COLUMNS = [
  {
    Header: 'Movimiento',
    accessor: 'name',
    className: 'text-left',
  },
  {
    Header: 'Total',
    accessor: 'total',
    className: 'text-center',
    width: 100,
  },
];

export const DRIVER_TASK_SUMMARY_MONTHLY_COLUMNS = [
  {
    Header: 'Nº DNI',
    accessor: 'documentNumber',
    className: 'text-center',
    width: 110,
  },
  {
    Header: 'Apellidos y Nombres',
    accessor: 'fullName',
    className: 'text-left',
    width: 260,
  },
  {
    Header: 'Fecha Ingreso',
    accessor: 'admissionDate',
    className: 'text-center',
    width: 120,
    Cell: (row) =>
      row.value ? <DateCell value={row.value} format={DATE_FORMAT} /> : '-',
    filterMethod: (filter, row) =>
      filterMethodCaseInsensitive(filter, {
        [filter.id]: row[filter.id]
          ? tzNormalizeDate({ date: row[filter.id], format: DATE_FORMAT })
          : null,
      }),
  },
  {
    Header: 'Vacaciones Generados',
    accessor: 'generatedVacationDays',
    className: 'text-center',
    width: 110,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Días con Actividad',
    accessor: 'totalDaysActivity',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Total Días',
    accessor: 'totalDays',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Descanso Físico Generados',
    accessor: 'generatedPhysicalRest',
    className: 'text-center',
    width: 120,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Descanso Físico Gozado',
    accessor: 'takenPhysicalRest',
    className: 'text-center',
    width: 120,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Descanso a pagar',
    accessor: 'physicalRestBalance',
    className: 'text-center',
    width: 120,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Feriados',
    accessor: 'holidays',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Tránsito',
    accessor: 'transit',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Permiso',
    accessor: 'permission',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Retén',
    accessor: 'retention',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Reserva',
    accessor: 'reserve',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Dsos. Médicos',
    accessor: 'medicalRest',
    className: 'text-center',
    width: 110,
    filterMethod: filterMethodExactValue
  },
  {
    id: 'vacations',
    Header: 'Vacaciones',
    accessor: (row) => (row.vacations || 0) + (row.paidVacations || 0),
    className: 'text-center',
    width: 100,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Suspensión',
    accessor: 'suspension',
    className: 'text-center',
    width: 100,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Inasistencia',
    accessor: 'absence',
    className: 'text-center',
    width: 100,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Lic. S/G',
    accessor: 'unpaidLicense',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
];

export const CABIN_CREW_TASK_SUMMARY_MONTHLY_COLUMNS = [
  {
    Header: 'Nº DNI',
    accessor: 'documentNumber',
    className: 'text-center',
    width: 110,
  },
  {
    Header: 'Apellidos y Nombres',
    accessor: 'fullName',
    className: 'text-left',
    width: 260,
  },
  {
    Header: 'Fecha Ingreso',
    accessor: 'admissionDate',
    className: 'text-center',
    width: 120,
    Cell: (row) =>
      row.value ? <DateCell value={row.value} format={DATE_FORMAT} /> : '-',
    filterMethod: (filter, row) =>
      filterMethodCaseInsensitive(filter, {
        [filter.id]: row[filter.id]
          ? tzNormalizeDate({ date: row[filter.id], format: DATE_FORMAT })
          : null,
      }),
  },
  {
    Header: 'Vacaciones Generados',
    accessor: 'generatedVacationDays',
    className: 'text-center',
    width: 110,
  },
  {
    Header: 'Días con Actividad',
    accessor: 'totalDaysActivity',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Total Días',
    accessor: 'totalDays',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Descanso Físico Generados',
    accessor: 'generatedPhysicalRest',
    className: 'text-center',
    width: 120,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Descanso Físico Gozado',
    accessor: 'takenPhysicalRest',
    className: 'text-center',
    width: 120,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Descanso a pagar',
    accessor: 'physicalRestBalance',
    className: 'text-center',
    width: 120,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Feriados',
    accessor: 'holidays',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Tránsito',
    accessor: 'transit',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Permiso',
    accessor: 'permission',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Retén',
    accessor: 'retention',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Reserva',
    accessor: 'reserve',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Dsos. Médicos',
    accessor: 'medicalRest',
    className: 'text-center',
    width: 110,
    filterMethod: filterMethodExactValue
  },
  {
    id: 'vacations',
    Header: 'Vacaciones',
    accessor: (row) => (row.vacations || 0) + (row.paidVacations || 0),
    className: 'text-center',
    width: 100,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Suspensión',
    accessor: 'suspension',
    className: 'text-center',
    width: 100,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Inasistencia',
    accessor: 'absence',
    className: 'text-center',
    width: 100,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Lic. S/G',
    accessor: 'unpaidLicense',
    className: 'text-center',
    width: 90,
    filterMethod: filterMethodExactValue
  },
];

export const ITINERARY_BOARDING_REPORT_COLUMNS = [
  {
    Header: 'Fecha de salida',
    accessor: 'departureTime',
    className: 'text-center',
    Cell: (row) => <DateCell value={row.value} format={DATE_TIME_FORMAT}/>,
    filterMethod: (filter, row) =>
      filterMethodCaseInsensitive(filter, {
        [filter.id]: row[filter.id]
          ? tzNormalizeDate({ date: row[filter.id], format: DATE_TIME_FORMAT })
          : null,
      }),
  },
  {
    Header: 'Itinerario',
    accessor: 'itineraryId',
    className: 'text-center',
  },
  {
    Header: 'Origen',
    accessor: 'originLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Destino',
    accessor: 'destinationLocation.name',
    className: 'text-center',
  },
  {
    Header: 'Agencia Embarque',
    accessor: 'boardingAgency.name',
    className: 'text-center'
  },
  {
    Header: 'N° Bus',
    accessor: 'companyBusId',
    className: 'text-center',
    Cell: ({ value }) => value || '-',
    width: 80,
  },
  {
    Header: 'N° Embarcados',
    accessor: 'boardedPassengers',
    className: 'text-center',
    width: 80,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'N° No embarcados',
    accessor: 'notBoardedPassengers',
    className: 'text-center',
    width: 80,
    filterMethod: filterMethodExactValue
  },
  {
    Header: 'Ruta',
    accessor: 'routeName',
    minWidth: 300,
    maxWidth: 450,
  },
  {
    Header: 'Embarcó en otra agencia',
    accessor: 'boardedAtOtherLocation',
    className: 'text-center',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value, original }) =>
      value ? (
        <Badge
          color="warning"
          className="badge badge-warning"
          // eslint-disable-next-line react/prop-types
          text={`Sí (${original.boardedAtOtherLocationCount})`}
        />
      ) : (
        <Badge color="darkGray" className="badge badge-secondary" text="No" />
      ),
    Filter: (row) => (
    <SelectFilter
      onChangeFilter={row.onChange}
      options={BOARDED_AT_OTHER_LOCATION_OPTIONS}
    />
  ),
  },
];

export const TICKET_CORPORATE_CREDIT_COLUMNS = [
  {
    Header: 'Código',
    accessor: 'id',
    className: 'text-center',
  },
  {
    Header: 'Nombre',
    accessor: 'name',
    className: 'text-center',
  },
  {
    Header: 'Empresa',
    accessor: 'company.name',
    className: 'text-center',
  },
  {
    Header: 'Crédito Inicial',
    accessor: 'agency.initialBalance',
    className: 'text-center',
  },
  {
    Header: 'Crédito Actual',
    accessor: 'agency.actualBalance',
    className: 'text-center',
  },
];

export const generateManualVoucherPaymentColumns = (tableFilters) => [
  {
    Header: 'N° de Documento',
    accessor: 'business.businessTaxId',
    Cell: (row) => {
      const {
        original: { customer, business },
      } = row;

      if (customer) {
        return `${customer.identificationType.name}: ${customer.idDocumentNumber}`;
      }

      if (business) {
        return `RUC: ${business.businessTaxId}`;
      }

      return '-';
    },
    className: 'text-center',
  },
  {
    Header: 'Razón Social/Nombre',
    accessor: 'business.name',
    Cell: (row) => {
      const {
        original: { customer, business },
      } = row;

      if (customer) {
        return customer.fullName;
      }

      if (business) {
        return business.name;
      }

      return '-';
    },
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Banco',
    accessor: 'bankAccount.bank.name',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'Cuenta Bancaria',
    accessor: 'bankAccount.accountNumber',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'Serie',
    accessor: 'documentSeries',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'Correlativo',
    accessor: 'documentCode',
    Cell: (row) => (row.value ? padStart(row.value, 7) : '-'),
    className: 'text-center',
  },
  {
    Header: 'N° Operación',
    accessor: 'operationNumber',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.bankAccount
          ? row.original.bankAccount.currency
          : undefined,
        value: row.value,
      }),
    className: 'text-right',
  },
  {
    Header: 'Fecha de Depósito',
    accessor: 'depositDate',
    Cell: (row) => <DateCell value={row.value} />,
    dataType: ColumnFilterDataTypes.DATE,
    className: 'text-center',
  },
  {
    Header: 'Aprobado',
    accessor: 'approved',
    Cell: (row) => <input type="checkbox" checked={row.value} readOnly />,
    className: 'text-center',
    filterable: false,
  },
  {
    Header: 'Acción',
    className: 'text-center',
    Cell: (row) => (
      <ManualVoucherPaymentActionsCell
        id={row.original.id}
        approved={row.original.approved}
        tableFilters={tableFilters}
      />
    ),
    filterable: false,
    notNavigateToModel: true,
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
  },
];

export const MANUAL_VOUCHER_RECONCILIATION_PAYMENT_COLUMNS = [
  {
    Header: 'Banco',
    accessor: 'bankAccount.bank.name',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'Cuenta Bancaria',
    accessor: 'bankAccount.accountNumber',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'N° Operación',
    accessor: 'operationNumber',
    Cell: (row) => row.value || '-',
    className: 'text-center',
  },
  {
    Header: 'Fecha de Depósito',
    accessor: 'depositDate',
    Cell: (row) => <DateCell value={row.value} />,
    className: 'text-center',
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    Cell: (row) =>
      numberFormatter({
        currency: row.original.bankAccount
          ? row.original.bankAccount.currency
          : undefined,
        value: row.value,
      }),
    className: 'text-center',
  },
  {
    Header: 'ID',
    accessor: 'id',
    className: 'text-center',
    width: 100,
  },
];
